import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {      
      "ProductPageTitle": "Upreality - The social landing page of your restaurant!",      
      "ProductPageAdTitle": "Upreality - The social network landing page 🍹",
      "Yes": "Yes",
      "No": "No",
      "Infos": "Infos",
      "OpeningStatus":"Open · Closes",
      "ClosedStatus": "Close · Opens",
      "MoreInfos": "More infos",
      "CGoogle": "data ©Google",
      "GO": "GO",
      "BOOK": "BOOK",
      "SAVE": "SAVE",
      "ShareTitle": "Want to go out to a restaurant?",
      "ShareText": "The link to {{name}}'s social website: ",
      "ShareTextDefaultName": "\"Restaurant not yet chosen\"",
      "BookTable": "Book a table",
      "Contact": "Contact us",
      "BookTableInfo": "or contact us!",
      "BookTableInfoEmoji": "📅",
      "ContactInfoEmoji": "💬",
      "OrderInfoEmoji": "🛵",
      "ShareEmoji": "👋",
      "Apply": "Join the adventure",
      "ApplyEmoji": "🚀",
      "BookOnline": "online",
      "BookPhone": "by phone",
      "BookEmail": "by email",
      "BookChat": "by chat",
      "BookEmailSubject": "Booking",
      "ShareEmail": "by email",
      "ShareFacebook": "with Facebook",
      "ShareCopy": "copy in the clipboard",
      "ShareOther": "other ways",
      "OrderOn": "Order",
      "ContactBy": "Contact us",    
      "OrderMeal": "Order",
      "VirtualTourTitle": "atmosphere",
      "MediasGalleryTitle": "menu",
      "MenusTitle": "menus",
      "DishesGalleryTitle": "dishes",
      "PromotionTitle": "new year's eve",
      "TouchToPlay": "Touch to play!",
      "BookButton": "book",
      "ContactButton": "contact",
      "OrderButton": "order",
      "ApplyButton": "apply",
      "ShareButton": "share",
      "ChatButton": "ai chat",
      "NearButton": "near",
      "PromoButton": "promo",
      "NearbyAttractions": "Nearby Attractions",
      "InfluencerButton": "liked",
      "ShareShareButton": "share",
      "ShareDialogTitle": "Share to a friend",
      "Free": "free",
      "Hours": "Hours",    
      "HoursSubtitle": "7 next days",
      "HoursInfoExtended": "extended hours on some restaurants",
      "Scroll": "Scroll",
      "HAPPY_HOUR": "Happy hours",
      "BREAKFAST": "Breakfast",
      "BRUNCH": "Brunch",
      "LUNCH": "Lunch",
      "DINNER": "Dinner",
      "DRIVE_THROUGH": "Drive through",
      "DELIVERY": "Delivery",
      "TAKEOUT": "Take out",
      "KITCHEN": "Kitchen",
      "PICKUP": "Pick up",
      "SENIOR_HOURS": "Senior hours",
      "Reviews": "review",
      "Location": "Go",
      "OpenOnGoogleMaps": "Open in Google Maps",
      "ChainChangeRestaurant": "Change restaurant",
      "ChainChooseRestaurant": "Choose your restaurant",
      "ChainChooseButton": "Choose",
      "ChainLocationPlaceholder": "Postal code or city",
      "ChainSearchRestaurants": "Search",
      "ChainSearching": "Searching…",
      "ChainNoRestaurantNearby": "No restaurant within 20 km",
      "ChainGeocodeError": "Location not found",
      "ChainGeolocation": "Use my location",
      "ChainGeolocationDenied": "Location access denied",
      "ChainGeolocationUnavailable": "Location unavailable",
      "ChainGeolocationTimeout": "Location request timed out",
      "ChainGeolocationUnsupported": "Geolocation is not supported",
      "ChainGeolocationError": "Unable to get your location",
      "ChainRestaurantDistance": "{{distance}} km",
      "ChainDemoVersionHint": "demo version",
      "Close": "Close",
      "StoryBgDesc": "Decor",
      "RestaurantContent": "Restaurant's media content",
      "TouchToPlay": "Touch to play!",
      "SparklesAlt": "sparkles",
      "StoryOverlayAlt": "video overlay",
      "InstagramAlt": "Instagram",
      "InstagramAvatarAlt": "Instagram avatar",
      "DeadEndAlt": "dead end",
      "HolbertonProgramAlt": "Holberton program",
      "PhoneFrameAlt": "phone frame",
      "FromInstagramProfileAlt": "from Instagram profile",
      "SpacerAlt": "layout spacer",
      "ArrowHintAlt": "direction arrow",
      "BetaRibbonAlt": "beta ribbon",
      "StatsPagePreviewAlt": "stats page preview",
      "StoryMakerPagePreviewAlt": "story maker page preview",
      "WebsitePagePreviewAlt": "website page preview",
      "AppPreviewAlt": "app preview",
      "NearbyAttractionsAlt": "nearby attractions",
      "PromoAlt": "promo",
      "RestaurantAvatarAlt": "restaurant avatar",
      "RestaurantAvatarPlaceholderAlt": "restaurant avatar placeholder",
      "ErrorImageAlt": "the dish is a failure",
      "GoogleAlt": "Google",
      "VideoContentAlt": "video content",
      "MenuFileTypeAlt": "menu file type",
      "CookingWearAlt": "cooking wear",
      "FullScreenPromotionAlt": "full screen promotion",
      "FullScreenContentAlt": "full screen content",
      "FullScreenMenuPageAlt": "full screen menu page",
      "LineSeparatorAlt": "line separator",
      "InstagramPostAlt": "Instagram post",
      "StoryThumbnailAlt": "story thumbnail",
      "EmptyKitchenAlt": "nothing in the kitchen",
      "MenuHeaderStyleAlt": "menu header style",
      "AvatarAlt": "avatar",
      "TestimonialImageAlt": "Testimonial {{num}}",
      "MuteSound": "Mute sound",
      "UnmuteSound": "Unmute sound",
      "Previous": "Previous",
      "Next": "Next",
      "Star": "star",
      "Menu": "Menu",      
      "Click": "click",
      "Here": "here",
      "ToRead": "to read",
      "Menus": "Menus",
      "Starter": "Starters",
      "MainCourse": "Main courses",
      "Dessert": "Desserts",
      "Wine": "Wines",
      "EndingPage": "Note",
      "SignaturesDishes": "Signature dishes",
      "Nutrients": "Nutritional values",
      "Saving": "Saving...",
        "Saved": "Saved at ",
      "ChooseRestaurant": "My restaurant",
      "ChooseRestaurantOr": "OR",
      "Login": "Log me in",
      "CreateAccount": "Create an account",
      "AlreadyRegistered": "Already registered?",      
      "PlaceholderAutocompleaterHelp": "Enter the name of your restaurant to configure your social landing page automatically",
      "MultipleRestaurantsHelp1": "You want a single social landing page for multiple restaurants (e.g. restaurant chain), ",
      "MultipleRestaurantsHelp2": "contact-us at contact@upreality.store !",
      "MultipleRestaurantsMailSubject": "Multi-restaurant social landing page",
      "PlaceholderAutocompleater": "the name of my restaurant",
      "PlaceholderRestaurantType": "my restaurant's type (eg: bistro, etc.)",
      "PlaceholderRestaurantArea": "my neighborhood or my address",      
      "PlaceholderRestaurantName": "my restaurant",
      "PlaceholderPhone": "my phone number",
      "PlaceholderChatMsg": "my welcome message 😊",
      "ChooseRestaurantToStickers": "Stickers > ",
      "MyRestaurant": "My restaurant",
      "MyLogo": "My logo",
      "ChooseMyLogo": "Choose my logo",
      "MyMusic": "My background music",   
              "ChooseMyMusic": "My background music",
        "SyncVideoWithMusic": "Sync video and sound",
        "SyncVideoWithMusicTooltip": "When enabled, music stops when you open a section.",
      "ExtractingMusic" : "extracting",
      "FromInstagram": "from Instagram",
      "Or": "or",
      "FromTheWeb": "from the web",
      "PasteWebLink": "paste here your web link",
      "FromMyComputer": "from my computer",
      "Ok": "Ok",
      "YourColors": "My colors",
      "PrimaryColorBg": "background",
      "PrimaryColorTxt": "text",
      "PreviewButtonLabel": "preview",
      "ThemeToChooseRestaurant": " < 1. Infos",          
      "MyStickers": "My stickers",
      "StickersToRestaurant": " < 1. Setting",
      "StickersToActions": "2. Actions > ",
      "RestaurantStoreFront": "🪟 My setting",
              "ChooseMyStoreFront": "Choose my decor",
        "ChooseMyStoreFrontHelp": "short video or image",
        "ChooseMyStoreFrontRecommendationTitle": "Recommendation:",
        "ChooseMyStoreFrontRecommendationBody": "🎬 Same video as on your Meta Ads campaign\n\nor\n\n✨ Storefront image animated with AI (make seated guests talk, or add wind to plants and the storefront)",
      "AddReviews": "Add my Google reviews ⭐",
      "ChooseMyHours": "Update my hours",
      "ChooseMyHoursDialog": "Update my hours 🕰️",      
      "ChooseMyHoursDialogHelp": "Synchronize with Google Business ⭐",
      "ChooseMyInside": "Choose my ambiance contents",
      "ChooseMyInsideHelp": "short video or image (2 max)",
      "ChooseMyPlates": "Add a content",
      "ChooseMyPlatesHelp": "short video or image (4 max)",
      "ChooseMyPlatesHelp2": "photo or short video",
      "RestaurantInside": "🖼️ My ambiance content",
      "RestaurantInsideMax": "2 contents maximum",
      "PlatesPreview": "Preview of the dishes (+ team)",
      "PlatesPreviewMax": "4 contents maximum",
      "ExternalMenu": "External menu",
      "GalleryMenu": "Gallery",
      "OptimizedMenu": "Embedded menu",      
      "AskForMenu": "Ask my menu",
       "MyActions" : "My actions",
       "BookButtonTitle": "📅 Book / Order / Contact", 
       "SocialWebsiteConfig": "⚙️ My Social Landing Page", 
       "InfluenceAndPromotions": "📣 Influence & promotions", 
       "AddMyMenu" : "🍽️ My menu",
       "AddMyMenuDialog" : "Add my menu 🍽️",
       "AddMyMenuEN" : "Add my menu in english 🍽️",
       "AddMyMenuENDialog" : "Add my menu in english 🍽️",
       "AddSymbolFR": "FR",
       "AddSymbolEN": "EN",
       "AddMyMenuHelp" : "web page, image or PDF",
       "AddMyMenuHelp2" : "The layout of your menu will be ready within 48 hours. In the meantime, it will be available in a simpler form (image or pdf)",
       "AddMyDayMenu" : "Add my daily menu",
       "AddMyDayMenuDialog" : "Add my daily menu 📋",
       "ActionsToStickers": " < 2. Stickers",
       "MenuToUse": "4. Use it > ",
       "UseItToMenu": " < 3. Actions",
        "ConfigureMyPixels": "Configure my pixel" /* "Configure my pixels" */,
        "ConfigureMyPixelsHelp": "All actions are tagged by default",
        "ConfigureMyPixelsDialog": "Configure my pixel ⚙️" /* "Configure my pixels ⚙️" */,
        "ConfigureMyPixelsMetaAbTestWarning": "Prefer the budget strategy at the ad set level (ABO) rather than campaign budget (CBO).<br/>Meta may automatically favor the site with the strongest conversion history and under-deliver a domain that is still rarely used.",
        "ConfigureMyPixelsMetaAbTestTogglePrompt": "⚠️ Start by A/B testing the solution?",
        "ConfigureMyPixelsNoPixelIdea": "If you do not enter a pixel ID, the visitor will not see the cookie/consent popup. You still keep users for retargeting who clicked your ad, and you can find those who actually ordered via the booking widget.",
        "ConfigureMyPixelsNoPixelIdeaTogglePrompt": "💡 Pixel = consent popup, really worth it?",
        "ConfigureInfluencerButtonDialog": "Influencer Review",
        "ConfigureInfluencerButtonHelp": "Configure the influencer button content",
        "ConfigureNearButtonDialog": "Nearby Attractions",
        "ConfigureNearButtonHelp": "Configure nearby attractions content",
        "ConfigurePromoButtonDialog": "Add a promo",
        "ConfigurePromoButtonHelp": "Configure promotion content",
        "EditorAddLink": "Add link",
        "EditorRemoveLink": "Remove link",
        "EditorLinkUrlPrompt": "Enter the URL",
        "EditorTextColor": "Text color",
        "EditorTextColorReset": "Reset color",
        "EditorFontSize": "Font size",
        "EditorFontSizeDefault": "Size",
        "Title": "Title",
        "InfluencerName": "Influencer name",
        "Description": "Description",
        "NearbyAttractions": "Nearby Attractions",
        "SelectImage": "Select Image",
        "ChangeImage": "Change Image",
        "RemoveImage": "Remove Image",
        "SelectImageAbove": "Select image above",
        "ErrorUploadingImage": "Error uploading image",
        "ReformatWithGenAI": "Reformat with GenAI",
        "Reformatting": "Reformatting...",
        "TranslateFromFR": "Translate from FR",
        "TranslateFromEN": "Translate from EN",
        "Translating": "Translating...",
        "NoSourceText": "No text to translate in the source language",
        "TextTooLong": "Text must not exceed 800 characters",
        "FrenchVersion": "French version",
        "EnglishVersion": "English version",
        "TipTapGenAIHint": "Try the GenAI reformat button to create a draft or improve your text ✨",
        "PromoType": "Promo Type",
        "TextPromo": "Text Promo",
        "ImagePromo": "Image Promo",
        "GetTheOffer": "Get the offer",
        "PromoOfferLinkHint": "coupon link (deep link or pdf)",
        "PromoOfferLinkHelp": "Optional.",
        "Meta": "Meta Pixel ID",
        "TikTok": "TikTok",        
        "CycleBudgetVisitsHelper": "Corresponds to {{visits}} visits",          
        "CreateNewSocialWebsiteErrorDialogTitle" : "Create a social landing page",        
        "AcceptSocialWebsiteErrorDialogTitle" : "Accept a transfer",
        "CreateNewSocialWebsiteErrorDialogText": "Your maximum of {{maxStory}} social landing pages has been reached.",        
        "CreateNewSocialWebsiteRestaurantErrorDialogText": "Your maximum of {{maxRestaurant}} restaurants has been reached.",
       "aliasAlreadyExists": "alias already exists",       
       "aliasNotValid": "letters, numbers and -",
       "Congratulation": "Congratulations 🍾",       
        "StoryLink": "My web link",
        "StoryLinkInfo": "or your domain name on request\ne.g.: social.mydomain.com",
        "AppearOnSearchEngines": "Appear on search engines",
        "CopyLink": "Copy the link",
        "PossibleUsages": "Where to use me?",
        "SocialeProfile": "Social profile: as website link",       
        "SocialAds": "Social ad: as action link",        
        "Website": "as QR Code or full-fledged Website",
        "SaveWork": "Without an UpReality account, your social landing page will be deleted after 1 month.",
        "Save": "Create an account",
        "MyStorys": "My Landing Pages",
        "ChooseMyCover": "Add a cover",
        "MenuStyleHelp": "only appears if you add content in \"Preview of the dishes\"",
        "MenuTitleColor": "Color of the title",
        "MenuTitleExample": "Starter",
        "Cancel": "Cancel",
        "Confirm": "Confirm",
        "Elegant": "Elegant",
        "Friendly": "Friendly",
        "Modern": "Modern",
        "Simple": "Simple",
        "Custom": "Custom",
        "OptimMyMenu": "Optimized format for mobile",                
        "InfoOptimMyMenu": "Login to enable the optimized format",     
        "InfoMenuUpdated": "Your menu will be updated as soon as possible, please wait for our feedback to republish your social landing page.",
        "InfoAskForMenuPreparing": "Your menu is being prepared and will be available in a few days. You will be notified by email.",
        "InfoAskForMenuPreparingTrialExtended": "Your menu is being prepared and will be available in a few days. You will be notified by email. Your free trial has been extended by 7 days.",
        "InfoMenuPreviewOptimization": "Menu being optimized...\nThe original link or file will open in a new tab until then.",
        "OptimMyMenuHelp": "menu with less than 50 items",
        "OptimStatus": "requested on {{date}}",
        "OptimMenuVersion": "version from {{date}}",
        "OptimMenuUpdateRequested": "update requested on {{date}}",
        "UpdateMyMenu": "Update",
        "UpdateMyMenuDialog": "Update my menu 🍽️",
        "MenuPreview": "Preview of the style:",
        "DishImages": "Dish images and correspondences",
        "Optional": "(optional)",
        "SendWithWeTransfer": "Send with WeTransfer",
        "LoginForOptimizedFormatp1": "Login",
        "LoginForOptimizedFormatp2": " to gain access to the optimized format",
        "ChooseYourMenuStyle": "Change style",
        "MenuStyle": "Menu style",
        "CoverStyle": "Cover style",
        "ChooseYourMenuColor":  "Personalization color",        
        "ChooseYourMenuCustom": "I want my own style based on my existing menu.",        
        "ChooseYourMenuCustomAlreadyFormated": "My custom menu already laid out.",
        "ChooseStyleValidationHelp1": "Your menu will be laid out within a few days. Try it by clicking on the \"menu\" sticker of your social landing page.",
        "ChooseStyleValidationHelp2": "You can use your social landing page now, the menu will be available in the form of the file or the original page until then.",
        "MyStories": "My Landing Pages",
        "MenuEditor": "Edit a menu",
        "CreateDemo": "Create demo",
        "CreateDemoSubtitle": "Create or edit a demo document in the demos collection (feed or reel).",
        "CreateDemoJsonTitle": "Prefill from JSON",
        "CreateDemoJsonPlaceholder": "{\"pageName\":\"demo-cafe\",\"pageAvatar\":\"https://.../avatar.png\",\"instagramProfile\":\"https://www.instagram.com/demo/\",\"storyId\":\"CafeUpRealityAd\",\"menuId\":\"...\",\"contentFormat\":\"reel\",\"mediaType\":\"video\",\"mediaUrl\":\"https://...\",\"width\":1080,\"height\":1920,\"adText\":\"Ad caption\",\"ctaText\":\"Learn more\",\"ctaLink\":\"/p/CafeUpRealityAd\"}",
        "CreateDemoApplyJson": "Apply JSON",
        "CreateDemoJsonApplied": "Form prefilled from JSON",
        "CreateDemoJsonInvalid": "Invalid JSON",
        "CreateDemoOpenDemoFeed": "Open DemoFeed page",
        "CreateUseCasesOpen": "Create use cases",
        "CreateUseCasesOpenPage": "Open use cases page",
        "CreateUseCasesOpenStorefrontVideo": "Open storefront video (dev)",
        "UseCasesYourCreativeContent": "Your creative content!",
        "CreateUseCasesBack": "← Back to Create demo",
        "CreateUseCasesTitle": "Create use cases",
        "CreateUseCasesSubtitle": "Based on demo “{{pageName}}” (page name, avatar and CTA color).",
        "CreateUseCasesRestaurantName": "Restaurant name",
        "CreateUseCasesRestaurantNameHint": "Shown at the top right of the use cases page. Empty uses the page name.",
        "CreateUseCasesSaveHint": "Saved in Firestore usecases/{demoId}; media copied to Storage demos/ (skipped if already there).",
        "CreateUseCasesReorderHint": "Drag cards or use the arrows to reorder. This order is used on the use cases page after save.",
        "CreateUseCasesReorderDrag": "Drag to reorder",
        "CreateUseCasesMoveUp": "Move up",
        "CreateUseCasesMoveDown": "Move down",
        "CreateUseCasesSave": "Save use cases",
        "CreateUseCasesSaving": "Saving…",
        "CreateUseCasesSaveSuccess": "Use cases saved",
        "CreateUseCasesSaveError": "Could not save use cases",
        "CreateUseCasesLoadError": "Could not load use cases",
        "CreateUseCasesLoading": "Loading use cases…",
        "CreateUseCasesNeedDemo": "Select a demo first",
        "CreateUseCasesNeedPageName": "Page name is required to mirror media to Storage",
        "CreateUseCasesNothingToSave": "Nothing to save — apply a JSON with media first",
        "CreateUseCasesJsonTitle": "Load 4 ads from JSON",
        "CreateUseCasesJsonExpand": "Show JSON field",
        "CreateUseCasesJsonPlaceholder": "{\"generatedAt\":\"…\",\"count\":4,\"ads\":[{\"demoSlot\":\"promo_image\",\"demoLabel\":\"…\",\"mediaUrl\":\"…\",\"mediaType\":\"image\",\"adText\":\"…\",\"ctaText\":\"Learn more\",\"ctaLink\":\"https://…\"}, …]}",
        "CreateUseCasesJsonApplied": "4 use-case slots loaded from JSON",
        "CreateUseCasesJsonNeedAds": "JSON must be an object with an “ads” array (or a raw array of ads)",
        "CreateUseCasesJsonEmpty": "The ads array is empty",
        "CreateUseCasesJsonUnitaryHelp": "Unitary JSON (one ad): paste it above, then use “Reload this use case” on the target slot. Old demos/ media and social-proof avatar are deleted from Storage.",
        "CreateUseCasesJsonUnitaryHint": "This looks like a single ad — use “Reload this use case” on the target slot",
        "CreateUseCasesJsonUnitaryApply": "Reload this use case from JSON",
        "CreateUseCasesJsonUnitaryReloading": "Reloading…",
        "CreateUseCasesJsonUnitaryApplied": "Use case “{{label}}” reloaded (old Storage files removed if any)",
        "CreateUseCasesJsonUnitaryInvalid": "Paste a single-ad JSON (object with mediaUrl / adText)",
        "CreateUseCasesJsonUnitaryNeedMedia": "Unitary JSON must include mediaUrl",
        "CreateUseCasesJsonUnitaryError": "Could not reload this use case",
        "CreateUseCasesSlotFallback": "Use case {{n}}",
        "CreateUseCasesSlotTitle": "Title",
        "CreateUseCasesSlotTitleHint": "Shown as the use case title on the use cases page.",
        "UseCaseSlotRestaurantPresentation": "Wordless video",
        "UseCaseSlotSocialProof": "Influencer collaboration",
        "UseCaseSlotDishMenu": "Promo video",
        "UseCaseSlotPromoOffer": "Promo image",
        "CreateUseCasesAdText": "Ad text",
        "CreateUseCasesSocialAuthorName": "Influencer / author name",
        "CreateUseCasesSocialAuthorNameHint": "Shown in front in the collab (author3). Leave empty to use the page name.",
        "CreateUseCasesSocialAvatarUrl": "Social-proof avatar URL",
        "CreateUseCasesSocialAvatarHint": "Not filled from JSON. Load from Instagram, then mirrored to Storage on save.",
        "CreateUseCasesSocialAvatarIgLoad": "Load avatar from Instagram",
        "CreateUseCasesSocialAvatarIgLoading": "Fetching Instagram avatar…",
        "CreateUseCasesSocialAvatarIgSuccess": "Avatar URL pasted — save use cases to store it on Storage",
        "CreateUseCasesSocialAvatarIgError": "Could not fetch the Instagram avatar",
        "CreateUseCasesSocialAvatarIgNeedProfile": "Enter a valid Instagram profile URL",
        "CreateUseCasesSocialAvatarIgDialogTitle": "Instagram profile to scrape",
        "CreateUseCasesSocialAvatarIgDialogHint": "Paste the profile page URL whose avatar should be used for this social-proof use case.",
        "CreateUseCasesSocialAvatarIgProfileLabel": "Instagram profile URL",
        "CreateUseCasesSocialAvatarIgConfirm": "Load avatar",
        "CreateUseCasesSponsorName": "Sponsor name (collab)",
        "CreateUseCasesSponsorNameHint": "Enables Instagram collab layout: “author et sponsor”. Hint: page name.",
        "CreateUseCasesSponsorAvatarUrl": "Sponsor avatar URL",
        "CreateUseCasesSponsorAvatarHint": "Shown behind the author avatar. Empty → demo page avatar.",
        "CreateUseCasesSponsorUsePageAvatar": "Use page avatar",
        "CreateUseCasesInfluencerGenerate": "Video transcript",
        "CreateUseCasesInfluencerGenerating": "Transcribing video…",
        "CreateUseCasesInfluencerNeedVideo": "A video URL is required for this use case",
        "CreateUseCasesInfluencerSuccess": "Transcript ready — save use cases to keep it",
        "CreateUseCasesInfluencerError": "Could not transcribe the video",
        "CreateUseCasesInfluencerTranscript": "Influencer transcript",
        "CreateUseCasesInfluencerTranscriptHint": "Saved with the use cases. Not written to the story and not sent to reformatWithGenAI.",
        "CreateUseCasesStoryLabel": "Story (right frame on use-cases page)",
        "CreateUseCasesStoryPlay": "Open story in a new tab",
        "CreateUseCasesStoryMain": "Main story",
        "CreateUseCasesStoryAlt": "Alternative {{n}} ({{storyId}})",
        "CreateUseCasesStoryAltNamed": "Alternative {{n}} — {{alias}} ({{storyId}})",
        "CreateUseCasesCtaDestHint": "Simulator CTA is not clickable (ctaDest=aucun). The CTA link field is kept for later save.",
        "CreateDemoSelectLabel": "Existing demo",
        "CreateDemoSelectExisting": "Choose a demo",
        "CreateDemoNewOption": "New demo",
        "CreateDemoLoading": "Loading demos…",
        "CreateDemoLoadError": "Could not load demos",
        "CreateDemoEditingHint": "Editing “{{pageName}}”. Save will update this document.",
        "CreateDemoCreatingHint": "Creating a new demo. Save will add a new document.",
        "CreateDemoPageName": "Page name",
        "CreateDemoPageAvatar": "Page avatar URL",
        "CreateDemoInstagramProfileSection": "Instagram profile",
        "CreateDemoPlayerSection": "Player UpReality",
        "CreateDemoSocialAdSection": "Social Ad",
        "CreateDemoInstagramProfile": "Instagram profile URL",
        "CreateDemoFromInstagram": "From Instagram",
        "CreateDemoFindInstagram": "Search the Instagram profile on the restaurant website",
        "CreateDemoFindInstagramSuccess": "Instagram profile added",
        "CreateDemoFindInstagramError": "Could not search the Instagram profile",
        "CreateDemoFindInstagramNotFound": "No Instagram profile found on the restaurant website",
        "CreateDemoFindInstagramNoWebsite": "This story has no website",
        "CreateDemoOpenInstagramProfile": "Open Instagram profile",
        "CreateDemoUpdateFromInstagram": "Update from Instagram",
        "CreateDemoUpdateFromInstagramUpdating": "Fetching from Instagram…",
        "CreateDemoUpdateFromInstagramSuccess": "Avatar updated from Instagram",
        "CreateDemoUpdateFromInstagramError": "Could not fetch the Instagram avatar",
        "CreateDemoUpdateFromInstagramNeedName": "Page name or story ID is required",
        "CreateDemoStoryId": "Story ID",
        "CreateDemoAltCreateButton": "Create alternative story",
        "CreateDemoAltCreating": "Creating alternative…",
        "CreateDemoAltListTitle": "Alternatives",
        "CreateDemoAltLoading": "loading…",
        "CreateDemoAltListEmpty": "No alternative yet.",
        "CreateDemoAltConfirm": "Create alternative alt{{n}} from “{{storyId}}”?\n(story + menu, shared media URLs)",
        "CreateDemoAltSuccess": "Alternative created: {{storyId}} (menu {{menuId}})",
        "CreateDemoAltError": "Could not create the alternative story",
        "CreateDemoAltMaxReached": "Maximum of 3 alternatives reached",
        "CreateDemoAltAliasTaken": "The alternative alias is already taken",
        "CreateDemoAltExists": "This alternative already exists",
        "CreateDemoAltMenuError": "Could not duplicate the menu for the alternative",
        "CreateDemoAltEditButton": "Edit",
        "CreateDemoAltEditTitle": "Edit {{storyId}}",
        "CreateDemoAltEditVideoUrl": "videoRef / image URL",
        "CreateDemoAltEditHint": "Media is copied to Storage under restaurants/…/{storyId}/. Tag appears as tag1text on the use-cases player URL.",
        "CreateDemoAltEditLoading": "Loading story…",
        "CreateDemoAltEditSaving": "Saving…",
        "CreateDemoAltEditUploading": "Uploading file…",
        "CreateDemoAltEditSave": "Save",
        "CreateDemoAltEditUrlRequired": "Video / image URL is required",
        "CreateDemoAltEditLoadError": "Could not load the alternative story",
        "CreateDemoAltEditSuccess": "Alternative {{storyId}} updated",
        "CreateDemoAltEditError": "Could not update the alternative",
        "CreateDemoAltEditUploadError": "Could not upload the file",
        "CreateDemoAltEditTag": "Tag (tag1text)",
        "CreateDemoAltEditTagHint": "Shown on the use-cases right player via ?tag1text=…",
        "CreateDemoAltEditInfluencerSection": "Influencer",
        "CreateDemoAltEditInfluencerAvatar": "Influencer avatar URL",
        "CreateDemoAltEditInfluencerAvatarHint": "Existing Storage URL — used by the influencer button (no upload)",
        "CreateDemoAltEditInfluencerOpen": "Edit name & review text",
        "CreateDemoAltEditInfluencerRemove": "Remove influencer",
        "CreateDemoAltEditInfluencerRemoveHint": "Removes the influencer button from the story. Storage files are kept.",
        "CreateDemoAltEditInfluencerRemoved": "Influencer option removed (Storage unchanged)",
        "CreateDemoAltEditInfluencerRemoveError": "Could not remove the influencer option",
        "CreateDemoAltEditAnimate": "Animate avatar",
        "CreateDemoAltEditAnimateUpdating": "Animating avatar…",
        "CreateDemoAltEditAnimateSuccess": "Animated avatar video set on the story (image kept in Storage)",
        "CreateDemoAltEditAnimateError": "Could not animate the avatar",
        "CreateDemoAltEditAnimateNeedImage": "Avatar URL must be an image (jpg, png, webp…)",
        "CreateDemoAltEditAnimateVideoHint": "Influencer button uses this muted video; the still image URL is unchanged.",
        "CreateDemoAltEditMusicUrl": "Background music URL",
        "CreateDemoAltEditMusicHint": "mp3 / wav / m4a — uploaded to Storage under restaurants/…/{storyId}/",
        "CreateDemoAltEditMusicDelete": "Delete music",
        "CreateDemoAltEditMusicDeleted": "Music removed",
        "CreateDemoAltEditMusicDeleteError": "Could not delete music",
        "CreateDemoAltEditPromoImg": "Promo image URL",
        "CreateDemoAltEditPromoDelete": "Delete promo",
        "CreateDemoAltEditPromoDeleted": "Promo removed",
        "CreateDemoAltEditPromoDeleteError": "Could not delete promo",
        "CreateDemoAltEditDeleting": "Deleting…",
        "CreateDemoAltEditMenuStickerTitle": "Menu sticker",
        "CreateDemoAltEditMenuStickerCenter": "Center menu sticker",
        "CreateDemoAltEditMenuStickerCenterHint": "Sets mediasCenterXpct and mediasCenterYpct to 50",
        "CreateDemoAltEditMenuStickerCentered": "Menu sticker centered (50 / 50)",
        "CreateDemoAltEditMenuStickerCenterError": "Could not center the menu sticker",
        "CreateDemoAltEditMenuPageModeTitle": "Menu first page type",
        "CreateDemoAltEditMenuPageModeRichtext": "Text + landscape image",
        "CreateDemoAltEditMenuPageModeImage": "Full-screen image",
        "CreateDemoAltEditRichPageImg": "Landscape image URL",
        "CreateDemoAltEditRichPageHint": "Updates the existing richtext first page on save",
        "CreateDemoAltEditRichPageCreateHint": "Saving creates a richtext page as the first menu page",
        "CreateDemoAltEditRichPagePosition": "Image position",
        "CreateDemoAltEditRichPagePositionTop": "Top",
        "CreateDemoAltEditRichPagePositionBottom": "Bottom",
        "CreateDemoAltEditRichPageHtmlFr": "Text",
        "CreateDemoAltEditRichPageHtmlHint": "Bold, italic, lists…",
        "CreateDemoAltEditRichPageDelete": "Delete text + image page",
        "CreateDemoAltEditRichPageDeleted": "Text + image menu page removed",
        "CreateDemoAltEditRichPageDeleteError": "Could not delete text + image menu page",
        "CreateDemoAltEditRichPageDeleteMissing": "No richtext menu page to delete",
        "CreateDemoAltEditMenuFirstPage": "Menu first-page image URL",
        "CreateDemoAltEditMenuFirstPageHint": "Sets menu_pages first page as type image",
        "CreateDemoAltEditMenuNoFirstPage": "This menu has no first page to update",
        "CreateDemoAltEditMenuCreateFirstPage": "No first page yet — saving will create an image page",
        "CreateDemoAltEditMenuPageDelete": "Delete image page",
        "CreateDemoAltEditMenuPageDeleted": "Menu image page removed",
        "CreateDemoAltEditMenuPageDeleteError": "Could not delete menu image page",
        "CreateDemoAltEditMenuDeleteNotImage": "Only an image-type first page can be deleted here",
        "CreateDemoAltEditMenuMissing": "No menu linked to this alternative",
        "CreateDemoAltEditInsideTitle": "Inside sticker",
        "CreateDemoAltEditInsideEmpty": "No inside media yet",
        "CreateDemoAltEditInsideAdd": "Add inside media",
        "CreateDemoAltEditInsideFromIg": "Add from Instagram",
        "CreateDemoAltEditInsideFromIgTitle": "Inside media from Instagram",
        "CreateDemoAltEditInsideFromIgHint": "Paste a post/reel share link. The video is downloaded via Playwright and added as inside media (no music extraction).",
        "CreateDemoAltEditInsideFromIgSuccess": "Instagram video added as inside media",
        "CreateDemoAltEditInsideMax": "Maximum 2 inside medias",
        "CreateDemoAltEditInsideRemoveError": "Could not remove inside media",
        "CreateDemoChooseFile": "Choose a file",
        "CreateDemoChooseFileHint": "Uploads to Storage (story or demos/ folder)",
        "CreateDemoFileNeedStoryOrPage": "Set a story ID or page name before uploading a file",
        "CreateDemoContentFormat": "Content format",
        "CreateDemoFormatFeed": "Feed",
        "CreateDemoFormatReel": "Reel",
        "CreateDemoMediaType": "Media type",
        "CreateDemoMediaVideo": "Video",
        "CreateDemoMediaImage": "Image",
        "CreateDemoDownloadFromIg": "Download from IG",
        "CreateDemoDownloadFromIgUpdating": "Downloading Instagram video…",
        "CreateDemoDownloadFromIgTitle": "Download video from Instagram",
        "CreateDemoDownloadFromIgUrlLabel": "Instagram share URL (post / reel)",
        "CreateDemoDownloadFromIgUrlPlaceholder": "https://www.instagram.com/reel/… or /p/…",
        "CreateDemoDownloadFromIgHint": "Page name is required. If a story ID is set, the video is also stored as storefront and music extraction starts.",
        "CreateDemoDownloadFromIgNeedPageName": "Page name is required before downloading from Instagram",
        "CreateDemoDownloadFromIgNeedUrl": "Enter a valid Instagram share URL",
        "CreateDemoDownloadFromIgSuccess": "Instagram video downloaded to Storage",
        "CreateDemoDownloadFromIgSuccessWithMusic": "Instagram video downloaded — music extraction started",
        "CreateDemoDownloadFromIgError": "Could not download the Instagram video",
        "CreateDemoDownloadFromIgConfirm": "Download",
        "CreateDemoMediaUrl": "Media URL (video or image)",
        "CreateDemoFillMediaFromStory": "Use story media",
        "CreateDemoFillMediaFromStoryUpdating": "Loading story media…",
        "CreateDemoFillMediaFromStorySuccess": "Demo mediaUrl / mediaType filled from the story",
        "CreateDemoFillMediaFromStoryError": "Could not load media from the story",
        "CreateDemoFillMediaFromStoryEmpty": "This story has no videoRef or imageRef",
        "CreateDemoWidth": "Width",
        "CreateDemoHeight": "Height",
        "CreateDemoAdText": "Ad text",
        "CreateDemoCtaText": "CTA text",
        "CreateDemoCtaLink": "CTA link",
        "CreateDemoDlIgProfileSc": "DL IG Profile SC",
        "CreateDemoDlIgProfileScUpdating": "Capturing Instagram profile…",
        "CreateDemoDlIgProfileScSuccess": "Instagram profile screenshot saved",
        "CreateDemoDlIgProfileScError": "Could not capture the Instagram profile",
        "CreateDemoDlIgProfileScNeedName": "Page name is required",
        "CreateDemoDlIgProfileScNeedUrl": "The CTA link must point to Instagram",
        "CreateDemoDlGoogleReserveSc": "DL Google Reserve SC",
        "CreateDemoDlGoogleReserveScUpdating": "Capturing Google Reserve page…",
        "CreateDemoDlGoogleReserveScSuccess": "Google Reserve screenshot saved",
        "CreateDemoDlGoogleReserveScError": "Could not capture the Google Reserve page",
        "CreateDemoDlGoogleReserveScNeedName": "Page name is required",
        "CreateDemoDlGoogleReserveScNeedUrl": "The CTA link must be a Google Reserve URL",
        "CreateDemoDlWebCtaSc": "DL Website SC",
        "CreateDemoDlWebCtaScUpdating": "Capturing website…",
        "CreateDemoDlWebCtaScSuccess": "Website screenshot saved",
        "CreateDemoDlWebCtaScError": "Could not capture the website",
        "CreateDemoDlWebCtaScNeedName": "Page name is required",
        "CreateDemoDlWebCtaScNeedUrl": "The CTA link must be a website URL (not Instagram or Google Reserve)",
        "CreateDemoSave": "Save demo",
        "CreateDemoUpdate": "Update demo",
        "CreateDemoSaving": "Saving…",
        "CreateDemoMirroring": "Uploading media to storage…",
        "CreateDemoMirrorError": "Could not copy media to storage",
        "CreateDemoSaved": "Demo created",
        "CreateDemoUpdated": "Demo updated",
        "CreateDemoSaveError": "Could not save the demo",
        "CreateDemoDelete": "Delete",
        "CreateDemoDeleting": "Deleting…",
        "CreateDemoDeleted": "Demo deleted",
        "CreateDemoDeleteError": "Could not delete the demo",
        "CreateDemoDeleteTitle": "Delete demo",
        "CreateDemoDeleteConfirm": "Delete the demo “{{pageName}}”? This cannot be undone.",
        "CreateDemoPageNameRequired": "Page name is required",
        "CreateDemoMediaRequired": "Media URL is required",
        "CreateDemoStoryIdRequired": "Story ID is required",
        "CreateDemoCreateStoryButton": "Create/Update story",
        "CreateDemoUpdateStoryButton": "Update story",
        "CreateDemoMenuId": "Menu ID",
        "CreateDemoMenuIdRequired": "Menu ID is required",
        "CreateDemoDisableDetailWithImg": "Disable dish detail for entries with images (disableDetailWithImg)",
        "CreateDemoDisableDetailWithImgSaving": "Updating menu…",
        "CreateDemoDisableDetailWithImgEnabled": "Menu updated: dish detail disabled for images",
        "CreateDemoDisableDetailWithImgDisabled": "Menu updated: dish detail re-enabled for images",
        "CreateDemoDisableDetailWithImgError": "Could not update disableDetailWithImg on the menu",
        "CreateDemoUpdateStoryUpdating": "Updating…",
        "CreateDemoUpdateStorySuccess": "Story updated (menu + restaurants)",
        "CreateDemoUpdateStoryError": "Could not update the story",
        "CreateDemoUpdateStoryNotFound": "This story ID does not exist",
        "CreateDemoPageAvatarRequired": "Page avatar URL is required",
        "CreateDemoUpdateColorsButton": "Update colors from avatar",
        "CreateDemoUpdateColorsUpdating": "Detecting colors…",
        "CreateDemoUpdateColorsSuccess": "Story colors updated",
        "CreateDemoUpdateColorsError": "Could not update story colors",
        "CreateDemoColorPrimary": "Primary",
        "CreateDemoColorSecondary": "Secondary",
        "CreateDemoColorMenu": "Menu",
        "CreateDemoManualColorHint": "Click a swatch to change a color manually",
        "CreateDemoManualColorSuccess": "Color saved",
        "CreateDemoManualColorError": "Could not save the color",
        "CreateDemoUpdateWebColorsButton": "Update colors from web",
        "CreateDemoUpdateWebColorsUpdating": "Detecting web colors…",
        "CreateDemoUpdateWebColorsSuccess": "Story colors updated from the website",
        "CreateDemoUpdateWebColorsError": "Could not detect colors from the website",
        "CreateDemoUpdateWebColorsNoWebsite": "This story has no website URL",
        "CreateDemoUpdateMenuColorsButton": "Update color from menu",
        "CreateDemoUpdateMenuColorsUpdating": "Updating menu color…",
        "CreateDemoUpdateMenuColorsSuccess": "Colors updated from the menu (title + background)",
        "CreateDemoUpdateMenuColorsError": "Could not update menuColor from the menu",
        "CreateDemoUpdateMenuColorsNoMenu": "Menu not found",
        "CreateDemoUpdateMenuColorsNoTitle": "This menu has no title color",
        "CreateDemoUpdateMenuColorsNoBackground": "This menu has no background color",
        "CreateDemoCreateStoryTitle": "Create/Update story",
        "CreateDemoCreateStoryRestaurant": "Restaurant in France",
        "CreateDemoCreateStoryCreating": "Working…",
        "CreateDemoCreateStoryCreated": "Story created",
        "CreateDemoInfluencerTextFailed": "Story created, but influencer texts could not be generated — save the demo again to retry",
        "CreateDemoCreateStoryError": "Could not create the story",
        "CreateDemoCreateStoryExists": "This story ID already exists",
        "CreateDemoCreateStoryAliasInvalid": "Story ID: letters, numbers, - and _ only",
        "CreateDemoCreateStoryAliasTaken": "This story ID is already used as an alias on another story",
        "CreateDemoCreateStoryRestaurantRequired": "Select a restaurant",
        "CreateDemoCreateStoryIdInvalid": "Story ID cannot contain “/”",
        "CreateDemoAddChainRestaurant": "Add a chain restaurant",
        "CreateDemoChainRestaurant": "Chain restaurant in France",
        "CreateDemoCreateStoryChainSame": "Choose a different restaurant for the chain",
        "CreateDemoCreateStoryChainName": "Chain name",
        "CreateDemoCreateStoryChainNameHint": "Used as the story display name (posName)",
        "CreateDemoCreateStoryChainNameRequired": "Enter the chain name",
        "CreateDemoCreateStoryChainAddress": "Chain address line",
        "CreateDemoCreateStoryChainAddressHint": "Displayed on the story (e.g. nationwide coverage)",
        "CreateDemoCreateStoryChainAddressLoading": "Generating address…",
        "CreateDemoMediaTypeInvalid": "Media type must be video or image",
        "CreateDemoFormatInvalid": "Format must be feed or reel",
        "CreateDemoAdminOnly": "Admin only",
        "DemoFeedLoading": "Loading demo…",
        "DemoFeedNotFound": "No demo found for “{{pageName}}”",
        "DemoFeedLoadError": "Could not load the demo",
        "DemoFeedAllowScrap": "See your demo for <bold>{{pageName}}</bold>?",
        "DemoFeedAllowScrapCta": "Click here!",
        "DemoFeedLearnMore": "Learn more",
        "DemoFeedUseCases": "Use cases",
        "DemoFeedTalkToUs": "Let's talk",
        "UseCasesBack": "← Back",
        "UseCasesLeftCaption": "Your Meta Social Ad",
        "UseCasesRightCaption": "After the CTA click",
        "UseCasesLoading": "Loading use cases…",
        "UseCasesNoDemo": "No demo for “{{pageName}}”",
        "UseCasesNoneSaved": "No use cases saved for “{{pageName}}”",
        "UseCasesEmpty": "Empty use cases for “{{pageName}}”",
        "UseCasesLoadFailed": "Could not load use cases",
        "UseCasesCreativeTitleLine1": "Give free rein",
        "UseCasesCreativeTitleLine2": "to your creativity.",
        "UseCasesCreativeSubtitle": "Turn every piece of content into a unique immersive experience.",
        "DemoFeedScrapConfirmTitle": "See my demo for {{pageName}}",
        "DemoFeedScrapConfirmText": "I act on behalf of {{pageName}}.\nA Meta Social Ad, a pinch of your website, a dash of AI… and it's ready.",
        "DemoFeedScrapConfirmTextReady": "Nothing to set up. Shall we take our seats? 👨‍🍳",
        "DemoFeedScrapConfirmAccept": "OK",
        "DemoFeedLeftCaption": "Classic Landing Page",
        "DemoFeedPhonesOr": "OR",
        "DemoFeedPhonesOrMobile": "OR RATHER",
        "DemoFeedRightCaptionPrefix": "",
        "DemoFeedRightCaptionPrefixMobile": "A ",
        "DemoFeedRightCaptionGradient": "Social",
        "DemoFeedRightCaptionSuffix": " Landing Page",
        "DemoFeedHookTitle": "After your Social Ad 👉",
        "DemoFeedHookTitleMobile": "After your Social Ad 👇",
        "DemoFeedChatFreeTrialNote": "30-day free trial",
        "DemoFeedPhonesCaption": "A social click shouldn’t lead to a page of text",
        "DemoFeedViewFullscreen": "View fullscreen",
        "DemoFeedWebsiteShotToast": "Your website",
        "DemoFeedInstagramShotToast": "Opening your Instagram profile",
        "DemoFeedGoogleShotToast": "Opening your Google booking",
        "DemoItineraryMockToast": "Opening your address on Google Maps",
        "DemoDeliveryPlatformToast": "Opening your platform",
        "DemoClickCollectPlatformToast": "Opening your platform",
        "DemoOrderingPlatformToast": "Opening your platform",
        "DemoPhoneCallToast": "Opening the phone call",
        "DemoInstagramChatToast": "Opening Instagram messaging",
        "BookingMockDemoToastSubtitle": "your existing booking page (zenchef, thefork, etc.)",
        "XViews": " views",
        "XUniqueViews": " unique views",
        "XAvgDurationTime": "Average visit",
        "XAvgDurationTimeList": " s average visit time",
        "Draft": "Draft",
        "Interest": "Interest: ",
        "XShares": " shares",
        "XBookingIntent": " bookings",
        "XContact": " contacts",
        "XItineraries": " itineraries",
        "XReturns": " returns",
        "Launch": "Launch",
        "Modify": "Modify",
        "CopyWebLink": "Copy the web link",
        "ChooseAFile": "Choose a file",
        "FromMyCamera": "From my video camera",
        "FromMyFiles": "From my files or my camera",
        "OpenMyCamera": "Open my camera",        
        "ErrorImageFormat": "Please choose an image format",
        "ErrorAudioFormat": "Please choose an audio format",
        "LoginWithFacebookBusiness": "Login with Facebook",
        "LoginWithFacebookBusinessHelp": "You have access to the restaurant's Facebook Business account, which is connected to its Instagram account.",
        "LoginWithInstagram": "Login with Instagram",
        "LoginWithInstagramHelp": "You have access to the restaurant's Instagram Business account.",
        "LoginHelp": "Logging in with Facebook or email link automatically create an UpReality account for you if you don't already have one.",
        "Login": "Login",
        "BackToMyStories": "My Landing Pages",
        "PublishMyChanges": "Publish",
        "PublishWarning": "Your customers will be able to see the changes made to your Social Landing Page, the update will be made immediately.", 
        "Publish": "Publish",
        "DeleteStory": "Delete my social landing page?",
        "DeleteStoryWarning": "This social landing page and its stats will be deleted permanently.", 
        "DuplicateStory": "Duplicate",
        "DuplicateStoryDialogTitle": "Duplicate this social landing page?",
        "DuplicateStoryWarning": "A copy of this social landing page will be created.",
        "DuplicateStoryFailed": "Unable to duplicate this social landing page. Please try again later.",
        "Delete": "Delete",
        "ChangeRestaurantWarning": "Changing restaurant will reset all your input, texts and images already saved.",
        "FileFormatError": "Please choose another file format",
        "FileSizeError": "Please choose a file under {{size}} Mb",
        "NoMediaFound": "No content found",
        "ModifyStoryWarning": "The changes made to this social landing page will only be applied when you publish them ",
        "CreateNewStory": "New landing page",
        "Preview": "Preview",
        "AbandonChanges": "Abandon changes",
        "Abandon": "Abandon",
        "AbandonStoryWarning": "The changes made to this social landing page will be lost.",
        "RestartStory": "Restart the social landing page",
        "RestartStoryWarning": "The changes made to this social landing page will be lost.",
        "Restart": "Restart",
        "AcknowledgeAbandonChanges": "The changes have been successfully abandoned.",   
        "AckStorySavedPerm": "You are now registered on the application and your social landing page has been permanently saved.",        
        "AckLinkCopied": "Link copied!", 
        "AckHoursThreshold": "Only reviews above 4 are displayed",
        "GoogleReviewCountSingular": "{{count}} review",
        "GoogleReviewCountPlural": "{{count}} reviews",
        "WarningDownsizeRunning": "An optimization of your multimedia content is in progress, this should only take a few minutes.",        
        "AckDisconnected": "You are now disconnected from your UpReality account.",
        "ErrorTitle": "Something went wrong!", 
        "ErrorMsg": "If the problem persists, please contact us.",
        "ErrorAction": "Refresh",
        "ChangeStyle": "Change style",
        "SelectFBPage": "Select the associated Facebook page",
        "ErrorNoFacebookPage": "You don't have a Facebook page associated with your account. Please connect directly from your restaurant's Instagram account.",
        "ErrorNoInstagramAccount": "You don't have an Instagram account associated with your Facebook page. Please connect directly from your restaurant's Instagram account.",
        "ErrorNoIGProfilePicture": "You don't have an Instagram profile picture. Please select instead from a file or a web link.",
        "ErrorInstagramMediaDownload": "Unable to download this Instagram video. Please try again or choose a file from your device.",          
        "ErrorDefault": "Error, please try again later.",
        "ErrorSaving": "Error saving configuration",
        "PreviousPage": "Previous page",
        "NextPage": "Next page",    
        "YourWelcomeMsg": "My welcome message",
        "YourInfos": "📄 My infos",
        "YourBranding": "🎨 My branding",
        "LinkBooking": "Configure my links",   
        "ConfigureBooking": "Configure my links 📅",  
        "Booking": "Booking",
        "Ordering": "Ordering",   
        "ContactCategory": "Contact",
        "BookingOptionGoogleMaps": "Google Maps page (default)",
        "BookingReplaceByLink": "replace by a web link",
        "BookingLinkHint": "booking web link",
        "BookingLinkHelp": "do not enter anything if you do not want online booking",
        "BookingOptionLinkTooltip": "Use the booking widget link if you use TheFork or Zenchef",
        "BookingReplaceByMaps": "replace by the Google Maps page",
        "OrderingAddAnotherPlatform": "add a platform",
        "OrderingAddPlatform": "Add a platform",
        "OrderingAddDeliveryPlatform": "Add a delivery platform",
        "OrderingAddClickCollectPlatform": "Add a Click & Collect platform",
        "OrderingLinkHint": "ordering web link",
        "OrderingTypeDelivery": "Delivery",
        "OrderingTypeClickCollect": "Click & Collect",
        "OrderClickCollectEmoji": "🛍️",
        "OrderOnDeliveryAndClickCollect": "Delivery and Click & Collect",
        "OrderOnDelivery": "Delivery",
        "OrderOnClickCollect": "Click & Collect",
        "BookingOptionLink": "By link",
        "BookingOptionPhoneOn": "By phone",
        "BookingOptionPhoneOff": "By phone (disabled)",
        "BookingPhoneHint": "your phone number",
        "BookingOptionPhoneToOff": "do not allow contact by phone",
        "BookingOptionPhoneToOn": "allow contact by phone",
        "BookingOptionEmail": "By email",
        "BookingEmailHint": "your booking email address",
        "BookingOptionChat": "By chat", 
        "ConnectInstagram": "Connect my Instagram profile",
        "ConnectInstagramHelp": "You will have access to your Instagram content to use in your social landing page (avatar, store front photo, plates photos, etc.).",
        "IGProfileConnected": "Profile {{name}} connected",
        "DisconnectInstagram": "disconnect my profile",
        "EnterEmail": "Enter your email address to login",
        "EnterEmailHelp": "We will send you a link to login to the app and go back to your social landing page",
        "EnterEmailHelp2": "You will then be able to connect to Instagram to import your content.",
        "EnterEmailHint": "your email address",
        "EmailSent": "Email sent, please check your inbox to go back to the application with your activated account. The email may be in your spam folder.",
        "ConnectEmailLink": "Login with email link",
        "FoodAgencies": "Food Agencies",
        "SocialWebsite": "Social Landing Page",      
        "Pricing": "Pricing",  
        "TopbarHome": "Home",
        "MyAccount": "My account",
        "LogOut": "Log me out",
        "LogOutWarning": "You will be logged out of UpReality.", 
        "ManageMyAccount": "Manage",
        "Hero1": "The",
        "Hero2": " Social Landing Page",
        "Hero3": "of your restaurant 🍹",        
        "Hero41": "After your social content: web page or immersive format?",
        "Hero42": "",  
        "InstantAdHero1": "The",
        "InstantAdHero2": "landing page",
        "InstantAdHero3": "of the social network.",
        "InstantAdHero41" : "After your Social Ad, an immersive experience for more reservations",
        "InstantAdHero42" : "",
        "FoodAgenciesHero1": "A",
        "FoodAgenciesHero2": " Social Landing Page",
        "FoodAgenciesHero3": "for your restaurants 🍹",
        "FoodAgenciesHero41": "Offer your clients an immersive format after their social ads",
        "FoodAgenciesHero42": "",
        "FoodAgenciesCTA": "Create a social landing page",
        "InstantAdYourContentHere": "Your content here!",
        "InstantAdYourContentNotAI": "(it's not AI)",
        "CTA": "Request a demo",
        "InstantAdCTA": "Create my social landing page",
        "Create": "Create with the maker",        
        "ProfileInstagramHint": "Instagram profile or website",    
        "ContactEmailHint": "my contact email",            
        "Create1ClickHelp0": "Instead of using the maker, let us create your Social Landing Page from your web content.",
        "Create1ClickHelp0InstantAd": "Instead of using the maker, let us create your Social Landing Page from your web content.",
        "Create1ClickHelp1": "You can optionally send us photos, videos and menu by WeTransfer.",
        "Create1ClickHelp2": "Social landing page editable upon request or manually through the application.",
        "MandatoryField": "mandatory",                
        "AckCreate1Click": "Your request has been successfully taken into account, you will receive your social landing page shortly.",        
        "SendMyContentWithWeTransfer": "Send my content with WeTransfer",
        "CTA2": "Create my social landing page",
        "RestaurantChainsContactUs": "Contact us",
        "CTAbottom":  "Request a demo",
        "Create1ClicBtn":  "Create in 1 click",        
        "Benefit1": "Rethink the social experience",
        "SubBenefit11": "Extend the exploration",
        "SubBenefit11det": "A social format designed for restaurants",
        "SubBenefit12": "Help your customers envision themselves",
        "SubBenefit12det": "An immersive and short format to capture intent",
        "SubBenefit13": "Facilitate the call to action",
        "SubBenefit13det": "An actionable format to trigger the reservation",
        "InstantAdBenefit1": "Rethink the social experience",
        "InstantAdSubBenefit11": "Extend the exploration",
        "InstantAdSubBenefit11det": "A social format designed for restaurants",
        "InstantAdSubBenefit12": "Help your customers envision themselves",
        "InstantAdSubBenefit12det": "An immersive and short format to capture intent",
        "InstantAdSubBenefit13": "Facilitate the call to action",
        "InstantAdSubBenefit13det": "An actionable format to trigger the reservation",
        "RestaurantsBenefit1": "Your restaurant's discovery board",
        "RestaurantsSubBenefit11": "Social video and stickers",
        "RestaurantsSubBenefit11det": "",
        "RestaurantsSubBenefit12": "Website menu and booking",
        "RestaurantsSubBenefit12det": "",
        "RestaurantsSubBenefit13": "Google Maps rating and reviews",
        "RestaurantsSubBenefit13det": "",
        "RestaurantsSubBenefit14": "AI chat for quick questions",
        "RestaurantsSubBenefit14det": "",
        "RestaurantsBenefit2": "A format that converts more",
        "RestaurantsSubBenefit21": "Everything to confirm their desire",
        "RestaurantsSubBenefit21det": "Mobile menu and Google reviews to decide",
        "RestaurantsSubBenefit22": "A flawless experience",
        "RestaurantsSubBenefit22det": "No popups, no intermediate menu, with your booking widget",
        "RestaurantsSubBenefit23": "Design your experience autonomously with the app",
        "RestaurantsSubBenefit23det": "or let our team prepare it for you",
        "RestaurantChainsSubBenefit23": "Built for restaurant chains",
        "RestaurantChainsSubBenefit23det": "Each location has its own dedicated content",
        "Benefit2": "Create in just a few minutes",
        "SubBenefit21": "Take it easy with AI",
        "SubBenefit21det": "Integrated chatbot, menu reformatting, data entry assistance, translations",
        "SubBenefit22": "Connect your web content",
        "SubBenefit22det": "Google Business data and Instagram content",
        "SubBenefit23": "Create with full autonomy with the maker",
        "SubBenefit23det": "We can also do it for you",
        "InstantAdBenefit2": "How to create your social landing page?",
        "InstantAdSubBenefit21": "Create your landing page yourself",
        "InstantAdSubBenefit21detPrefix": "or ",
        "InstantAdSubBenefit21detLink": "contact us",
        "InstantAdSubBenefit21detSuffix": " to have us do it for you",
        "InstantAdSubBenefit22": "Customize your page with your content",
        "InstantAdSubBenefit22det": "Google Maps sync, social video, menu, booking widget",
        "InstantAdSubBenefit23": "Make life easier with AI",
        "InstantAdSubBenefit23det": "your menu (PDF or web) is reformatted by AI",
        "InstantAdSubBenefit24": "Publish your page",
        "InstantAdSubBenefit24det": "you get a web link ready to use",
        "InstantAdSubBenefit25": "Paste your web link as your social ad destination",
        "InstantAdSubBenefit25det": "or on your Meta profiles, via QR code, etc.",
        "InstantAdWhoForTitle": "Who is it for?",
        "InstantAdWhoForRestaurantsTitle": "Restaurants",
        "InstantAdWhoForRestaurantsDet": "Create your landing page on your own\nor let us create it for you",
        "InstantAdWhoForChainTitle": "Chains",
        "InstantAdWhoForChainDet": "With a \"Find my restaurant\" feature like on the website and personalized pages per restaurant",
        "InstantAdWhoForAgenciesTitle": "Food Agencies",
        "InstantAdWhoForAgenciesDet": "A/B test multiple versions to find the one best suited to your audience",
        "FoodAgenciesBenefit1": "Boost attractiveness and performance",
        "FoodAgenciesSubBenefit11": "Extend social exploration",
        "FoodAgenciesSubBenefit11det": "An immersive and engaging choice experience",
        "FoodAgenciesSubBenefit12": "Everything to confirm their desire",
        "FoodAgenciesSubBenefit12det": "Mobile menu and Google reviews to decide",
        "FoodAgenciesSubBenefit13": "Flawless navigation",
        "FoodAgenciesSubBenefit13det": "No popups, no intermediate menu, with your booking widget",
        "FoodAgenciesBenefit2": "Increase your creative potential",
        "FoodAgenciesSubBenefit21": "Test your creatives on your Ad, AND also on its destination",
        "FoodAgenciesSubBenefit21det": "A fully configurable enriched social format",
        "FoodAgenciesSubBenefit22": "A new optimization opportunity for your campaigns",
        "FoodAgenciesSubBenefit22det": "A free trial for a spot in your AB Test budget",
        "FoodAgenciesSubBenefit23": "Create with full autonomy with the maker",
        "FoodAgenciesSubBenefit23det": "We can also do it for you",
        "CompareWebsite": "Compare a mobile website with an UpReality social landing page",
        "CompareWebsiteInstantAd": "Compare a traditional website with a Social Landing Page",
        "CompareWebsiteRestaurants": "A social click shouldn't lead to a text page",
        "CompareFrameTraditionalWebsite": "traditional website",
        "CompareFrameSocialWebsite": "social landing page",
        "CompareWebsiteClosing1": "Your website is relevant on Google,",
        "CompareWebsiteClosing2": "UpReality on social networks.",
        "CompareWebsiteClosingRestaurants1": "Your website is relevant on Google,",
        "CompareWebsiteClosingRestaurants2": "UpReality on social networks.",
        "HomeFloatingConversionTarget": "Target reservation rate: +20%",
        "WebsiteQ1" : "Text world",                
        "WebsiteQ2" : "More textual and long",        
        "WebsiteQ3" : "The big story",        
        "StoryQ1" : "Living world",        
        "StoryQ2" : "Video and interactive",      
        "StoryQ3" : "Instant and immersive",        
        "CompareDuel1": "World",
        "CompareDuel2": "Content",
        "CompareDuel3": "Experience",
        "SalesDeckTitle": "Social Ads for restaurants today",
        "SalesDeckSlide1CaptionInstagram": "Instagram feed",
        "SalesDeckSlide1CaptionTraditionalWebsite": "Traditional website",
        "SalesDeckSlide1CaptionSocialWebsite": "Social Landing Page",
        "TryItPremium" : "Try it in premium",        
        "TryItPremiumTitle" : "Try UpReality Premium for 30 days",                
        "TryItPremiumText" : "During your free trial, you have access to:",
        "TryItPremiumText1" : "the integrated menu optimized for mobile,",
        "TryItPremiumText2" : "the automatic synchronization to your Google Business page",
        "TryItPremiumText3" : " as well as the possibility of having up to 3 social landing pages to push your A/B tests further.",        
        "UpgradeTitle": "Upgrade your plan",        
        "UpgradeButton" : "Upgrade to Premium",
        "FAQ": "FAQ",
        "FAQ1": "FAQ 1",
        "FAQanswer1": "Answer 1",
        "FAQ2": "FAQ 2",
        "FAQanswer2": "Answer 2",
        "FAQ3": "FAQ 3",
        "FAQanswer3": "Answer 3",
        "FAQ4": "FAQ 4",
        "FAQanswer4": "Answer 4",
        "AboutUs": "About us",
        "AboutUsText": "Jacques ...",
        "Terms": "Terms",
        "FooterFollowUsLinkedIn": "Follow us",
        "FooterFollowUsLinkedInAria": "Follow UpReality on LinkedIn",
        "FooterLinkedInShort": "LinkedIn ↗",
        "FooterCopyright": "© {{year}} UpReality",
        "Privacy": "Privacy",        
        "ConsentMessage": "To enhance your experience, we use handcrafted cookies.",
        "ConsentLearnMore": "Learn more.",
        "ConsentLess": "Show less.",
        "ConsentDetailsTitle": "Our cookie recipe 🍪",
        "ConsentDetailsPurpose": "🎯 What it's for: we use {{pixels}} to watch your visit on this social landing page, measure and improve our ads.",
        "ConsentDetailsData": "📊 What we gather: browsing data on this story (infos viewed, booking steps…).",
        "ConsentDetailsWho": "👩‍🍳 Who bakes them: this restaurant and {{controllers}}, as joint controllers.",
        "ConsentPixelMeta": "the Meta pixel",
        "ConsentPixelTikTok": "the TikTok pixel",
        "ConsentPixelBoth": "the Meta and TikTok pixels",
        "ConsentControllerMeta": "Meta (Facebook / Instagram)",
        "ConsentControllerTikTok": "TikTok",
        "ConsentControllerBoth": "Meta (Facebook / Instagram) and TikTok",
        "ConsentDetailsChoice": "✋ Your choice: accept or decline in one tap, and change your mind whenever you like.",
        "ConsentRefuse": "Decline",
        "ConsentAccept": "Accept",
        "ConsentManage": "Manage my cookies 🍪",
        "ConsentCurrentAccepted": "You currently accept cookies.",
        "CGV": "Terms of Sale",
        "PublicationDate": "Published on ",
        "NotPublished": "not published",
        "Loading": "Loading...",
        "ErrorAccountExistsWithDifferentCredential": "You previously logged in with an email link, to be able to reconnect with Facebook, please log in with an email link and go to your preferences to link your Facebook account to your email.",        
        "ErrorFBNotInitialized": "Please disable your ad blocker and refresh the page to access your Instagram content.",
        "ErrorFBNotInitializedAfterLogin": "Please disable your ad blocker to access your Instagram content. After refreshing, you will need to reselect your social landing page from the list, your changes will be saved",
        "AckInstagramChat": "Your customers can now use the Instagram chat to contact you.",
        "TermsHelp": "To be able to use the application, you must accept the terms of use.",
        "TermsTitle": "Terms of use",
        "TermsText1": "I acknowledge having read and understood the ",
        "TermsText2": "terms of use",
        "TermsText3": " and accept them.",
        "ErrorEmailLinkExpired": "The email link has expired, please log in again to get a new email link.",
        "TitleLogged": "My Social Landing Pages",
        "TitleMaker": "Social landing page maker",
        "ContinueToInstagramTitle": "Continue to Instagram",
        "ContinueToInstagram": "You just logged in with an email link, we will now log you in to Instagram to allow you to select your content.",
        "ContinueToInstagramProfile": "You just logged in with an email link, we will now log you in to Instagram.",
        "HoursFromTo": "{{from}} to {{to}}",
        "InfoSwipe": "Swipe to see more",
        "InfoPreview": "After each modification, click on the 'Preview' button to see the result.",
        "EmptyList": "Nothing in the kitchen!",                
        "MaskedStories": "upgrade to premium to display the {{maskedStories}} hidden social landing pages",        
        "MaskedStoriesPlus": "upgrade to premium to display the {{maskedStories}} hidden social landing pages",
        "ClosePreview": "Close preview",
        "TabMaker": "Maker",
        "TabStories": "My Landing Pages",
        "TabAccount": "My account",
        "ManageMyAccountTitle": "Manage my account",
        "MyAccountCateg": "My account",
        "MyPlanCateg": "My plan",
        "OthersCateg": "Others",
        "AssociateAccounts": "Associate my accounts",
        "AssociateFacebookToEmail": "Associate my Facebook account to my email account",
        "AssociateEmailToFacebook": "Associate my email account to my Facebook account",
        "EmailLinkedToFacebook": "Your email account is now linked to your Facebook account.",
        "EmailLinkedToFacebookStatus": "Email account linked to Facebook account",        
        "PlanUpdating": "Your plan is being updated...",        
        "Logging": "Logging in...",
        "ErrorInstagramInAppBrowserTitle": "Dead end!",
        "ErrorInstagramInAppBrowserMsg": "Accept the popup to return to the application on your original browser.",
        "ErrorInstagramInAppBrowserMsg1": "OR",
        "ErrorInstagramInAppBrowserMsg2": "Click on settings at the top right then \"Open in Chrome\"",        
        "MenuAllergens": "List of allergens",
        "MenuVegetarianLabel": "Vegetarian",
        "MenuSignatureLabel": "Signature",
        "MenuDemoMenusTitle": "{{menu}} set menu (X €)",
        "MenuDemoMenusDesc1": "Main course + Dessert",
        "MenuDemoMenusDesc2": "Starter + Main course + Dessert",
        "MenuDemoStarterTitle": "Starter {{nb}}",
        "MenuDemoStarterDesc": "Starter {{nb}} composition",
        "MenuDemoStarterTitleDemo1": "Plate of raw vegetables (v)",
        "MenuDemoStarterDescDemo1": "Salad, tomatoes, cucumbers, green beans",
        "MenuDemoStarterTitleDemo2": "Hot goat cheese salad",
        "MenuDemoStarterDescDemo2": "Salad, hot goat cheese, tomatoes, nuts (v)",
        "MenuDemoStarterTitleDemo3": "Country terrine",
        "MenuDemoStarterDescDemo3": "Homemade, pickles, salad",
        "MenuDemoStarterTitleDemo4": "Vegetable soup (v)",
        "MenuDemoStarterDescDemo4": "Seasonal vegetable soup",
        "MenuDemoStarterTitleDemo5": "Mussels marinières",
        "MenuDemoStarterDescDemo5": "Cooked in white wine, fries", 
        "MenuDemoMainCourseTitle": "Main course {{nb}}",
        "MenuDemoMainCourseDesc": "Main course {{nb}} composition",
        "MenuDemoMainCourseTitleDemo1": "Grilled pork chop",
        "MenuDemoMainCourseDescDemo1": "Served with green beans",
        "MenuDemoMainCourseTitleDemo2": "Roast chicken",
        "MenuDemoMainCourseDescDemo2": "Served with potatoes",
        "MenuDemoMainCourseTitleDemo3": "Roasted cauliflower steak (v)",
        "MenuDemoMainCourseDescDemo3": "Served with roasted potatoes and green salad",
        "MenuDemoMainCourseTitleDemo4": "Fish of the day",
        "MenuDemoMainCourseDescDemo4": "Depending on availability, served with rice",
        "MenuDemoMainCourseTitleDemo5": "Cheese and bacon burger",
        "MenuDemoMainCourseDescDemo5": "Served with fries",
        "MenuDemoDessertTitle": "Dessert {{nb}}",
        "MenuDemoDessertDesc": "Dessert {{nb}} composition",
        "MenuDemoDessertTitleDemo1": "Raspberry tart",
        "MenuDemoDessertDescDemo1": "Homemade",
        "MenuDemoDessertTitleDemo2": "Crème brûlée",
        "MenuDemoDessertDescDemo2": "Homemade",
        "MenuDemoDessertTitleDemo3": "Mousse au chocolat",
        "MenuDemoDessertDescDemo3": "Homemade",
        "MenuDemoDessertTitleDemo4": "Fruit salad",
        "MenuDemoDessertDescDemo4": "Fresh fruit",
        "MenuDemoDessertTitleDemo5": "Ice cream",
        "MenuDemoDessertDescDemo5": "3 balls to choose from",
        "WineDemoTitle": "Wine {{nb}}",
        "WineDemoPrices": "37.5 cl: X € - 75 cl: X €",
        "WineDemoPrices2": "12 cl: X €",
        "EndingPageDemoText": "Net prices including service\n\nOur dishes are prepared with fresh and local products, in collaboration with surrounding farms.\n\nMeans of payment: credit card (visa, master card, american express), etc.",
        "TransferToAnotherAccount": "Transfer to another account",
        "TransferRecipient": "New owner email address",
        "TransferHint": "The landing page to transfer",
        "TransferToAnotherAccountWarning": "The social landing page {{name}}, published on {{date}} will be transferred to the UpReality account associated with the email address entered. If the account does not yet exist, the social landing page will be automatically assigned when it is created.",
        "TransferAction": "Transfer",
        "TransferInProgress": "{{name}} being transferred toward {{email}}",
        "SnackAcceptTransfer":  "Accept the social landing page transfer for \"{{name}}\"",    
        "SnackAcceptTransferAction": "Accept",      
        "ErrorSubscriptionLimitReached":  "Sorry, the registration limit for our Beta has been reached. We have taken your email and will contact you as soon as a place becomes available.",
        "ErrorNoInternetConnection": "No internet connection. Please check your connection and try again.",
        "ChatLimitReached": "The chef went back to the kitchen 😜 (chat limit reached), visit the restaurant's website!",
        "ChatLimitReachedWithLink": "The chef went back to the kitchen 😜 (chat limit reached), visit <link>the restaurant's website</link>!",
        "ChatError": "Sorry, an error occurred. Please try again.",
        "ChatPrivacy": "chat recorded to serve you better :)",
        "ChatPlaceholder": "Ask your question...",
        "ChatProcessing": "Processing...",
        "ChatWelcomeMessage": "At your service! 😊",
        "DeleteMyAccount": "Delete my account",
        "DeleteMyAccountWarning": "Your account and all your social landing pages will be deleted permanently.",
        "DeleteAction": "Delete",
        "AckAccountDeleted": "Your account has been deleted.",        
        "ErrRecentLogin": "Your last login is too old, we cannot delete your account. Please log back in and click this button again to permanently delete your account.",
        "Help": "Help",
        "ReadFAQ": "Read the FAQ",
        "TranslateWithGoogle": "translate with Google",
        "DefaultTranslation": "in french",
        "CheckMyRights": "Check my rights",
        "ReadLegals": "Read the legal notices",
        "Legals": "Legal notices",
        "Others": "Others",
        "Images": "Images",  
        "Fonts": "Fonts",      
        "FAQWebsiteSubstituteQuestion": "I already have a website, why use UpReality?",        
        "FAQWebsiteSubstituteAnswer": "UpReality is designed to be used on social networks, it is the social version of your website. Your website, more adapted to the world of text and desktop, remains the most relevant for searches from Google. \n\nYou can use UpReality instead of or in addition to your website on your social media profile.\n\nIf you do not have a website, UpReality can be a more economical, current and easy to update alternative. Indeed, UpReality can be used simply and in total autonomy by restaurateurs or restaurant marketing teams.",
        "FAQSocialProfileRedirectQuestion": "I redirect to my social profile, why use UpReality?",
        "FAQSocialProfileRedirectAnswer": "The social profile is great for discovery and exploration, less so for synthesizing information and converting to action.\n\nOn Instagram, for example, you get an avalanche of social-network buttons and tabs (follow, contact, publishing tabs), an endless content feed, and you can't display the menu properly. Under those conditions, tapping \"Book\" is less obvious.\n\nUpReality, on the other hand, synthesizes all the information while staying in a \"social\" frame:",
        "FAQSocialProfileRedirectAnswerl0": "visuals of dishes and the dining room",
        "FAQSocialProfileRedirectAnswerl1": "the menu in mobile format (not a PDF)",
        "FAQSocialProfileRedirectAnswerl2": "Google reviews + a guest influencer",
        "FAQSocialProfileRedirectAnswerAfter": "so the customer can complete their evaluation and therefore book more easily.",
        "FAQInstantAdQuestion": "What is an Instant Ad?",        
        "FAQInstantAdAnswer": "An Instant Ad is a social advertising format offering a simplified form of the website for a frictionless experience.\nIt extends in-feed advertising with a full-screen experience in the form of a simplified web page (photos, videos, carousels).",        
        "FAQInstantAdDifferenceQuestion": "What is the difference with TikTok Instant Page and Meta Instant Experience?",
        "FAQInstantAdDifferenceAnswer": "Whereas TikTok Instant Page and Meta Instant Experience propose a simplified web format, UpReality offers a real immersive experience in the form of a social landing page.\nThe Social Landing Page connects as the destination link of your Social Ad and offers a standard loading time for a more attractive and engaging experience, in line with social content.",
        "FAQEasyToUseQuestion": "Is it easy to use?",        
        "FAQEasyToUseAnswer": "UpReality is designed for restaurant owners and marketing professionals. It's simple, intuitive, and easy to use. You can create your Social Landing Page in just a few clicks and update it instantly whenever you need.\n\nIf you prefer, we can also take care of everything for you. Feel free to get in touch.",
        "FAQSocialWebsiteVideoQuestion": "What video should I use for my Social Landing Page?",
        "FAQSocialWebsiteVideoAnswer": "You are free to use the content you want. We suggest two formats:\n\n1) Reuse the Social Ad video as is:\n\nThis is the easiest solution to set up. The Landing Page opens in continuity with your ad, as if layered over the video.\n\n2) Use an animated video of the restaurant storefront:\n\nThe idea is to offer slower content that leaves room for information discovery.\n\n💡 Idea: a simple photo of your storefront can be animated with AI (customers on the terrace, awning movement, vegetation, light, etc.) to create a lively result without organizing a shoot.",
        "FAQProContentsQuestion": "Can I use photos and videos that I have taken myself or do I have to use a professional?",            
        "FAQProContentsAnswer": "You can give free rein to your creativity and use your own photos and videos. Some tips: \n",          
        "FAQProContentsAnswerl0": "Take your photos in portrait for better use of space on mobile.\nCenter your subject, indeed the edges of the top and bottom can be cut on small phones.",
        "FAQProContentsAnswerl1": "Privilege color and natural light (eg at 11am)",        
        "FAQProContentsAnswerl2": "For your dishes, put yourself in the customer's shoes at the right distance. The overhead shot is the most common, but you can also vary according to the dishes.",        
        "FAQProContentsAnswerl3": "Bet on naturalness, do not abuse filters, but do not hesitate to play on contrasts and brightness to bring out your photos.",        
        "FAQProContentsAnswerl4": "Play with utensils that make up the identity of your restaurant (eg: wooden board, glass of wine, etc.)",        
        "FAQProContentsAnswerl5": "You can also use a professional to get the best result.",
        "FAQGoogleDataQuestion":  "Where do my restaurant's data come from?",        
        "FAQGoogleDataAnswer":  "Your restaurant's data: address, name, phone number, opening hours, price class come from your Google Business account. They are public and available on Google Maps and Google My Business. If you want to change them, you can do so on Google My Business.",        
        "FAQSocialNetworksQuestion": "On which social networks can I use my social landing page?",            
        "FAQSocialNetworksAnswer": "UpReality is more specifically designed to be used on Instagram and Facebook. \n\nPlease note, UpReality does not publish on social networks as a network content, it's a web link that can be integrated in different places, like the web profile link, the web target of a sticker or a social ad, or simply a link in a message." /* "You can use your social landing page on all social networks. UpReality is more specifically designed to be used on Instagram, TikTok, Snapchat, and Facebook. \n\nPlease note, UpReality does not publish on social networks as a network content, it's a web link that can be integrated in different places, like the web profile link, the web target of a sticker or a social ad, or simply a link in a message." */ ,
        "FAQSocialProfileQuestion": "How to use my social landing page on my social profile?",          
        "FAQSocialProfileAnswer":   "Go to the \"website\" section of your social profile and paste the link of your social landing page. It is possible that on some social networks, you will first have to create a professional account.",                
        "FAQSocialAdDestQuestion": "How to use my landing page as a destination for social ads?",        
        "FAQSocialAdDestAnswer": "UpReality social landing pages can be used for campaigns with a Traffic, Engagement or Conversion objective. They are used as the action link of your social ad instead of the website or social profile.\n\nAdd your Meta pixel number to receive all interaction events directly on your Ad Manager. Global interaction statistics are also available in the app on the statistics page." /* "UpReality social landing pages can be used for campaigns with a Traffic, Engagement or Conversion objective. They are used as the action link of your social ad instead of the website or social profile.\nAdd your Meta and TikTok pixel numbers to receive all interaction events directly on your Ad Manager. Global interaction statistics are also available in the app on the statistics page." */,
        "FAQWebsiteQuestion": "How to use my social landing page as a website?",           
        "FAQWebsiteAnswer": "Your social landing page is already published as a website, you can directly use the link. We will soon set up a service allowing you to connect an existing domain name or order your own domain name.\nIn the meantime, you can connect a subdomain that you own (eg: social.yourrestaurant.com) to the url of your social landing page using a 301 redirection.",                         
        "FAQSocialAdQuestion": "How to use my social landing page from an action on a social ad?",        
        "FAQSocialAdAnswer": "You can use your social landing page as an action link from a social ad on all social platforms, copy the link of the social landing page instead of the website.",                
        "FAQOriginalWaysQuestion": "What other original ways do you suggest?",        
        "FAQOriginalWaysAnswer": "You can use your social landing page from: \n",                
        "FAQOriginalWaysAnswerl0": "a QR Code (examples of use: flyer, business card, etc.).",        
        "FAQOriginalWaysAnswerl1": "a sticker on social networks that allow it like Instagram.",
        "FAQOriginalWaysAnswerl2": "an additional link in your linktr.ee",        
        "FAQOriginalWaysAnswerl3": "a pinned post on your facebook profile so that your social landing page is always visible at the top of the feed",        
        "FAQOriginalWaysAnswerl4": "a Google Business post",        
        "FAQOriginalWaysAnswerl5": "an SMS campaign",
        "FAQStatsNoteQuestion": "How is the interest note calculated?",        
        "FAQStatsNoteAnswer": "The interest rating is calculated from an engagement rating for 3/5 of the rating and a conversion rating for 2/5.",
        "FAQStatsNoteAnswerl1": "The more your customers interact with the social landing page: stickers, action buttons, and information menus, the higher the engagement rating.",
        "FAQStatsNoteAnswerl2": "The greater the proportion of your customers who clicked on the \"Book\" button, the higher the conversion rating."      ,
        "FAQStatsQuestion": "À quoi correspondent les statistiques proposées ?",        
        "FAQStatsAnswerUniqueView": "1 unique view corresponds to the visit of a user. If he closes his web browser and decides to come back to your social landing page, this new visit will not be counted.",        
        "FAQStatsAnswerMoy": "The average duration corresponds to the average visit duration on your social landing page.",        
        "FAQStatsAnswerShares": "The number of shares corresponds to the number of times a user has clicked on the \"Share\" button.",        
        "FAQStatsAnswerBooks": "The number of booking intents corresponds to the number of times a user has clicked on the \"Book\" button.",      
        "FAQStatsAnswerItinerary": "The number of itineraries corresponds to the number of times a user has clicked on the \"Itinerary\" button.",        
        "FAQStatsAnswerReturn": "The number of returns corresponds to the number of times a user has closed the web page and then returned to your social landing page.",        
        "FAQMenuTranslatedQuestion": "Will my menu in optimized mobile format be translated for foreign tourists?",        
        "FAQMenuTranslatedAnswer": "If the menu you send us contains the English translation, it will be integrated into your social landing page. For menus without English translation, users will be able to obtain a automated translation directly from the social landing page.",                         
        "FAQNoFacebookPageQuestion": "When I try to add content with \"Login with Facebook\", I get the error \"You don't have a Facebook page associated with your account\".",        
        "FAQNoFacebookPageAnswer": "To use this feature, you must : \n",
        "FAQNoFacebookPageAnswer0": "have a Facebook page for your restaurant and be connected to a Facebook account that has \"personal\" access to this page,\n",
        "FAQNoFacebookPageAnswer1": "Click here to see how to do it",        
        "FAQNoFacebookPageAnswer2": "and an Instagram account associated with this page. \n",
        "FAQNoFacebookPageAnswer3": "Click here to see how to do it",
        "FAQVideoFormatQuestion": "What video formats can I use?",        
        "FAQVideoFormatAnswer": "Videos in .mp4 and .mov format (h.264 codec or higher) are compatible.",        
        "FAQVideoSizeQuestion": "What is the maximum size for a video?",        
        "FAQVideoSizeAnswer": "The maximum size for a video is 50 Mb.",             
        "FAQVideoRecommendedResolutionQuestion":  "What video resolution do you recommend?",         
        "FAQVideoRecommendedResolutionAnswer": "We recommend using 720 in width x 1280 in height), the best compromise between size and quality. Videos of higher resolution are automatically resized to this resolution.",
        "FAQImageRecommendedResolutionQuestion": "What image resolution do you recommend?",         
        "FAQImageRecommendedResolutionAnswer":  "We recommend using portrait format images, 9/16 for better use of space, at least 720 in width x 1280 in height for better image quality. Images of higher resolution are automatically resized to this resolution and compressed for optimal weight.",
        "FAQImageFormatQuestion": "What image formats can I use?",        
        "FAQImageFormatAnswer": "Images in .jpg, .png, .gif, .webp, .svg and .bmp format are compatible.",        
        "FAQImageSizeQuestion": "What is the maximum size for an image?",        
        "FAQImageSizeAnswer": "The maximum size for an image is 10 Mb, only the avatar is limited to 512 kb.",            
        "FAQMusicFormatQuestion": "What audio file formats can I use?",        
        "FAQMusicFormatAnswer": "Audio files in .wav, .mp3 and .m4a format are compatible.",        
        "FAQMusicSizeQuestion": "What is the maximum size for an audio file?",        
        "FAQMusicSizeAnswer": "The maximum size for an audio file is 10 Mb. Audio files with a bit rate higher than 128k and a duration longer than 30s will be automatically resized to these values for optimal weight.",
        "FAQCatUprealityOffer": "Understand the UpReality offer",
        "FAQCatUseMyStory": "🔗 Use my social landing page",
        "FAQCatMyStory": "🧑‍🍳 Create my social landing page",
        "FAQCatVideos": "📹 Videos",
        "FAQCatImages": "📷 Images",
        "FAQCatMusic": "🎶 Background music",
        "FAQCatMyStats": "📊 My stats",
        "FAQCatMyAccount": "⚙️ My account",
        "FAQCatMetaPixel": "📈 My Meta Pixel",
        "FAQMetaPixelEventsQuestion": "What events are sent to the Meta Pixel?",
        "FAQMetaPixelEventsAnswer": "When a Meta Pixel is configured on your social landing page and the visitor has accepted tracking, UpReality sends events to Meta to measure engagement and conversions from your ads. These include:\n",
        "FAQMetaPixelEventsAnswerl0": "PageView — when your social landing page is opened.",
        "FAQMetaPixelEventsAnswerl1": "ViewContent — when visitors interact with your content (menu, gallery, reviews, map, share, chat, etc.).",
        "FAQMetaPixelEventsAnswerl2": "Custom intent events — when a visitor starts a booking, order or contact (\"Book\" buttons, phone call, etc.), such as InitiateBooking, InitiateOrder or InitiateContact.",
        "FAQMetaPixelEventsAnswerl3": "Zenchef widget — if you use integrated Zenchef booking, steps in the reservation flow (calendar, party size, time slot, etc.) and the booking confirmation (Schedule) are also sent to the Meta Pixel.",
        "FAQMetaPixelEventsAnswerl4": "Widget TheFork — automatic forwarding of widget events to the Meta Pixel is not built in. If you already have a webhook to receive TheFork widget events, contact us at contact@upreality.store so we can relay those events to your webhook.",
        "Bio": "Mobile Product Manager, I was tired of navigating from one page to another in search of the right dining experience. I decided to use my knowledge in mobile technology to provide a discovery experience that makes the search as enjoyable as the moment at the table.",
        "american_restaurant": "American restaurant",
        "bakery": "Bakery",
        "bar": "Bar",
        "barbecue_restaurant": "Barbecue restaurant",
        "brazilian_restaurant": "Brazilian restaurant",
        "breakfast_restaurant" : "Breakfast restaurant",
        "brunch_restaurant": "Brunch restaurant",
        "cafe": "Cafe",
        "chinese_restaurant": "Chinese restaurant",  
        "coffee_shop": "Coffee shop",
        "fast_food_restaurant": "Fast food",
        "french_restaurant": "French restaurant",        
        "greek_restaurant": "Greek restaurant",
        "hamburger_restaurant" : "Hamburger restaurant",        
        "ice_cream_shop": "Ice cream shop",      
        "indian_restaurant": "Indian restaurant",
        "indonesian_restaurant": "Indonesian restaurant",
        "italian_restaurant": "Italian restaurant",
        "japanese_restaurant": "Japanese restaurant",
        "korean_restaurant"	: "Korean restaurant",
        "lebanese_restaurant": "Lebanese restaurant",        
        "meal_delivery": "Meal delivery",
        "meal_takeaway": "Meal takeaway",
        "mediterranean_restaurant": "Mediterranean restaurant",
        "mexican_restaurant": "Mexican restaurant",
        "middle_eastern_restaurant": "Middle eastern restaurant",
        "pizza_restaurant": "Pizza restaurant",
        "ramen_restaurant": "Ramen restaurant",
        "restaurant": "Restaurant",
        "sandwich_shop": "Sandwich shop",
        "seafood_restaurant": "Seafood restaurant",
        "spanish_restaurant": "Spanish restaurant",
        "steak_house": "Steak house",
        "sushi_restaurant": "Sushi restaurant",
        "thai_restaurant": "Thai restaurant",
        "turkish_restaurant": "Turkish restaurant",
        "vegan_restaurant": "Vegan restaurant",
        "vegetarian_restaurant": "Vegetarian restaurant",
        "vietnamese_restaurant": "Vietnamese restaurant",  
        "Allergens": "Allergens",
        "AllergensLabel": "Allergens: ",
        "Soja": "Soja",
        "Pisces": "Pisces",
        "Egg": "Egg",
        "Mustard": "Mustard",
        "Molluscs": "Molluscs",
        "Lupine": "Lupine",
        "Milk": "Milk",
        "Sesame seeds": "Sesame seeds",
        "Gluten": "Gluten",
        "Nuts": "Nuts",
        "Crustaceans": "Crustaceans",
        "Cereals": "Cereals",
        "Celery": "Celery",
        "Peanuts": "Peanuts",
        "Sulphurous anhydrous": "Sulphurous anhydrous",                  
        "KFontaineTitle" : "Marketing and Communication Director at Cardito Village Group",        
        "KFontaineTestimonial" : "UpReality permits me to give a quality overview of my 3 establishments on a daily basis! Everything is intuitive, access to our Google ratings, our offers, the redirection links. It's a real game changer for the traffic campaigns we run on Meta.",
        "KFontaineTestimonialBadge": "Conversion rate up to 8%",
        "TestimonialsTitle": "They tested, they adopted",         
        "TestimonialsSubtitle": "Discover how the immersive format of UpReality Social Landing Pages has transformed their advertising campaigns.",
        "TestimonialsSubtitleRestaurants": "Discover how the immersive format of the Social Landing Page has transformed their advertising campaigns.",
        "TestimonialsSubtitleSocial": "Discover how the immersive format of UpReality Social Landing Pages has transformed their advertising campaigns.",
        
        // Upgrade Dialog translations
        "ChooseYourPlan": "Change my plan",        
        "UpgradeToPremium": "Upgrade to Premium to optimize your Social Ads campaigns 🍹",
        "Feature": "Feature",        
        "Premium": "Premium",                
        "PremiumPlus": "Premium Plus",
        "Trial" : "Free trial",        
                "PremiumPrice": "0.04 € exc. VAT / visit",
        "PremiumPriceVAT": "Price without VAT",
        "PremiumPriceTooltip": "Anti-fraud mechanism to prevent abuse",
        "UpgradeNow": "Upgrade To Premium",        
        "UpgradeNowPlus": "Upgrade To Plus",
        "TakePremiumAgain": "Take Premium Again",
        "StayPremium": "Stay Premium",           
        "TakePremiumPlusAgain": "Take Plus Again",
        "StayPremiumPlus": "Stay Plus",
        "Downgrade": "Downgrade To Free",          
        "ChangePlan": "Change my plan",        
        "StripePortal": "My payment infos", 
        "StayFree": "Stay Free",        
        "ContinueMyTry": "Continue my trial",
        "MenuOptimized": "Optimized Menu (with updates)",
        "GoogleReviews": "Google Rating and Reviews",        
        "GoogleSync": "Google Business Sync",               
        "GoogleSyncDesc": "Rating, reviews, hours, etc.",
        "MaxStories": "20 landing pages for A/B testing",        
        "MaxRestaurants": "Limit of restaurants",
        "MaxRestaurantsFree": "1",
        "MaxRestaurantsPremium": "10",
        "MaxRestaurantsPremiumPlus": "50",
        "AckUpgraded": "Your plan has been upgraded to Premium.",          
        "AckUpgradedPlus": "Your plan has been upgraded to Premium Plus.",
        "AckDowngraded": "Your premium subscription has been successfully canceled. You will continue to enjoy its benefits for the month.",
        "MyPlan": "My current plan",
        "Until": " (until {{date}})",
        "Admin" : "Admin",

        "lundi": "Monday",
        "mardi": "Tuesday",
        "mercredi": "Wednesday",
        "jeudi": "Thursday",
        "vendredi": "Friday",
        "samedi": "Saturday",
        "dimanche": "Sunday",
        
        "Open": "Open",
        "Closed": "Closed",
        "AddPeriod": "Add a period",
        "SaveHours": "Save",
        "hve": "Haute Valeur Environnementale",
        "bio-coherence": "Bio Cohérence",
        "organic": "Bio Européen",
        "biodyvin": "Biodyvin",
        "demeter": "Demeter",
        "nature-progres": "Nature & Progrès",
        "avn": "Association des Vins Naturels",
        "vigneron-independant": "Vigneron Indépendant",
        "terra-vitis": "Terra Vitis",
        "bio": "Agriculture Biologique",
        "methode-nature": "Vin Méthode Nature",
        "sains": "SAINS",
        "PricingChoosePlan": "Choose your plan",
        "PricingFindSolution": "Find the solution for your needs.",
        "PricingAudience": "For restaurants and food agencies",
        "PricingDiscovery": "Discovery",
        "PricingFree": "Free",
        "PricingForever": "Forever",
        "PricingDiscoveryDesc": "The social version of your website.",        
        "PricingFeature1": "Without Google rating and reviews",
        "PricingFeature2": "File or image gallery menu",
        "PricingFeature3": "1 single social landing page",     
        "PricingFeature4": "Entering from Google without syncing",
        "PricingFeature5": "",
        "PricingStartFree": "Start for free",
        "PricingPremium": "Premium",
        "PricingPremiumPrice": "0.04 € exc. VAT",
        "PricingPremiumSub": "/ visit",
        "PricingPremiumAnnually": "You only pay when you use it",
        "PricingPremiumDesc": "Maximize your Social Ads campaigns!",
        "PricingPremiumFeature1": "Google rating and reviews integrated",
        "PricingPremiumFeature1Desc": "",
        "PricingPremiumFeature2": "Optimized Menu (with updates)",
        "PricingPremiumFeature2Desc": "",
        "PricingPremiumFeature3": "Up to 20 landing pages for 10 restaurants",
        "PricingPremiumFeature3Desc": "",
        "PricingPremiumFeature4": "Google Business Sync",
        "PricingPremiumFeature4Desc": "Rating, reviews, hours, etc.",
        "PricingPremiumFeature5": "",
        "PricingChoosePremium": "Choose Premium",
        "PricingTrialButton": "Try free (30 days)",
        "PricingChainTitle": "Restaurant chain",
        "PricingChainAudience": "For restaurant chains",
        "PricingChainPrice": "Custom",
        "PricingChainSubtitle": "Based on your locations",
        "PricingChainFeature3": "Up to 20 landing pages",
        "PricingChainFeature5Quote": "\"Find my restaurant\"",
        "PricingChainFeature5Suffix": "built in",
        "PricingChainTrialNote": "Free 30-day trial (setup fees may apply)",
        "InSocialAdsGivesAbout": "in Social Ads gives about",
        "ForABudgetOf": "A budget of",
        "Visits": "visits.",
        "ForACostOf": "For ",
        "BudgetCalculationTooltip": "Calculation based on an average CPM of €11.66 and a CTR of 0.84%",
        "WeAimToHelpYouEarn": ", we aim ",
        "InReservations": " less in CPA",
        "ConversionRateImprovementTooltip": "Calculation based on a reservation rate improvement of 0.5%",
        "CannotDeleteAccountWithPremium": "You cannot delete your account while you have a premium subscription.",
        "RoasCalculatorTitle": "ROAS Calculator",
        "RoasCalculatorParameters": "Your advertising parameters",
        "RoasCalculatorBudgetLabel": "Social Ads Budget (€)",
        "RoasCalculatorCpcLabel": "CPC - Cost per click (€)",
        "RoasCalculatorReservationRateLabel": "Reservation rate website (%)",
        "RoasCalculatorAvgBasketLabel": "Basket per reservation (€)",
        "RoasCalculatorCpaLabel": "CPA - Cost per acquisition (€)",
        "RoasCalculatorCurrentResult": "A social ads budget of <strong style=\"color: #2FC4B5\">{{budget}} €</strong> generates <strong style=\"color: #2FC4B5; font-size: 1.1rem\">{{initialRevenue}} €</strong> in reservations <strong style=\"color: #2FC4B5\">(ROAS: {{roas}}:1)</strong>.",
        "RoasCalculatorCurrentResultCpa": "A social ads budget of <strong style=\"color: #2FC4B5\">{{budget}} €</strong> generates <strong style=\"color: #2FC4B5; font-size: 1.1rem\">{{initialRevenue}} €</strong> in reservations <strong style=\"color: #2FC4B5\">(ROAS: {{roas}}:1)</strong>.",
        "RoasCalculatorWithUpReality": "With UpReality",
        "RoasCalculatorImprovement": "UpReality targets a <strong>20% reservation rate improvement</strong> (compared to your website).",
        "RoasCalculatorImprovementCpa": "UpReality targets a <strong>20% reservation rate improvement</strong> (compared to your website).",
        "RoasCalculatorImprovedResult": "The same social ads budget generates <strong style=\"color: #2FC4B5; font-size: 1.15rem\">{{improvedRevenue}} €</strong> in reservations <strong style=\"color: #2FC4B5\">(ROAS: {{improvedRoas}}:1)</strong>, i.e. <strong style=\"color: #2FC4B5\">{{additionalRevenue}} € more</strong> for an UpReality cost of <strong style=\"color: #2FC4B5\">{{uprealityCost}} €</strong>.",
        "CalculateMyNewRoas": "Calculate my new ROAS"
    }
  },
  fr: {
    translation: {
        "ProductPageTitle": "Upreality - La landing page sociale de votre restaurant !",
        "ProductPageAdTitle": "Upreality - La landing page du réseau social 🍹",
        "Yes": "Oui",
        "No": "Non",
        "Infos": "Infos",
        "OpeningStatus":"Ouvert · Ferme à",
        "ClosedStatus": "Fermé · Ouvre à",
        "MoreInfos": "Plus d'infos",
        "CGoogle": "données ©Google",
        "GO": "Y ALLER",
        "BOOK": "RÉSERVER",
        "SAVE": "ENREGISTRER",
        "ShareTitle": "Envie de sortir au restaurant ?",
        "ShareText": "Le lien vers le site web social de {{name}} : ",
        "ShareTextDefaultName": "\"Restaurant non encore choisi\"",
        "BookTable": "Réserver une table",
        "Contact": "Contactez-nous",
        "BookTableInfo": "ou contactez-nous !",
        "BookTableInfoEmoji": "📅",
        "ContactInfoEmoji": "💬",
        "OrderInfoEmoji": "🛵",
        "ShareEmoji": "👋",
        "Apply": "Rejoignez l'aventure",
        "ApplyEmoji": "🚀",
        "BookOnline": "en ligne",
        "BookPhone": "par téléphone",
        "BookEmail": "par email",
        "BookChat": "par chat",
        "BookEmailSubject": "Réserver",
        "ShareEmail": "par email",
        "ShareFacebook": "avec Facebook",
        "ShareCopy": "copier dans le presse-papier",
        "ShareOther": "autres moyens",
        "OrderOn": "Commander",
        "ContactBy": "Contactez-nous",        
        "OrderMeal": "Commander",
        "VirtualTourTitle": "ambiance",
        "MediasGalleryTitle": "menu",
        "MenusTitle": "menus",
        "DishesGalleryTitle": "plats",
        "PromotionTitle": "réveillon",
        "TouchToPlay": "Touchez pour jouer !",
        "BookButton": "réserver",
        "ContactButton": "contacter",
        "OrderButton": "commander",
        "ShareButton": "partager",
        "ShareShareButton": "partager",
        "ChatButton": "chat ia",
        "NearButton": "proche",
        "PromoButton": "promo",
        "NearbyAttractions": "Attractions proches",
        "InfluencerButton": "a aimé",
        "ApplyButton": "candidater",
        "ShareDialogTitle": "Proposer à un ami",
        "Free": "gratuit",
        "Hours": "Horaires",
        "HoursSubtitle": "7 prochains jours",
        "HoursInfoExtended": "horaires étendus sur certains restaurants",
        "Scroll": "Scroll",
        "HAPPY_HOUR": "Happy hours",
        "BREAKFAST": "Petit-déjeuner",
        "BRUNCH": "Brunch",
        "LUNCH": "Déjeuner",
        "DINNER": "Dîner",     
        "DRIVE_THROUGH": "Drive",
        "DELIVERY": "Livraison",
        "TAKEOUT": "À emporter",
        "KITCHEN": "Cuisine",
        "PICKUP": "Click & collect",
        "SENIOR_HOURS": "Heures senior",   
        "Reviews": "avis",
        "Location": "Y aller",
        "OpenOnGoogleMaps": "Ouvrir sur Google Maps",
        "ChainChangeRestaurant": "Changer de restaurant",
        "ChainChooseRestaurant": "Choisissez votre restaurant",
        "ChainChooseButton": "Choisir",
        "ChainLocationPlaceholder": "Code postal ou ville",
        "ChainSearchRestaurants": "Rechercher",
        "ChainSearching": "Recherche…",
        "ChainNoRestaurantNearby": "Aucun restaurant à moins de 20 km",
        "ChainGeocodeError": "Lieu introuvable",
        "ChainGeolocation": "Ma position",
        "ChainGeolocationDenied": "Accès à la localisation refusé",
        "ChainGeolocationUnavailable": "Position indisponible",
        "ChainGeolocationTimeout": "Délai de localisation dépassé",
        "ChainGeolocationUnsupported": "Géolocalisation non prise en charge",
        "ChainGeolocationError": "Impossible d'obtenir votre position",
        "ChainRestaurantDistance": "{{distance}} km",
        "ChainDemoVersionHint": "version démo",
        "Close": "Fermer",
        "StoryBgDesc": "Decor",
        "RestaurantContent": "Contenu media du restaurant",
        "TouchToPlay": "Toucher pour jouer !",
        "SparklesAlt": "étincelles",
        "StoryOverlayAlt": "voile vidéo",
        "InstagramAlt": "Instagram",
        "InstagramAvatarAlt": "avatar Instagram",
        "DeadEndAlt": "impasse",
        "HolbertonProgramAlt": "programme Holberton",
        "PhoneFrameAlt": "cadre de téléphone",
        "FromInstagramProfileAlt": "profil Instagram",
        "SpacerAlt": "espacement",
        "ArrowHintAlt": "flèche d'indication",
        "BetaRibbonAlt": "ruban bêta",
        "StatsPagePreviewAlt": "aperçu des statistiques",
        "StoryMakerPagePreviewAlt": "aperçu de création de story",
        "WebsitePagePreviewAlt": "aperçu de page web",
        "AppPreviewAlt": "aperçu de l'app",
        "NearbyAttractionsAlt": "lieux à proximité",
        "PromoAlt": "promotion",
        "RestaurantAvatarAlt": "avatar du restaurant",
        "RestaurantAvatarPlaceholderAlt": "avatar du restaurant par défaut",
        "ErrorImageAlt": "le plat est raté",
        "GoogleAlt": "Google",
        "VideoContentAlt": "contenu vidéo",
        "MenuFileTypeAlt": "type de fichier du menu",
        "CookingWearAlt": "tenue de cuisine",
        "FullScreenPromotionAlt": "promotion plein écran",
        "FullScreenContentAlt": "contenu plein écran",
        "FullScreenMenuPageAlt": "page de menu en plein écran",
        "LineSeparatorAlt": "séparateur",
        "InstagramPostAlt": "publication Instagram",
        "StoryThumbnailAlt": "miniature de story",
        "EmptyKitchenAlt": "rien dans la cuisine",
        "MenuHeaderStyleAlt": "style d'en-tête du menu",
        "AvatarAlt": "avatar",
        "TestimonialImageAlt": "Témoignage {{num}}",
        "MuteSound": "Couper le son",
        "UnmuteSound": "Activer le son",
        "Previous": "Précédent",
        "Next": "Suivant",
        "Star": "étoile",
        "Menu": "Carte",
        "Click": "cliquez",
        "Here": "ici",
        "ToRead": "pour lire",
        "Menus": "Formules",
        "Starter": "Entrées",
        "MainCourse": "Plats",
        "Dessert": "Desserts",
        "Wine": "Vins",
        "EndingPage": "Note",
        "SignaturesDishes": "Plats Signature",
        "Nutrients": "Valeurs nutritionnelles",
        "Saving": "Enregistrement...",
        "Saved": "Enregistré à ",
        "ChooseRestaurant": "Mon restaurant",
        "ChooseRestaurantOr": "OU",
        "Login": "Me connecter",
        "CreateAccount": "Créer un compte",
        "AlreadyRegistered": "Déjà enregistré ?",
        "PlaceholderAutocompleaterHelp": "Saisissez le nom de votre restaurant pour que votre landing page sociale soit configurée automatiquement",
        "MultipleRestaurantsHelp1": "Vous souhaitez une unique landing page sociale pour plusieurs restaurants (exemple : chaîne de restaurant), ",
        "MultipleRestaurantsHelp2": "contactez-nous à contact@upreality.store !",
        "MultipleRestaurantsMailSubject": "Landing page sociale multi-restaurants",
        "PlaceholderAutocompleater": "le nom de mon restaurant",
        "PlaceholderRestaurantType": "mon type de restaurant (ex : bistro, etc.)",
        "PlaceholderRestaurantArea": "mon quartier ou mon adresse",
        "PlaceholderRestaurantName": "mon restaurant",
        "PlaceholderPhone": "mon no de téléphone",
        "PlaceholderChatMsg": "mon message d'accueil 😊",
        "ChooseRestaurantToStickers": "Stickers > ",
        "MyRestaurant": "Mon restaurant",
        "MyLogo": "Mon logo",
        "ChooseMyLogo": "Choisir mon logo",
        "MyMusic": "Ma musique d'ambiance",
        "ChooseMyMusic": "Ma Musique d'ambiance",
        "SyncVideoWithMusic": "Synchroniser vidéo et son",
        "SyncVideoWithMusicTooltip": "En synchronisé, la musique s'arrête lorsque vous consultez une rubrique.",
        "ExtractingMusic" : "extraction",
        "LogoInstagram": "celui d'Instagram",
        "FromInstagram": "depuis Instagram",
        "Or": "ou",
        "FromTheWeb": "depuis le web",
        "PasteWebLink": "collez ici votre lien web",
        "FromMyComputer": "depuis mon ordinateur",
        "Ok": "Ok",
        "YourColors": "Mes couleurs",
        "PrimaryColorBg": "fond",
        "PrimaryColorTxt": "texte",
        "PreviewButtonLabel": "aperçu",
        "ThemeToChooseRestaurant": " < 1. Infos",             
        "MyStickers": "Mes stickers",
        "StickersToRestaurant": " < 1. Cadre",
        "StickersToActions": "3. Actions > ",
        "RestaurantStoreFront": "🪟 Mon cadre",
        "ChooseMyStoreFront": "Choisir mon décor",
        "ChooseMyStoreFrontHelp": "vidéo courte ou image",
        "ChooseMyStoreFrontRecommendationTitle": "Recommandation :",
        "ChooseMyStoreFrontRecommendationBody": "🎬 Même vidéo que sur votre campagne Meta Ads\n\nou\n\n✨ Image de vitrine animée par IA (faire parler les gens attablés ou ajouter du vent aux plantes et au store)",
        "AddReviews": "Ajouter mes avis Google ⭐",
        "ChooseMyHours": "Mettre à jour mes horaires",
        "ChooseMyHoursDialog": "Mettre à jour mes horaires 🕰️",
        "ChooseMyHoursDialogHelp": "Synchroniser avec Google Business ⭐",
        "ChooseMyInside": "Choisir mes contenus d'ambiance",
        "ChooseMyInsideHelp": "vidéo courte ou image (2 max)",
        "ChooseMyPlates": "Ajouter un contenu",
        "ChooseMyPlatesHelp": "vidéo courte ou image (4 max)",
        "ChooseMyPlatesHelp2": "photo ou vidéo courte",
        "RestaurantInside": "🖼️ Mes contenus d'ambiance",
        "RestaurantInsideMax": "2 contenus maximum",
        "PlatesPreview": "Aperçu des plats (+ équipe)",
        "PlatesPreviewMax": "4 contenus maximum",
        "ExternalMenu": "Menu externe",
        "GalleryMenu": "Gallerie",
        "OptimizedMenu": "Menu intégré",
        "AskForMenu": "Demander mon menu",
        "MyActions" : "Mes actions", 
        "BookButtonTitle": "📅 Réserver / Commander / Contacter",
        "SocialWebsiteConfig": "⚙️ Ma landing page sociale", 
        "InfluenceAndPromotions": "📣 Influence & promotions", 
        "AddMyMenu" : "🍽️ Mon menu",
        "AddMyMenuDialog" : "Ajouter mon menu 🍽️",
        "AddMyMenuEN" : "Ajouter mon menu en anglais 🍽️",
        "AddMyMenuENDialog" : "Ajouter mon menu en anglais 🍽️",
        "AddMyMenuHelp" : "page web, image ou PDF",  
        "AddSymbolFR": "FR",
        "AddSymbolEN": "EN",
        "AddMyDayMenu" : "Ajouter mon menu du jour",
        "AddMyDayMenuDialog" : "Ajouter mon menu du jour 📋",
        "ActionsToStickers": " < 2. Stickers",
        "MenuToUse": "4. Utiliser > ",
        "UseItToMenu": " < 3. Actions",
        "ConfigureMyPixels": "Configurer mon pixel" /* "Configurer mes pixels" */,
        "ConfigureMyPixelsHelp": "Toutes les actions sont tagguées par défaut",
        "ConfigureMyPixelsDialog": "Configurer mon pixel ⚙️" /* "Configurer mes pixels ⚙️" */,
        "ConfigureMyPixelsMetaAbTestWarning": "Privilégiez la stratégie budget au niveau de l’ensemble de publicités (ABO) plutôt que budget campagne (CBO).<br/>Meta peut favoriser automatiquement le site disposant du plus fort historique de conversion et sous-diffuser un domaine encore peu utilisé.",
        "ConfigureMyPixelsMetaAbTestTogglePrompt": "⚠️ Vous commencez par AB Tester la solution ?",
        "ConfigureMyPixelsNoPixelIdea": "Ne pas renseigner d’ID pixel permet aux visiteurs de ne pas voir de popup de consentement. Vous conservez pour le retargeting les utilisateurs qui ont cliqué sur la publicité, et vous pouvez retrouver ceux qui ont effectivement commandé via le widget de réservation.",
        "ConfigureMyPixelsNoPixelIdeaTogglePrompt": "💡 Pixel = popup de consentement, vraiment utile ?",
        "ConfigureInfluencerButtonDialog": "Avis d'influenceur",
        "ConfigureInfluencerButtonHelp": "Configurez le contenu du bouton influenceur",
        "ConfigureNearButtonDialog": "Attractions proches",
        "ConfigureNearButtonHelp": "Configurez le contenu des attractions à proximité",
        "ConfigurePromoButtonDialog": "Ajouter une promo",
        "ConfigurePromoButtonHelp": "Configurez le contenu de la promotion",
        "EditorAddLink": "Ajouter un lien",
        "EditorRemoveLink": "Retirer le lien",
        "EditorLinkUrlPrompt": "Saisissez l'URL",
        "EditorTextColor": "Couleur du texte",
        "EditorTextColorReset": "Réinitialiser la couleur",
        "EditorFontSize": "Taille du texte",
        "EditorFontSizeDefault": "Taille",
        "Title": "Titre",
        "InfluencerName": "Nom de l'influenceur",
        "Description": "Description",
        "NearbyAttractions": "Attractions à proximité",
        "SelectImage": "Sélectionner une image",
        "ChangeImage": "Changer l'image",
        "RemoveImage": "Supprimer l'image",
        "SelectImageAbove": "Sélectionner l'image ci-dessus",
        "ErrorUploadingImage": "Erreur lors du téléchargement de l'image",
        "ReformatWithGenAI": "Reformatter avec le GenAI",
        "Reformatting": "Reformatage...",
        "TranslateFromFR": "Traduire depuis FR",
        "TranslateFromEN": "Traduire depuis EN",
        "Translating": "Traduction...",
        "NoSourceText": "Aucun texte à traduire dans la langue source",
        "TextTooLong": "Le texte ne doit pas dépasser 800 caractères",
        "FrenchVersion": "Version française",
        "EnglishVersion": "Version anglaise",
        "TipTapGenAIHint": "Essayer le bouton de reformatage GenAI pour vous créer un brouillon ou améliorer votre texte ✨",
        "PromoType": "Type de promo",
        "TextPromo": "Promo texte",
        "ImagePromo": "Promo image",
        "GetTheOffer": "Obtenir l'offre",
        "PromoOfferLinkHint": "lien coupon (deep link ou pdf)",
        "PromoOfferLinkHelp": "Optionnel.",
        "Meta": "ID pixel Meta",
        "TikTok": "TikTok",        
        "CycleBudgetVisitsHelper": "Correspond à {{visits}} visites",        
        "CreateNewSocialWebsiteErrorDialogTitle" : "Créer une landing page sociale",
        "AcceptSocialWebsiteErrorDialogTitle" : "Accepter un transfert",
        "CreateNewSocialWebsiteErrorDialogText": "Vous avez atteint votre maximum de {{maxStory}} landing pages sociales.",
        "CreateNewSocialWebsiteRestaurantErrorDialogText": "Vous avez atteint votre maximum de {{maxRestaurant}} restaurants.",
        "aliasAlreadyExists": "alias déjà utilisé",
        "aliasNotValid": "lettres, chiffres et -",
        "Congratulation": "Félicitations 🍾",
        "StoryLink": "Mon lien web",
        "StoryLinkInfo": "ou votre nom de domaine sur demande\nexemple : social.mondomaine.com",
        "AppearOnSearchEngines": "Apparaître sur les moteurs de recherche",
        "CopyLink": "Copier le lien",
        "PossibleUsages": "Où m'utiliser ?",
        "SocialeProfile": "Profil social : en lien site web",        
        "SocialAds": "Publicité sociale : en lien action",
        "Website": "en QR Code ou Site Web à part entière",
        "SaveWork": "Sans compte UpReality, votre landing page sociale sera supprimée au bout de 1 mois.",
        "Save": "Créer un compte",
        "MyStorys": "Mes Landing Pages",
        "ChooseMyCover": "Ajouter une couverture",        
        "MenuTitleColor": "Couleur du titre",
        "MenuTitleExample": "Entrée",
        "Cancel": "Annuler",
        "Confirm": "Valider",
        "Elegant": "Élégant",
        "Friendly": "Friendly",
        "Modern": "Moderne",
        "Simple": "Simple",
        "Custom": "Custom",
        "OptimMyMenu": "Format optimisé pour mobile",
        "OptimMyMenuHelp": "carte de moins de 50 éléments",
        "InfoOptimMyMenu": "Connectez-vous pour activer le format optimisé",
        "InfoMenuUpdated": "Votre menu sera mis à jour dans les plus brefs délais, attendez notre retour pour republier votre landing page sociale.",
        "InfoAskForMenuPreparing": "Votre menu est en cours de préparation et sera disponible dans quelques jours. Vous serez prévenu par email.",
        "InfoAskForMenuPreparingTrialExtended": "Votre menu est en cours de préparation et sera disponible dans quelques jours. Vous serez prévenu par email. Votre essai gratuit a été prolongé de 7 jours.",
        "InfoMenuPreviewOptimization": "Menu en cours d'optimisation...\nLe lien ou le fichier d'origine s'affichera dans un nouvel onglet jusque-là.",
        "OptimStatus": "demandé le {{date}}",
        "OptimMenuVersion": "version du {{date}}",
        "OptimMenuUpdateRequested": "mise à jour demandée le {{date}}",
        "UpdateMyMenu": "Mettre à jour",
        "UpdateMyMenuDialog": "Mettre à jour mon menu 🍽️",
        "MenuPreview": "Aperçu du style : ",
        "DishImages": "Images des plats et correspondances",
        "Optional": "(optionnel)",
        "SendWithWeTransfer": "Envoyer avec WeTransfer",
        "LoginForOptimizedFormatp1": "Logguez-vous",
        "LoginForOptimizedFormatp2": " pour accéder au format optimisé",
        "ChooseYourMenuStyle": "Changer de style",
        "MenuStyle": "Style de la carte",
        "MenuStyleHelp": "n'apparaît que si vous ajoutez un contenu dans \"Aperçu des plats\"",
        "CoverStyle": "Style de la couverture",
        "ChooseYourMenuColor":  "Couleur de personnalisation",        
        "ChooseYourMenuCustom" : "Je veux mon propre style sur le modèle de mon menu existant.",
        "ChooseYourMenuCustomAlreadyFormated" : "Mon menu custom déjà mis en page.",
        "ChooseStyleValidationHelp1": "Votre carte sera mise en page sous un délai de quelques jours. Essayez-la en cliquant sur le sticker \"menu\" de votre landing page sociale.",
        "ChooseStyleValidationHelp2": "Vous pouvez utiliser votre landing page sociale dès maintenant, la carte sera consultable sous la forme du fichier ou de la page d'origine jusque-là.",
        "MyStories": "Mes Landing Pages",  
        "MenuEditor": "Editer un menu",
        "CreateDemo": "Créer démo",
        "CreateDemoSubtitle": "Crée ou modifie un document dans la collection demos (feed ou reel).",
        "CreateDemoJsonTitle": "Préremplir depuis un JSON",
        "CreateDemoJsonPlaceholder": "{\"pageName\":\"demo-cafe\",\"pageAvatar\":\"https://.../avatar.png\",\"instagramProfile\":\"https://www.instagram.com/demo/\",\"storyId\":\"CafeUpRealityAd\",\"menuId\":\"...\",\"contentFormat\":\"reel\",\"mediaType\":\"video\",\"mediaUrl\":\"https://...\",\"width\":1080,\"height\":1920,\"adText\":\"Texte de l’annonce\",\"ctaText\":\"En savoir plus\",\"ctaLink\":\"/p/CafeUpRealityAd\"}",
        "CreateDemoApplyJson": "Appliquer le JSON",
        "CreateDemoJsonApplied": "Formulaire prérempli depuis le JSON",
        "CreateDemoJsonInvalid": "JSON invalide",
        "CreateDemoOpenDemoFeed": "Ouvrir la page DemoFeed",
        "CreateUseCasesOpen": "Créer « Cas d'usage »",
        "CreateUseCasesOpenPage": "Ouvrir la page cas d’usage",
        "CreateUseCasesOpenStorefrontVideo": "Ouvrir la vidéo vitrine (dev)",
        "UseCasesYourCreativeContent": "Votre contenu créatif !",
        "CreateUseCasesBack": "← Retour à Créer démo",
        "CreateUseCasesTitle": "Créer Cas d'usage",
        "CreateUseCasesSubtitle": "À partir de la démo « {{pageName}} » (nom de page, avatar et couleur CTA).",
        "CreateUseCasesRestaurantName": "Nom du restaurant",
        "CreateUseCasesRestaurantNameHint": "Affiché en haut à droite de la page cas d’usage. Vide = nom de page.",
        "CreateUseCasesSaveHint": "Firestore usecases/{demoId} ; médias copiés dans Storage demos/ (ignoré si déjà un lien Storage).",
        "CreateUseCasesReorderHint": "Glisse les cartes ou utilise les flèches pour réordonner. Cet ordre est repris sur la page cas d’usage après enregistrement.",
        "CreateUseCasesReorderDrag": "Glisser pour réordonner",
        "CreateUseCasesMoveUp": "Monter",
        "CreateUseCasesMoveDown": "Descendre",
        "CreateUseCasesSave": "Enregistrer cas d'usage",
        "CreateUseCasesSaving": "Enregistrement…",
        "CreateUseCasesSaveSuccess": "Cas d’usage enregistrés",
        "CreateUseCasesSaveError": "Impossible d’enregistrer les cas d’usage",
        "CreateUseCasesLoadError": "Impossible de charger les cas d’usage",
        "CreateUseCasesLoading": "Chargement des cas d’usage…",
        "CreateUseCasesNeedDemo": "Sélectionne d’abord une démo",
        "CreateUseCasesNeedPageName": "Le nom de page est requis pour copier les médias vers Storage",
        "CreateUseCasesNothingToSave": "Rien à enregistrer — applique d’abord un JSON avec des médias",
        "CreateUseCasesJsonTitle": "Charger 4 contenus depuis un JSON",
        "CreateUseCasesJsonExpand": "Afficher le champ JSON",
        "CreateUseCasesJsonPlaceholder": "{\"generatedAt\":\"…\",\"count\":4,\"ads\":[{\"demoSlot\":\"promo_image\",\"demoLabel\":\"…\",\"mediaUrl\":\"…\",\"mediaType\":\"image\",\"adText\":\"…\",\"ctaText\":\"En savoir plus\",\"ctaLink\":\"https://…\"}, …]}",
        "CreateUseCasesJsonApplied": "4 cas d’usage chargés depuis le JSON",
        "CreateUseCasesJsonNeedAds": "Le JSON doit être un objet avec un tableau « ads » (ou un tableau d’ads)",
        "CreateUseCasesJsonEmpty": "Le tableau ads est vide",
        "CreateUseCasesJsonUnitaryHelp": "JSON unitaire (1 ad) : colle-le ci-dessus, puis « Recharger ce cas » sur le slot cible. L’ancien média demos/ et l’avatar preuve sociale sont supprimés du Storage.",
        "CreateUseCasesJsonUnitaryHint": "Ce JSON ressemble à un seul ad — utilise « Recharger ce cas » sur le slot cible",
        "CreateUseCasesJsonUnitaryApply": "Recharger ce cas depuis le JSON",
        "CreateUseCasesJsonUnitaryReloading": "Rechargement…",
        "CreateUseCasesJsonUnitaryApplied": "Cas « {{label}} » rechargé (anciens fichiers Storage retirés si besoin)",
        "CreateUseCasesJsonUnitaryInvalid": "Colle un JSON d’un seul ad (objet avec mediaUrl / adText)",
        "CreateUseCasesJsonUnitaryNeedMedia": "Le JSON unitaire doit contenir mediaUrl",
        "CreateUseCasesJsonUnitaryError": "Impossible de recharger ce cas",
        "CreateUseCasesSlotFallback": "Cas d’usage {{n}}",
        "CreateUseCasesSlotTitle": "Titre",
        "CreateUseCasesSlotTitleHint": "Affiché comme titre du cas sur la page cas d’usage.",
        "UseCaseSlotRestaurantPresentation": "Vidéo sans parole",
        "UseCaseSlotSocialProof": "Collaboration influenceur",
        "UseCaseSlotDishMenu": "Vidéo de promotion",
        "UseCaseSlotPromoOffer": "Image de promotion",
        "CreateUseCasesAdText": "Texte de l’annonce",
        "CreateUseCasesSocialAuthorName": "Nom influenceur / auteur",
        "CreateUseCasesSocialAuthorNameHint": "Affiché devant dans le collab (author3). Vide = nom de la page.",
        "CreateUseCasesSocialAvatarUrl": "URL avatar preuve sociale",
        "CreateUseCasesSocialAvatarHint": "Non rempli depuis le JSON. Charge depuis Instagram ; miroir Storage à l’enregistrement.",
        "CreateUseCasesSocialAvatarIgLoad": "Charger avatar depuis Instagram",
        "CreateUseCasesSocialAvatarIgLoading": "Récupération avatar Instagram…",
        "CreateUseCasesSocialAvatarIgSuccess": "URL avatar collée — enregistre les cas d’usage pour la stocker sur Storage",
        "CreateUseCasesSocialAvatarIgError": "Impossible de récupérer l’avatar Instagram",
        "CreateUseCasesSocialAvatarIgNeedProfile": "Saisis une URL de profil Instagram valide",
        "CreateUseCasesSocialAvatarIgDialogTitle": "Profil Instagram à scraper",
        "CreateUseCasesSocialAvatarIgDialogHint": "Colle l’URL de la page profil dont l’avatar doit servir pour ce cas preuve sociale.",
        "CreateUseCasesSocialAvatarIgProfileLabel": "URL du profil Instagram",
        "CreateUseCasesSocialAvatarIgConfirm": "Charger l’avatar",
        "CreateUseCasesSponsorName": "Nom du sponsor (collab)",
        "CreateUseCasesSponsorNameHint": "Active le layout collab Instagram : « auteur et sponsor ». Suggestion : nom de la page.",
        "CreateUseCasesSponsorAvatarUrl": "URL avatar sponsor",
        "CreateUseCasesSponsorAvatarHint": "Affiché derrière l’avatar auteur. Vide → avatar de la démo.",
        "CreateUseCasesSponsorUsePageAvatar": "Utiliser l’avatar de la page",
        "CreateUseCasesInfluencerGenerate": "Transcript vidéo",
        "CreateUseCasesInfluencerGenerating": "Transcription en cours…",
        "CreateUseCasesInfluencerNeedVideo": "Une URL vidéo est requise pour ce cas d’usage",
        "CreateUseCasesInfluencerSuccess": "Transcript prêt — enregistre les cas d’usage pour le conserver",
        "CreateUseCasesInfluencerError": "Impossible de transcrire la vidéo",
        "CreateUseCasesInfluencerTranscript": "Transcript influenceur",
        "CreateUseCasesInfluencerTranscriptHint": "Enregistré avec les cas d’usage. Non écrit sur la story, non envoyé à reformatWithGenAI.",
        "CreateUseCasesStoryLabel": "Story (cadre droite page cas d’usage)",
        "CreateUseCasesStoryPlay": "Ouvrir la story dans un nouvel onglet",
        "CreateUseCasesStoryMain": "Story principale",
        "CreateUseCasesStoryAlt": "Alternative {{n}} ({{storyId}})",
        "CreateUseCasesStoryAltNamed": "Alternative {{n}} — {{alias}} ({{storyId}})",
        "CreateUseCasesCtaDestHint": "Le CTA du simulateur n’est pas cliquable (ctaDest=aucun). Le lien CTA est conservé pour une future sauvegarde.",
        "CreateDemoSelectLabel": "Démo existante",
        "CreateDemoSelectExisting": "Choisir une démo",
        "CreateDemoNewOption": "Nouvelle démo",
        "CreateDemoLoading": "Chargement des démos…",
        "CreateDemoLoadError": "Impossible de charger les démos",
        "CreateDemoEditingHint": "Édition de « {{pageName}} ». Enregistrer mettra à jour ce document.",
        "CreateDemoCreatingHint": "Création d’une nouvelle démo. Enregistrer ajoutera un document.",
        "CreateDemoPageName": "Nom de page",
        "CreateDemoPageAvatar": "URL de l’avatar de page",
        "CreateDemoInstagramProfileSection": "Profil Instagram",
        "CreateDemoPlayerSection": "Player UpReality",
        "CreateDemoSocialAdSection": "Social Ad",
        "CreateDemoInstagramProfile": "URL du profil Instagram",
        "CreateDemoFromInstagram": "Depuis Instagram",
        "CreateDemoFindInstagram": "Chercher le profil Instagram sur le site du restaurant",
        "CreateDemoFindInstagramSuccess": "Profil Instagram ajouté",
        "CreateDemoFindInstagramError": "Impossible de chercher le profil Instagram",
        "CreateDemoFindInstagramNotFound": "Aucun profil Instagram trouvé sur le site du restaurant",
        "CreateDemoFindInstagramNoWebsite": "Cette story n’a pas de site web",
        "CreateDemoOpenInstagramProfile": "Ouvrir le profil Instagram",
        "CreateDemoUpdateFromInstagram": "MAJ depuis Instagram",
        "CreateDemoUpdateFromInstagramUpdating": "Récupération depuis Instagram…",
        "CreateDemoUpdateFromInstagramSuccess": "Avatar mis à jour depuis Instagram",
        "CreateDemoUpdateFromInstagramError": "Impossible de récupérer l’avatar Instagram",
        "CreateDemoUpdateFromInstagramNeedName": "Le nom de page ou le story ID est requis",
        "CreateDemoStoryId": "Story ID",
        "CreateDemoAltCreateButton": "Créer une story alternative",
        "CreateDemoAltCreating": "Création de l’alternative…",
        "CreateDemoAltListTitle": "Alternatives",
        "CreateDemoAltLoading": "chargement…",
        "CreateDemoAltListEmpty": "Aucune alternative pour l’instant.",
        "CreateDemoAltConfirm": "Créer l’alternative alt{{n}} à partir de « {{storyId}} » ?\n(story + menu, URLs médias partagées)",
        "CreateDemoAltSuccess": "Alternative créée : {{storyId}} (menu {{menuId}})",
        "CreateDemoAltError": "Impossible de créer la story alternative",
        "CreateDemoAltMaxReached": "Maximum de 3 alternatives atteint",
        "CreateDemoAltAliasTaken": "L’alias de l’alternative est déjà pris",
        "CreateDemoAltExists": "Cette alternative existe déjà",
        "CreateDemoAltMenuError": "Impossible de dupliquer le menu de l’alternative",
        "CreateDemoAltEditButton": "Modifier",
        "CreateDemoAltEditTitle": "Modifier {{storyId}}",
        "CreateDemoAltEditVideoUrl": "URL vidéo / image",
        "CreateDemoAltEditHint": "Les médias sont copiés dans Storage sous restaurants/…/{storyId}/. Le tag apparaît en ?tag1text=… sur la page cas d’usage.",
        "CreateDemoAltEditLoading": "Chargement de la story…",
        "CreateDemoAltEditSaving": "Enregistrement…",
        "CreateDemoAltEditUploading": "Upload du fichier…",
        "CreateDemoAltEditSave": "Enregistrer",
        "CreateDemoAltEditUrlRequired": "L’URL vidéo / image est requise",
        "CreateDemoAltEditLoadError": "Impossible de charger la story alternative",
        "CreateDemoAltEditSuccess": "Alternative {{storyId}} mise à jour",
        "CreateDemoAltEditError": "Impossible de mettre à jour l’alternative",
        "CreateDemoAltEditUploadError": "Impossible d’uploader le fichier",
        "CreateDemoAltEditTag": "Tag (tag1text)",
        "CreateDemoAltEditTagHint": "Affiché sur le player droit des cas d’usage via ?tag1text=…",
        "CreateDemoAltEditInfluencerSection": "Influenceur",
        "CreateDemoAltEditInfluencerAvatar": "URL avatar influenceur",
        "CreateDemoAltEditInfluencerAvatarHint": "URL Storage déjà existante — utilisée par le bouton influenceur (pas d’upload)",
        "CreateDemoAltEditInfluencerOpen": "Modifier nom et texte de l’avis",
        "CreateDemoAltEditInfluencerRemove": "Supprimer l’influenceur",
        "CreateDemoAltEditInfluencerRemoveHint": "Retire le bouton influenceur de la story. Les fichiers Storage sont conservés.",
        "CreateDemoAltEditInfluencerRemoved": "Option influenceur supprimée (Storage inchangé)",
        "CreateDemoAltEditInfluencerRemoveError": "Impossible de supprimer l’option influenceur",
        "CreateDemoAltEditAnimate": "Animer l’avatar",
        "CreateDemoAltEditAnimateUpdating": "Animation de l’avatar…",
        "CreateDemoAltEditAnimateSuccess": "Vidéo avatar posée sur la story (image Storage conservée)",
        "CreateDemoAltEditAnimateError": "Impossible d’animer l’avatar",
        "CreateDemoAltEditAnimateNeedImage": "L’URL avatar doit être une image (jpg, png, webp…)",
        "CreateDemoAltEditAnimateVideoHint": "Le bouton influenceur utilise cette vidéo muette ; l’URL image reste inchangée.",
        "CreateDemoAltEditMusicUrl": "URL musique d’ambiance",
        "CreateDemoAltEditMusicHint": "mp3 / wav / m4a — upload Storage restaurants/…/{storyId}/",
        "CreateDemoAltEditMusicDelete": "Supprimer la musique",
        "CreateDemoAltEditMusicDeleted": "Musique supprimée",
        "CreateDemoAltEditMusicDeleteError": "Impossible de supprimer la musique",
        "CreateDemoAltEditPromoImg": "URL image promotion",
        "CreateDemoAltEditPromoDelete": "Supprimer la promo",
        "CreateDemoAltEditPromoDeleted": "Promo supprimée",
        "CreateDemoAltEditPromoDeleteError": "Impossible de supprimer la promo",
        "CreateDemoAltEditDeleting": "Suppression…",
        "CreateDemoAltEditMenuStickerTitle": "Sticker menu",
        "CreateDemoAltEditMenuStickerCenter": "Centrer sticker menu",
        "CreateDemoAltEditMenuStickerCenterHint": "Met mediasCenterXpct et mediasCenterYpct à 50",
        "CreateDemoAltEditMenuStickerCentered": "Sticker menu centré (50 / 50)",
        "CreateDemoAltEditMenuStickerCenterError": "Impossible de centrer le sticker menu",
        "CreateDemoAltEditMenuPageModeTitle": "Type de 1re page menu",
        "CreateDemoAltEditMenuPageModeRichtext": "Texte + image landscape",
        "CreateDemoAltEditMenuPageModeImage": "Image plein écran",
        "CreateDemoAltEditRichPageImg": "URL image landscape",
        "CreateDemoAltEditRichPageHint": "Met à jour la page richtext existante à l’enregistrement",
        "CreateDemoAltEditRichPageCreateHint": "L’enregistrement crée une page richtext en 1re page du menu",
        "CreateDemoAltEditRichPagePosition": "Position de l’image",
        "CreateDemoAltEditRichPagePositionTop": "Haut",
        "CreateDemoAltEditRichPagePositionBottom": "Bas",
        "CreateDemoAltEditRichPageHtmlFr": "Texte",
        "CreateDemoAltEditRichPageHtmlHint": "Gras, italique, listes…",
        "CreateDemoAltEditRichPageDelete": "Supprimer la page texte + image",
        "CreateDemoAltEditRichPageDeleted": "Page texte + image du menu supprimée",
        "CreateDemoAltEditRichPageDeleteError": "Impossible de supprimer la page texte + image",
        "CreateDemoAltEditRichPageDeleteMissing": "Aucune page richtext à supprimer",
        "CreateDemoAltEditMenuFirstPage": "URL image 1re page du menu",
        "CreateDemoAltEditMenuFirstPageHint": "Passe la 1re page du menu en type image",
        "CreateDemoAltEditMenuNoFirstPage": "Ce menu n’a pas de première page à mettre à jour",
        "CreateDemoAltEditMenuCreateFirstPage": "Pas encore de 1re page — l’enregistrement en créera une (image)",
        "CreateDemoAltEditMenuPageDelete": "Supprimer la page image",
        "CreateDemoAltEditMenuPageDeleted": "Page image du menu supprimée",
        "CreateDemoAltEditMenuPageDeleteError": "Impossible de supprimer la page image du menu",
        "CreateDemoAltEditMenuDeleteNotImage": "Seule une 1re page de type image peut être supprimée ici",
        "CreateDemoAltEditMenuMissing": "Aucun menu lié à cette alternative",
        "CreateDemoAltEditInsideTitle": "Sticker inside",
        "CreateDemoAltEditInsideEmpty": "Aucun média inside pour l’instant",
        "CreateDemoAltEditInsideAdd": "Ajouter un média inside",
        "CreateDemoAltEditInsideFromIg": "Ajouter depuis Instagram",
        "CreateDemoAltEditInsideFromIgTitle": "Média inside depuis Instagram",
        "CreateDemoAltEditInsideFromIgHint": "Colle un lien de partage post/reel. La vidéo est téléchargée via Playwright et ajoutée en média inside (sans extraction musique).",
        "CreateDemoAltEditInsideFromIgSuccess": "Vidéo Instagram ajoutée en média inside",
        "CreateDemoAltEditInsideMax": "Maximum 2 médias inside",
        "CreateDemoAltEditInsideRemoveError": "Impossible de supprimer le média inside",
        "CreateDemoChooseFile": "Choisir un fichier",
        "CreateDemoChooseFileHint": "Upload vers Storage (story ou dossier demos/)",
        "CreateDemoFileNeedStoryOrPage": "Renseigne un story ID ou un nom de page avant d’uploader un fichier",
        "CreateDemoContentFormat": "Format de contenu",
        "CreateDemoFormatFeed": "Feed",
        "CreateDemoFormatReel": "Reel",
        "CreateDemoMediaType": "Type de média",
        "CreateDemoMediaVideo": "Vidéo",
        "CreateDemoMediaImage": "Image",
        "CreateDemoDownloadFromIg": "Télécharger depuis IG",
        "CreateDemoDownloadFromIgUpdating": "Téléchargement vidéo Instagram…",
        "CreateDemoDownloadFromIgTitle": "Télécharger une vidéo depuis Instagram",
        "CreateDemoDownloadFromIgUrlLabel": "URL de partage Instagram (post / reel)",
        "CreateDemoDownloadFromIgUrlPlaceholder": "https://www.instagram.com/reel/… ou /p/…",
        "CreateDemoDownloadFromIgHint": "Le nom de page est requis. Si un story ID est renseigné, la vidéo est aussi stockée en storefront et l’extraction musique démarre.",
        "CreateDemoDownloadFromIgNeedPageName": "Le nom de page est requis avant le téléchargement Instagram",
        "CreateDemoDownloadFromIgNeedUrl": "Saisissez une URL de partage Instagram valide",
        "CreateDemoDownloadFromIgSuccess": "Vidéo Instagram téléchargée vers Storage",
        "CreateDemoDownloadFromIgSuccessWithMusic": "Vidéo Instagram téléchargée — extraction musique lancée",
        "CreateDemoDownloadFromIgError": "Impossible de télécharger la vidéo Instagram",
        "CreateDemoDownloadFromIgConfirm": "Télécharger",
        "CreateDemoMediaUrl": "URL du média (vidéo ou image)",
        "CreateDemoFillMediaFromStory": "Reprendre le média de la story",
        "CreateDemoFillMediaFromStoryUpdating": "Chargement du média story…",
        "CreateDemoFillMediaFromStorySuccess": "mediaUrl / mediaType repris depuis la story",
        "CreateDemoFillMediaFromStoryError": "Impossible de reprendre le média de la story",
        "CreateDemoFillMediaFromStoryEmpty": "Cette story n’a ni videoRef ni imageRef",
        "CreateDemoWidth": "Largeur",
        "CreateDemoHeight": "Hauteur",
        "CreateDemoAdText": "Texte de l’annonce",
        "CreateDemoCtaText": "Texte CTA",
        "CreateDemoCtaLink": "Lien CTA",
        "CreateDemoDlIgProfileSc": "DL SC Profil IG",
        "CreateDemoDlIgProfileScUpdating": "Capture du profil Instagram…",
        "CreateDemoDlIgProfileScSuccess": "Screenshot du profil Instagram enregistré",
        "CreateDemoDlIgProfileScError": "Impossible de capturer le profil Instagram",
        "CreateDemoDlIgProfileScNeedName": "Le nom de page est requis",
        "CreateDemoDlIgProfileScNeedUrl": "Le lien CTA doit pointer vers Instagram",
        "CreateDemoDlGoogleReserveSc": "DL SC Réserver Google",
        "CreateDemoDlGoogleReserveScUpdating": "Capture Réserver avec Google…",
        "CreateDemoDlGoogleReserveScSuccess": "Screenshot Réserver avec Google enregistré",
        "CreateDemoDlGoogleReserveScError": "Impossible de capturer la page Réserver avec Google",
        "CreateDemoDlGoogleReserveScNeedName": "Le nom de page est requis",
        "CreateDemoDlGoogleReserveScNeedUrl": "Le lien CTA doit être une URL Réserver avec Google",
        "CreateDemoDlWebCtaSc": "DL SC Site web",
        "CreateDemoDlWebCtaScUpdating": "Capture du site web…",
        "CreateDemoDlWebCtaScSuccess": "Screenshot du site web enregistré",
        "CreateDemoDlWebCtaScError": "Impossible de capturer le site web",
        "CreateDemoDlWebCtaScNeedName": "Le nom de page est requis",
        "CreateDemoDlWebCtaScNeedUrl": "Le lien CTA doit être une URL web (hors Instagram et Réserver avec Google)",
        "CreateDemoSave": "Enregistrer la démo",
        "CreateDemoUpdate": "Mettre à jour",
        "CreateDemoSaving": "Enregistrement…",
        "CreateDemoMirroring": "Téléchargement des médias vers Storage…",
        "CreateDemoMirrorError": "Impossible de copier les médias vers Storage",
        "CreateDemoSaved": "Démo créée",
        "CreateDemoUpdated": "Démo mise à jour",
        "CreateDemoSaveError": "Impossible d’enregistrer la démo",
        "CreateDemoDelete": "Supprimer",
        "CreateDemoDeleting": "Suppression…",
        "CreateDemoDeleted": "Démo supprimée",
        "CreateDemoDeleteError": "Impossible de supprimer la démo",
        "CreateDemoDeleteTitle": "Supprimer la démo",
        "CreateDemoDeleteConfirm": "Supprimer la démo « {{pageName}} » ? Cette action est irréversible.",
        "CreateDemoPageNameRequired": "Le nom de page est requis",
        "CreateDemoMediaRequired": "L’URL du média est requise",
        "CreateDemoStoryIdRequired": "Le story ID est requis",
        "CreateDemoCreateStoryButton": "Créer/MAJ story",
        "CreateDemoUpdateStoryButton": "MAJ Story",
        "CreateDemoMenuId": "Menu ID",
        "CreateDemoMenuIdRequired": "Le menu ID est requis",
        "CreateDemoDisableDetailWithImg": "Désactiver le détail des plats avec image (disableDetailWithImg)",
        "CreateDemoDisableDetailWithImgSaving": "Mise à jour du menu…",
        "CreateDemoDisableDetailWithImgEnabled": "Menu mis à jour : détail désactivé pour les images",
        "CreateDemoDisableDetailWithImgDisabled": "Menu mis à jour : détail réactivé pour les images",
        "CreateDemoDisableDetailWithImgError": "Impossible de mettre à jour disableDetailWithImg sur le menu",
        "CreateDemoUpdateStoryUpdating": "Mise à jour…",
        "CreateDemoUpdateStorySuccess": "Story mise à jour (menu + restaurants)",
        "CreateDemoUpdateStoryError": "Impossible de mettre à jour la story",
        "CreateDemoUpdateStoryNotFound": "Ce story ID n’existe pas",
        "CreateDemoPageAvatarRequired": "L’URL de l’avatar de page est requise",
        "CreateDemoUpdateColorsButton": "MAJ Couleurs depuis Avatar",
        "CreateDemoUpdateColorsUpdating": "Détection des couleurs…",
        "CreateDemoUpdateColorsSuccess": "Couleurs de la story mises à jour",
        "CreateDemoUpdateColorsError": "Impossible de mettre à jour les couleurs",
        "CreateDemoColorPrimary": "Primaire",
        "CreateDemoColorSecondary": "Secondaire",
        "CreateDemoColorMenu": "Menu",
        "CreateDemoManualColorHint": "Cliquez une pastille pour modifier une couleur manuellement",
        "CreateDemoManualColorSuccess": "Couleur enregistrée",
        "CreateDemoManualColorError": "Impossible d’enregistrer la couleur",
        "CreateDemoUpdateWebColorsButton": "MAJ Couleur depuis web",
        "CreateDemoUpdateWebColorsUpdating": "Détection des couleurs web…",
        "CreateDemoUpdateWebColorsSuccess": "Couleurs mises à jour depuis le site",
        "CreateDemoUpdateWebColorsError": "Impossible de détecter les couleurs du site",
        "CreateDemoUpdateWebColorsNoWebsite": "Cette story n’a pas d’URL de site web",
        "CreateDemoUpdateMenuColorsButton": "MAJ couleur depuis menu",
        "CreateDemoUpdateMenuColorsUpdating": "Mise à jour de menuColor…",
        "CreateDemoUpdateMenuColorsSuccess": "Couleurs mises à jour depuis le menu (titre + fond)",
        "CreateDemoUpdateMenuColorsError": "Impossible de mettre à jour menuColor depuis le menu",
        "CreateDemoUpdateMenuColorsNoMenu": "Menu introuvable",
        "CreateDemoUpdateMenuColorsNoTitle": "Ce menu n’a pas de couleur de titre",
        "CreateDemoUpdateMenuColorsNoBackground": "Ce menu n’a pas de couleur de fond",
        "CreateDemoCreateStoryTitle": "Créer/MAJ story",
        "CreateDemoCreateStoryRestaurant": "Restaurant en France",
        "CreateDemoCreateStoryCreating": "En cours…",
        "CreateDemoCreateStoryCreated": "Story créée",
        "CreateDemoInfluencerTextFailed": "Story créée, mais les textes influenceur n’ont pas pu être générés — réenregistre la démo pour réessayer",
        "CreateDemoCreateStoryError": "Impossible de créer la story",
        "CreateDemoCreateStoryExists": "Ce story ID existe déjà",
        "CreateDemoCreateStoryAliasInvalid": "Story ID : lettres, chiffres, - et _ uniquement",
        "CreateDemoCreateStoryAliasTaken": "Ce story ID est déjà utilisé comme alias sur une autre story",
        "CreateDemoCreateStoryRestaurantRequired": "Sélectionnez un restaurant",
        "CreateDemoCreateStoryIdInvalid": "Le story ID ne peut pas contenir « / »",
        "CreateDemoAddChainRestaurant": "Ajouter un restaurant de chaîne",
        "CreateDemoChainRestaurant": "Restaurant de la chaîne en France",
        "CreateDemoCreateStoryChainSame": "Choisissez un autre restaurant pour la chaîne",
        "CreateDemoCreateStoryChainName": "Nom de la chaîne",
        "CreateDemoCreateStoryChainNameHint": "Utilisé comme nom affiché de la story (posName)",
        "CreateDemoCreateStoryChainNameRequired": "Indiquez le nom de la chaîne",
        "CreateDemoCreateStoryChainAddress": "Ligne d'adresse de la chaîne",
        "CreateDemoCreateStoryChainAddressHint": "Affichée sur la story (ex. couverture nationale)",
        "CreateDemoCreateStoryChainAddressLoading": "Génération de l'adresse…",
        "CreateDemoMediaTypeInvalid": "Le type de média doit être video ou image",
        "CreateDemoFormatInvalid": "Le format doit être feed ou reel",
        "CreateDemoAdminOnly": "Réservé aux admins",
        "DemoFeedLoading": "Chargement de la démo…",
        "DemoFeedNotFound": "Aucune démo trouvée pour « {{pageName}} »",
        "DemoFeedLoadError": "Impossible de charger la démo",
        "DemoFeedAllowScrap": "Voir votre démo pour <bold>{{pageName}}</bold> ?",
        "DemoFeedAllowScrapCta": "Cliquez ici !",
        "DemoFeedLearnMore": "En savoir plus",
        "DemoFeedUseCases": "Cas d'usage",
        "DemoFeedTalkToUs": "Parlons-en",
        "UseCasesBack": "← Retour",
        "UseCasesLeftCaption": "Votre Social Ad Meta",
        "UseCasesRightCaption": "Après le clic CTA",
        "UseCasesLoading": "Chargement des use cases…",
        "UseCasesNoDemo": "Aucune démo pour « {{pageName}} »",
        "UseCasesNoneSaved": "Aucun cas d’usage enregistré pour « {{pageName}} »",
        "UseCasesEmpty": "Cas d’usage vides pour « {{pageName}} »",
        "UseCasesLoadFailed": "Impossible de charger les cas d’usage",
        "UseCasesCreativeTitleLine1": "Laissez libre cours",
        "UseCasesCreativeTitleLine2": "à votre créativité.",
        "UseCasesCreativeSubtitle": "Transformez chaque contenu en une expérience immersive unique.",
        "DemoFeedScrapConfirmTitle": "Voir ma démo {{pageName}}",
        "DemoFeedScrapConfirmText": "J'agis pour le compte de {{pageName}}.\nUn Social Ad Meta, une pincée de votre site web, un soupçon d'IA… et c'est prêt.",
        "DemoFeedScrapConfirmTextReady": "Rien à configurer. On passe à table ? 👨‍🍳",
        "DemoFeedScrapConfirmAccept": "OK",
        "DemoFeedLeftCaption": "Votre Landing Page",
        "DemoFeedPhonesOr": "OU",
        "DemoFeedPhonesOrMobile": "OU PLUTÔT",
        "DemoFeedRightCaptionPrefix": "Landing Page ",
        "DemoFeedRightCaptionPrefixMobile": "Une Landing Page ",
        "DemoFeedRightCaptionGradient": "Sociale",
        "DemoFeedRightCaptionSuffix": "",
        "DemoFeedHookTitle": "Après votre Social Ad 👉",
        "DemoFeedHookTitleMobile": "Après votre Social Ad 👇",
        "DemoFeedChatFreeTrialNote": "Essai gratuit de 30j",
        "DemoFeedPhonesCaption": "Un clic social ne devrait pas amener sur une page de texte",
        "DemoFeedViewFullscreen": "Voir en plein écran",
        "DemoFeedWebsiteShotToast": "Votre site web",
        "DemoFeedInstagramShotToast": "Ouverture de votre profil Instagram",
        "DemoFeedGoogleShotToast": "Ouverture de votre réservation Google",
        "DemoItineraryMockToast": "Ouverture de votre adresse sur Google Maps",
        "DemoDeliveryPlatformToast": "Ouverture de votre plateforme",
        "DemoClickCollectPlatformToast": "Ouverture de votre plateforme",
        "DemoOrderingPlatformToast": "Ouverture de votre plateforme",
        "DemoPhoneCallToast": "Ouverture de l'appel téléphonique",
        "DemoInstagramChatToast": "Ouverture de la messagerie Instagram",
        "BookingMockDemoToastSubtitle": "votre page de réservation existante (zenchef, thefork, etc.)",
        "XViews": " vues",
        "XUniqueViews": " vues uniques",
        "XAvgDurationTime": "visite moyenne",
        "XAvgDurationTimeList": " s de visite en moyenne",
        "Draft": "Brouillon",
        "Interest": "Intérêt : ",
        "XShares": " partages",
        "XBookingIntent": " réservations",
        "XContact": " contacts",
        "XItineraries": " itinéraires",
        "XReturns": " retours",
        "Launch": "Lancer",
        "Modify": "Modifier",
        "CopyWebLink": "Copier le lien web",
        "ChooseAFile": "Choisir un fichier",
        "FromMyCamera": "Depuis ma caméra",
        "FromMyFiles": "Depuis mes fichiers on mon appareil photo",
        "OpenMyCamera": "Ouvrir ma caméra",
        "ErrorImageFormat": "Merci de choisir un format d'image",
        "ErrorAudioFormat": "Merci de choisir un format audio",
        "LoginWithFacebookBusiness": "Me connecter avec Facebook",
        "LoginWithFacebookBusinessHelp": "Vous avez accès au compte Facebook Business du restaurant qui est connecté à son compte Instagram.",
        "LoginWithInstagram": "Me connecter avec Instagram",
        "LoginWithInstagramHelp": "Vous avez accès au compte Instagram Business du restaurant.",
        "LoginHelp": "Vous connecter avec Facebook ou par lien email vous crée automatiquement un compte UpReality si vous n'en avez pas déjà un.",
        "Login": "Me connecter",
        "BackToMyStories": "Mes Landing Pages",
        "PublishMyChanges": "Publier",
        "PublishWarning": "Vos clients pourront voir les modifications apportées à votre Landing Page Sociale, la mise à jour sera faite immédiatement.",
        "Publish": "Publier",
        "DeleteStory": "Supprimer ma landing page sociale ?",
        "DeleteStoryWarning": "Cette landing page sociale et ses statistiques seront supprimées définitivement. ",
        "DuplicateStory": "Dupliquer",
        "DuplicateStoryDialogTitle": "Dupliquer cette landing page sociale ?",
        "DuplicateStoryWarning": "Une copie de cette landing page sociale sera créée.",
        "DuplicateStoryFailed": "Impossible de dupliquer cette landing page sociale. Merci de réessayer plus tard.",
        "Delete": "Supprimer",
        "ChangeRestaurantWarning": "Changer de restaurant réinitialisera toute votre saisie, les textes et images déjà enregistrés seront perdus.",
        "FileFormatError": "Merci de choisir un autre format de fichier",
        "FileSizeError": "Merci de choisir un fichier de moins de {{size}} Mo",
        "NoMediaFound": "Aucun contenu trouvé",
        "ModifyStoryWarning": "Les changements effectués sur cette landing page sociale ne seront appliqués que lorsque vous les publierez ",
        "CreateNewStory": "Nouvelle landing page",
        "Preview": "Aperçu",
        "AbandonChanges": "Abandonner les changements",
        "Abandon": "Abandonner",
        "AbandonStoryWarning": "Les changements effectués sur cette landing page sociale seront perdus.",
        "RestartStory": "Recommencer la landing page sociale",
        "RestartStoryWarning": "Les changements effectués sur cette landing page sociale seront perdus.",
        "Restart": "Recommencer",
        "AcknowledgeAbandonChanges": "Les changements ont bien été abandonnés.",
        "AckStorySavedPerm": "Vous êtes désormais enregistré sur l'application et votre landing page sociale a été sauvegardée de manière permanente.",              
        "AckLinkCopied": "Lien copié !",
        "AckHoursThreshold": "Seuls les avis supérieurs à 4 sont affichés",
        "GoogleReviewCountSingular": "{{count}} avis",
        "GoogleReviewCountPlural": "{{count}} avis",
        "WarningDownsizeRunning": "Une optimisation de vos contenus multimédia est en cours, cela ne devrait prendre que quelques minutes.",
        "AckDisconnected": "Vous êtes maintenant déconnecté de votre compte UpReality.",
        "ErrorTitle": "Quelque chose a raté !",
        "ErrorMsg": "Si le problème persiste, merci de nous contacter.",
        "ErrorAction": "Réactualiser",
        "ChangeStyle": "Changer de style",
        "SelectFBPage": "Sélectionnez la page Facebook associée",	
        "ErrorNoFacebookPage": "Vous n'avez pas de page Facebook associée à votre compte. Veuillez-vous connecter directement depuis le compte instagram de votre restaurant.",
        "ErrorNoInstagramAccount": "Vous n'avez pas de compte Instagram associé à votre page Facebook. Veuillez-vous connecter directement depuis le compte instagram de votre restaurant.",
        "ErrorNoIGProfilePicture": "Vous n'avez pas de photo de profil Instagram. Veuillez sélectionner à la place un fichier ou un lien web.",
        "ErrorInstagramMediaDownload": "Impossible de télécharger cette vidéo Instagram. Réessayez ou choisissez un fichier sur votre appareil.",        
        "ErrorDefault": "Erreur, merci de réessayer plus tard.",
        "ErrorSaving": "Erreur lors de la sauvegarde de la configuration",
        "PreviousPage": "Page précédente",
        "NextPage": "Page suivante",
        "YourWelcomeMsg": "Mon message d'accueil",
        "YourBranding": "🎨 Mon branding",
        "YourInfos": "📄 Mes informations",
        "LinkBooking": "Configurer mes liens",
        "ConfigureBooking": "Configurer mes liens 📅",
        "Booking": "Réservation",
        "Ordering": "Commande",
        "ContactCategory": "Contact",
        "BookingOptionGoogleMaps": "Page Google Maps (défaut)",
        "BookingOptionLink": "Par lien",
        "BookingOptionLinkTooltip": "Utilisez le lien du widget de réservation si vous utilisez TheFork ou Zenchef",
        "BookingReplaceByLink": "remplacer par un lien web",
        "BookingLinkHint": "lien web de réservation",
        "BookingLinkHelp": "ne rien saisir si vous ne souhaitez pas de réservation en ligne",
        "BookingReplaceByMaps": "remplacer par la page Google Maps",
        "OrderingAddAnotherPlatform": "ajouter une plateforme",
        "OrderingAddPlatform": "Ajouter une plateforme",
        "OrderingAddDeliveryPlatform": "Ajouter une plateforme de livraison",
        "OrderingAddClickCollectPlatform": "Ajouter une plateforme de Click & Collect",
        "OrderingLinkHint": "lien web de commande",
        "OrderingTypeDelivery": "Livraison",
        "OrderingTypeClickCollect": "Click & Collect",
        "OrderClickCollectEmoji": "🛍️",
        "OrderOnDeliveryAndClickCollect": "Livraison et Click & Collect",
        "OrderOnDelivery": "Livraison",
        "OrderOnClickCollect": "Click & Collect",
        "BookingOptionPhoneOn": "Par téléphone",
        "BookingOptionPhoneOff": "Par téléphone (désactivé)",        
        "BookingPhoneHint": "votre no de téléphone",
        "BookingOptionPhoneToOff": "ne pas autoriser le contact par téléphone",
        "BookingOptionPhoneToOn": "autoriser le contact par téléphone",
        "BookingOptionEmail": "Par email",
        "BookingEmailHint": "votre adresse email de réservation",     
        "BookingOptionChat": "Par chat", 
        "ConnectInstagram": "Connecter mon profil Instagram",
        "ConnectInstagramHelp": "Vous aurez accès à vos contenus Instagram pour les utiliser dans votre landing page sociale (avatar, photo vitrine, photo plats, etc.).",        
        "IGProfileConnected": "Profil {{name}} connecté",
        "DisconnectInstagram": "déconnecter mon profil",
        "EnterEmail": "Entrez votre email pour vous connecter",
        "EnterEmailHelp": "Vous recevrez un email à l'adresse saisie avec un lien pour vous connecter sur l'app et revenir sur votre landing page sociale.",
        "EnterEmailHelp2": "Vous pourrez ensuite vous connecter à Instagram pour importer vos contenus.", 
        "EnterEmailHint": "votre adresse email",
        "EmailSent": "Email envoyé, merci de vérifier votre boîte de réception pour revenir sur l'application avec votre compte activé. Il se peut que l'email soit dans vos spams.",
        "ConnectEmailLink": "Me connecter par lien email",
        "InstantAd": "Restaurants",
        "FoodAgencies": "Agences Food",
        "SocialWebsite": "Chaîne de restaurant",
        "Pricing": "Tarifs",
        "TopbarHome": "Accueil",
        "MyAccount": "Mon compte",
        "LogOut": "Me déconnecter",
        "LogOutWarning": "Vous serez déconnecté de votre compte UpReality.",
        "ManageMyAccount": "Gérer",
        "Hero1": "Un",
        "Hero2": " landing page sociale",
        "Hero3": "pour vos restaurants",
        "Hero41" : "Après votre contenu social : page web ou format immersif ?",
        "Hero42" : "",
        "InstantAdHero1": "La",
        "InstantAdHero2": "landing page",
        "InstantAdHero3": "du réseau social.",
        "InstantAdHero41" : "Après votre Social Ad, une expérience immersive pour plus de réservations",
        "InstantAdHero42" : "",
        "FoodAgenciesHero1": "Un",
        "FoodAgenciesHero2": " landing page sociale",
        "FoodAgenciesHero3": "pour vos restaurants 🍹",
        "FoodAgenciesHero41": "Proposez à vos clients un format immersif après leurs pubs sociales",
        "FoodAgenciesHero42": "",
        "FoodAgenciesCTA": "Créer une landing page sociale",
        "InstantAdYourContentHere": "Votre contenu ici !",
        "InstantAdYourContentNotAI": "(c'est pas de l'IA)",
        "CTA": "Demander une démo",
        "InstantAdCTA": "Créer ma landing page sociale",
        "Create": "Créer avec le maker",
        "ProfileInstagramHint": "profil Instagram ou site web",        
        "ContactEmailHint": "mon email de contact", 
        "Create1ClickHelp0": "Plutôt que d'utiliser le maker, nous créons votre Landing Page Sociale depuis votre contenu web.",
        "Create1ClickHelp0InstantAd": "Plutôt que d'utiliser le maker, nous créons votre Landing Page Sociale depuis votre contenu web.",
        "Create1ClickHelp1": "Vous pouvez optionnellement nous envoyer photos, vidéos et menu par envoi WeTransfer.",
        "Create1ClickHelp2": "Landing page sociale modifiable par la suite sur demande ou manuellement via l'application",
        "MandatoryField": " obligatoire",
        "AckCreate1Click": "Votre demande a bien été prise en compte, vous recevrez votre landing page sociale sous quelques jours.",
        "SendMyContentWithWeTransfer": "Envoyer mon contenu avec WeTransfer",
        "CTA2": "Créer ma landing page sociale",
        "RestaurantChainsContactUs": "Contactez-nous",
        "CTAbottom": "Demander une démo",
        "Create1ClicBtn": "Créer en 1 clic",
        "Benefit1": "Repensez l'expérience sociale",
        "SubBenefit11": "Prolongez l'exploration",
        "SubBenefit11det": "Un format social pensé pour les restaurants",
        "SubBenefit12": "Aidez vos clients à se projeter",
        "SubBenefit12det": "Un format immersif et court pour capter l'intention",
        "SubBenefit13": "Facilitez le passage à l'action",
        "SubBenefit13det": "Un format actionnable pour déclencher la réservation",
        "InstantAdBenefit1": "Repensez l'expérience sociale",
        "InstantAdSubBenefit11": "Prolongez l'exploration",
        "InstantAdSubBenefit11det": "Un format social pensé pour les restaurants",        
        "InstantAdSubBenefit12": "Aidez vos clients à se projeter",
        "InstantAdSubBenefit12det": "Un format immersif et court pour capter l’intention",
        "InstantAdSubBenefit13": "Facilitez le passage à l’action",
        "InstantAdSubBenefit13det": "Un format actionnable pour déclencher la réservation",
        "RestaurantsBenefit1": "La planche découverte de votre restaurant",
        "RestaurantsSubBenefit11": "La vidéo du réseau social",
        "RestaurantsSubBenefit11det": "",
        "RestaurantsSubBenefit12": "Le menu et la réservation du site web",
        "RestaurantsSubBenefit12det": "",
        "RestaurantsSubBenefit13": "La note et les avis de Google Maps",
        "RestaurantsSubBenefit13det": "",
        "RestaurantsSubBenefit14": "Le chat IA pour les petites questions",
        "RestaurantsSubBenefit14det": "",
        "RestaurantsBenefit2": "Un format qui convertit davantage",
        "RestaurantsSubBenefit21": "Tout pour confirmer son envie",
        "RestaurantsSubBenefit21det": "Menu mobile et avis Google pour se décider",
        "RestaurantsSubBenefit22": "Une expérience sans fausse note",
        "RestaurantsSubBenefit22det": "Sans popup, sans menu intermédiaire, avec votre widget de réservation",
        "RestaurantsSubBenefit23": "Composez votre expérience en autonomie avec l'app",
        "RestaurantsSubBenefit23det": "ou laissez notre équipe la préparer pour vous",
        "RestaurantChainsSubBenefit23": "Pensé pour les chaînes de restaurants",
        "RestaurantChainsSubBenefit23det": "Chaque établissement dispose de son contenu dédié",
        "Benefit2": "Créez en quelques minutes",
        "SubBenefit21": "Levez le pied avec l'IA",
        "SubBenefit21det": "Chatbot intégré, reformatage du menu, aide à la saisie, traductions",
        "SubBenefit22": "Connectez votre contenu web",
        "SubBenefit22det": "Données Google Business et contenus Instagram",
        "SubBenefit23": "Créez en toute autonomie avec le maker",
        "SubBenefit23det": "On peut aussi le faire pour vous",
        "InstantAdBenefit2": "Comment créer votre landing page sociale ?",
        "InstantAdSubBenefit21": "Créez votre landing page vous-même",
        "InstantAdSubBenefit21detPrefix": "ou ",
        "InstantAdSubBenefit21detLink": "contactez-nous",
        "InstantAdSubBenefit21detSuffix": " pour que nous la fassions pour vous",
        "InstantAdSubBenefit22": "Personnalisez votre page avec vos contenus",
        "InstantAdSubBenefit22det": "synchro Google Maps, vidéo sociale, menu, widget de réservation",
        "InstantAdSubBenefit23": "Simplifiez-vous la vie avec l'IA",
        "InstantAdSubBenefit23det": "votre menu (pdf ou web) est reformaté par IA",
        "InstantAdSubBenefit24": "Publiez votre page",
        "InstantAdSubBenefit24det": "vous obtenez un lien web prêt à être utilisé",
        "InstantAdSubBenefit25": "Collez votre lien web en destination de vos publicités sociales",
        "InstantAdSubBenefit25det": "ou sur vos profils Meta, en QR code, etc.",
        "InstantAdWhoForTitle": "Pour qui ?",
        "InstantAdWhoForRestaurantsTitle": "Restaurants",
        "InstantAdWhoForRestaurantsDet": "Créez votre landing page en autonomie\nou laissez-nous la créer pour vous",
        "InstantAdWhoForChainTitle": "Chaînes",
        "InstantAdWhoForChainDet": "Avec un « Trouver mon restaurant » comme sur le site web et des pages personnalisées par restaurant",
        "InstantAdWhoForAgenciesTitle": "Agences Food",
        "InstantAdWhoForAgenciesDet": "A/B testez plusieurs versions pour trouver la plus adaptée à votre audience",
        "FoodAgenciesBenefit1": "Boostez attractivité et performance",
        "FoodAgenciesSubBenefit11": "Prolongez l'exploration sociale",
        "FoodAgenciesSubBenefit11det": "Une expérience de choix immersive et engageante",
        "FoodAgenciesSubBenefit12": "Tout pour confirmer son envie",
        "FoodAgenciesSubBenefit12det": "Menu mobile et avis Google pour se décider",
        "FoodAgenciesSubBenefit13": "Une navigation sans fausse note",
        "FoodAgenciesSubBenefit13det": "Sans popup, sans menu intermédiaire, avec votre widget de réservation",
        "FoodAgenciesBenefit2": "Augmentez votre potentiel créatif",
        "FoodAgenciesSubBenefit21": "Testez vos créas sur votre Ad, ET aussi sur sa destination",
        "FoodAgenciesSubBenefit21det": "Un format social enrichi entièrement configurable",
        "FoodAgenciesSubBenefit22": "Une nouvelle opportunité d'optimisation pour vos campagnes",
        "FoodAgenciesSubBenefit22det": "Un essai gratuit pour une place dans votre budget d'AB Test",
        "FoodAgenciesSubBenefit23": "Créez en toute autonomie avec le maker",
        "FoodAgenciesSubBenefit23det": "On peut aussi le faire pour vous",
        "CompareWebsite": "Comparez un site web mobile avec une landing page sociale UpReality",
        "CompareWebsiteInstantAd": "Comparez un site web tradi avec une Landing Page Sociale",
        "CompareWebsiteRestaurants": "Un clic social ne devrait pas amener sur une page de texte",
        "CompareFrameTraditionalWebsite": "site web tradi",
        "CompareFrameSocialWebsite": "landing page sociale",
        "CompareWebsiteClosing1": "Votre site web est pertinent sur Google,",
        "CompareWebsiteClosing2": "UpReality sur les réseaux sociaux.",
        "CompareWebsiteClosingRestaurants1": "Votre site web est pertinent sur Google,",
        "CompareWebsiteClosingRestaurants2": "UpReality sur les réseaux sociaux.",
        "HomeFloatingConversionTarget": "Taux de réservation cible : +20 %",
        "WebsiteQ1" : "Monde du texte",
        "WebsiteQ2" : "Plus textuel et long",
        "WebsiteQ3" : "La grande histoire",
        "StoryQ1" : "Monde du vivant",
        "StoryQ2" : "Vidéo et interactif",
        "StoryQ3" : "Instantanée et immersive",
        "CompareDuel1": "Univers",
        "CompareDuel2": "Contenu",
        "CompareDuel3": "Expérience",
        "SalesDeckTitle": "Les Social Ads pour restaurant aujourd'hui",
        "SalesDeckSlide1CaptionInstagram": "Feed Instagram",
        "SalesDeckSlide1CaptionTraditionalWebsite": "Site web tradi",
        "SalesDeckSlide1CaptionSocialWebsite": "Landing Page Sociale",
        "TryItPremium" : "J'essaie en premium",
        "TryItPremiumTitle" : "Essayer UpReality Premium pendant 30 jours",
        "TryItPremiumText" : "Pendant votre essai gratuit, vous avez accès notamment :",
        "TryItPremiumText1" : "au menu intégré optimisé pour le mobile,",
        "TryItPremiumText2" : "à la synchronisation automatique à votre fiche Google Business",
        "TryItPremiumText3" : " ainsi qu'à la possibilité d'avoir jusqu'à 3 landing pages sociales pour pousser plus loin vos ab tests.",
        "UpgradeTitle": "Changer de plan",
        "UpgradeButton" : "Passer à premium",
        "FAQ": "FAQ",
        "FAQ1": "FAQ 1",
        "FAQanswer1": "Réponse 1",
        "FAQ2": "FAQ 2",
        "FAQanswer2": "Réponse 2",
        "FAQ3": "FAQ 3",
        "FAQanswer3": "Réponse 3",
        "FAQ4": "FAQ 4",
        "FAQanswer4": "Réponse 4",
        "AboutUs": "À propos",
        "AboutUsText": "Jacques ...",
        "Terms": "Conditions générales",
        "FooterFollowUsLinkedIn": "Nous suivre",
        "FooterFollowUsLinkedInAria": "Suivre UpReality sur LinkedIn",
        "FooterLinkedInShort": "LinkedIn ↗",
        "FooterCopyright": "© {{year}} UpReality",
        "CGV": "Conditions de vente",
        "Privacy": "Confidentialité",
        "ConsentMessage": "Pour sublimer votre expérience, nous servons aussi des cookies faits maison.",
        "ConsentLearnMore": "En savoir plus.",
        "ConsentLess": "Réduire.",
        "ConsentDetailsTitle": "La recette de nos cookies 🍪",
        "ConsentDetailsPurpose": "🎯 À quoi ça sert : nous utilisons {{pixels}} pour observer votre visite sur cette landing page sociale, mesurer et améliorer nos publicités.",
        "ConsentDetailsData": "📊 Ce qu'on récolte : des données de navigation sur cette story (infos vues, étapes de réservation…).",
        "ConsentDetailsWho": "👩‍🍳 Qui les prépare : ce restaurant et {{controllers}}, responsables conjoints.",
        "ConsentPixelMeta": "le pixel Meta",
        "ConsentPixelTikTok": "le pixel TikTok",
        "ConsentPixelBoth": "les pixels Meta et TikTok",
        "ConsentControllerMeta": "Meta (Facebook / Instagram)",
        "ConsentControllerTikTok": "TikTok",
        "ConsentControllerBoth": "Meta (Facebook / Instagram) et TikTok",
        "ConsentDetailsChoice": "✋ Votre choix : acceptez ou refusez d'un clic, et changez d'avis quand vous voulez.",
        "ConsentRefuse": "Refuser",
        "ConsentAccept": "Accepter",
        "ConsentManage": "Gérer mes cookies 🍪",
        "ConsentCurrentAccepted": "Vous acceptez actuellement les cookies.",
        "PublicationDate": "Publié le ",
        "NotPublished": "Non publié",
        "Loading": "Chargement...",
        "ErrorAccountExistsWithDifferentCredential": "Vous vous êtes connecté précédemment par lien email, pour pouvoir vous reconnecter avec Facebook, merci de vous connecter par lien email et de vous rendre dans vos préférences pour lier votre compte Facebook à votre email.",
        "ErrorFBNotInitialized": "Merci de désactiver votre bloqueur de publicité puis de rafraichir la page pour accéder à votre contenu Instagram.",
        "ErrorFBNotInitializedAfterLogin": "Merci de désactiver votre bloqueur de publicité pour accéder à votre contenu Instagram. Après rafraichissement, vous devrez resélectionner votre landing page sociale depuis la liste, vos modifications seront bien sauvegardées",    
        "AckInstagramChat": "Vos clients peuvent désormais utiliser le chat Instagram pour vous contacter.",
        "TermsHelp": "Pour pouvoir utiliser l'application, vous devez accepter les conditions générales d'utilisation.",
        "TermsTitle": "Conditions d'utilisation",
        "TermsText1": "Je reconnais avoir lu et compris les ",
        "TermsText2": "conditions générales d'utilisation",
        "TermsText3": " et les accepte.",
        "ErrorEmailLinkExpired": "Le lien email a expiré, merci de vous reconnecter pour obtenir un nouveau lien email.",
        "TitleLogged": "Mes Landing Pages Sociales",
        "TitleMaker": "Editeur de landing page sociale",        
        "ContinueToInstagramTitle": "Continuer sur Instagram",
        "ContinueToInstagram": "Vous venez de vous connecter par email, nous allons maintenant vous connecter à Instagram pour vous permettre de sélectionner votre contenu.",
        "ContinueToInstagramProfile": "Vous venez de vous connecter par email, nous allons maintenant vous connecter à Instagram.",
        "HoursFromTo": "{{from}} à {{to}}",
        "InfoSwipe": "Faites glisser pour voir la suite",
        "InfoPreview": "Après chaque modification, cliquez sur le bouton 'Aperçu' pour voir le résultat.",
        "EmptyList": "Rien en cuisine !",
        "MaskedStories": "repasser premium pour afficher les {{maskedStories}} landing pages sociales masquées",
        "MaskedStoriesPlus": "repasser plus pour afficher les {{maskedStories}} landing pages sociales masquées",
        "ClosePreview": "Fermer l'aperçu",                
        "TabMaker": "Editeur",
        "TabStories": "Mes Landing Pages",
        "TabAccount": "Mon compte",
        "ManageMyAccountTitle": "Gérer mon compte",
        "MyAccountCateg": "Mon compte",
        "MyPlanCateg": "Mon plan",
        "OthersCateg": "Autres",
        "AssociateAccounts": "Associer mes comptes",
        "AssociateFacebookToEmail": "Associer mon compte Facebook à mon email",
        "AssociateEmailToFacebook": "Associer mon compte email à mon compte Facebook",
        "EmailLinkedToFacebook": "Votre compte email est désormais associé à votre compte Facebook.",
        "EmailLinkedToFacebookStatus": "Compte email connecté au compte Facebook",
        "PlanUpdating": "Votre plan se met à jour...",
        "Logging": "Connexion en cours...",
        "ErrorInstagramInAppBrowserTitle": "Cul de sac !",
        "ErrorInstagramInAppBrowserMsg": "Acceptez la popup pour revenir à l'application sur votre navigateur d'origine.",
        "ErrorInstagramInAppBrowserMsg1": "OU",
        "ErrorInstagramInAppBrowserMsg2": "Cliquez sur les paramètres en haut à droite puis \"Ouvrir dans Chrome\"",        
        "MenuAllergens": "Liste des allergènes",
        "MenuVegetarianLabel": "Végétarien",
        "MenuSignatureLabel": "Signature",
        "MenuDemoMenusTitle": "Formule {{menu}} (X €)",
        "MenuDemoMenusDesc1": "Plat + Dessert",
        "MenuDemoMenusDesc2": "Entrée + Plat + Dessert",
        "MenuDemoStarterTitle": "Entrée {{nb}}",
        "MenuDemoStarterDesc": "Composition de l'entrée {{nb}}",
        "MenuDemoStarterTitleDemo1": "Assiette de crudités (v)",
        "MenuDemoStarterDescDemo1": "Salade, tomates, concombres, haricots verts",
        "MenuDemoStarterTitleDemo2": "Salade de chèvre chaud (v)",
        "MenuDemoStarterDescDemo2": "Salade, chèvre chaud, tomates, noix",
        "MenuDemoStarterTitleDemo3": "Terrine de campagne",
        "MenuDemoStarterDescDemo3": "Fait maison, cornichons, salade",
        "MenuDemoStarterTitleDemo4": "Soupe de légumes (v)",
        "MenuDemoStarterDescDemo4": "Soupe de légumes de saison",
        "MenuDemoStarterTitleDemo5": "Moules marinières",
        "MenuDemoStarterDescDemo5": "Cuites au vin blanc, frites", 
        "MenuDemoMainCourseTitle": "Plat {{nb}}",
        "MenuDemoMainCourseDesc": "Composition du plat {{nb}}",
        "MenuDemoMainCourseTitleDemo1": "Côte de porc grillée",
        "MenuDemoMainCourseDescDemo1": "Servie avec haricots verts",
        "MenuDemoMainCourseTitleDemo2": "Poulet rôti",
        "MenuDemoMainCourseDescDemo2": "Servi avec pommes de terre",
        "MenuDemoMainCourseTitleDemo3": "Steak de chou-fleur roti (v)",
        "MenuDemoMainCourseDescDemo3": "Servi avec pommes de terre roties et salade verte",
        "MenuDemoMainCourseTitleDemo4": "Poisson du jour",
        "MenuDemoMainCourseDescDemo4": "Selon arrivage, servi avec riz",
        "MenuDemoMainCourseTitleDemo5": "Burger au fromage et bacon",
        "MenuDemoMainCourseDescDemo5": "Servi avec frites",
        "MenuDemoDessertTitle": "Dessert {{nb}}",
        "MenuDemoDessertDesc": "Composition du dessert {{nb}}",
        "MenuDemoDessertTitleDemo1": "Tarte aux framboises",
        "MenuDemoDessertDescDemo1": "Fait maison",
        "MenuDemoDessertTitleDemo2": "Crème brûlée",
        "MenuDemoDessertDescDemo2": "Fait maison",
        "MenuDemoDessertTitleDemo3": "Mousse au chocolat",
        "MenuDemoDessertDescDemo3": "Fait maison",
        "MenuDemoDessertTitleDemo4": "Salade de fruits",
        "MenuDemoDessertDescDemo4": "Fruits frais",
        "MenuDemoDessertTitleDemo5": "Glace",
        "MenuDemoDessertDescDemo5": "3 boules au choix",
        "WineDemoTitle": "Vin {{nb}}",
        "WineDemoPrices": "37.5 cl : X € - 75 cl : X €",
        "WineDemoPrices2": "12 cl : X €",
        "EndingPageDemoText": "Prix nets service compris\n\nNos plats sont préparés avec des produits frais et locaux, en collaboration avec les fermes environnantes.\n\nMoyens de paiements : titres restaurant, chèques vacances, carte bleu, etc.",
        "TransferToAnotherAccount": "Transférer vers un autre compte",
        "TransferRecipient": "Adresse email du nouveau compte",
        "TransferHint": "La landing page à transférer",
        "TransferToAnotherAccountWarning": "La landing page sociale {{name}}, publiée le {{date}} sera transférée vers le compte UpReality associé à l'adresse email saisie. Si le compte n'existe pas encore, la landing page sociale sera automatiquement affectée à sa création.",
        "TransferAction": "Transférer",
        "TransferInProgress": "{{name}} en cours de transfert vers {{email}}",    
        "SnackAcceptTransfer": "Accepter le transfert de la landing page sociale \"{{name}}\"",   
        "SnackAcceptTransferAction": "Accepter",
        "ErrorSubscriptionLimitReached": "Désolé, la limite d'inscription pour notre Beta est atteinte. Nous avons bien pris votre email et vous recontacterons dès qu'une place se libère.",
        "ErrorNoInternetConnection": "Pas de connexion internet. Veuillez vérifier votre connexion et réessayer.",
        "ChatLimitReached": "Le restaurateur est reparti en cuisine 😜 (limite de chat atteinte), rendez-vous sur le site web du restaurant !",
        "ChatLimitReachedWithLink": "Le restaurateur est reparti en cuisine 😜 (limite de chat atteinte), rendez-vous sur <link>le site web du restaurant</link> !",
        "ChatError": "Désolé, une erreur s'est produite. Veuillez réessayer.",
        "ChatPrivacy": "chat enregistré pour mieux vous servir :)",
        "ChatPlaceholder": "Poser votre question...",
        "ChatProcessing": "En cours de traitement...",
        "ChatWelcomeMessage": "À votre service ! 😊",
        "DeleteMyAccount": "Supprimer mon compte",
        "DeleteMyAccountWarning": "Votre compte et vos landing pages sociales seront supprimés définitivement.",
        "DeleteAction": "Supprimer",
        "AckAccountDeleted": "Votre compte a bien été supprimé.",
        "ErrRecentLogin": "Votre dernier login est trop ancien, nous ne pouvons pas supprimer votre compte. Merci de vous relogguer et de recliquer sur ce bouton pour supprimer définitivement votre compte.",
        "Help": "Aide",
        "ReadFAQ": "Consulter les FAQ",
        "TranslateWithGoogle": "traduire avec Google",
        "DefaultTranslation": "en français",
        "CheckMyRights": "Vérifier mes droits",
        "ReadLegals": "Lire les mentions légales",
        "Legals": "Mentions légales",
        "ReadCgus": "Lire les conditions générales",
        "ReadPrivacy": "Lire la charte de confidentialité",
        "Credits": "Crédits",
        "Others": "Autres",
        "Images": "Images",
        "Fonts": "Polices",      
        "FAQWebsiteSubstituteQuestion": "J'ai déjà un site web, pourquoi utiliser UpReality ?",
        "FAQWebsiteSubstituteAnswer": "UpReality est conçu pour être utilisé sur les réseaux sociaux, il est la version sociale de votre site web. Votre site web, plus adapté au monde du texte et de l'ordinateur de bureau, reste le plus pertinent pour des recherches depuis Google.\n\nVous pouvez utiliser UpReality à la place ou en complément de votre site web sur votre profil social. \n\nSi vous ne possédez pas de site web, UpReality peut être une alternative plus économique, actuelle et facile à mettre à jour. En effet, UpReality peut être utiliser simplement et en total autonomie par un restaurateur ou des professionnels du marketing.",
        "FAQSocialProfileRedirectQuestion": "Je redirige sur mon profil social, pourquoi utiliser UpReality ?",
        "FAQSocialProfileRedirectAnswer": "Le profil social est très bien pour la découverte et l'exploration, moins pour la synthèse des informations et le passage à l'action.\n\nSur Instagram, par exemple, on a une avalanche de boutons et d'onglets liés au réseau social (suivre, contacter, onglets de publication), un flux infini de contenu et on ne peut pas afficher le menu bien. Moins évident, dans ces conditions, de taper sur \"Réserver\".\n\nUpReality permet en revanche de synthétiser toutes les informations tout en restant dans un cadre \"social\" :",
        "FAQSocialProfileRedirectAnswerl0": "visuels des plats et de la salle",
        "FAQSocialProfileRedirectAnswerl1": "le menu au format mobile (pas un pdf)",
        "FAQSocialProfileRedirectAnswerl2": "les avis Google + un influenceur guest",
        "FAQSocialProfileRedirectAnswerAfter": "pour permettre au client de finaliser son évaluation et donc de passer plus facilement à la réservation.",
        "FAQInstantAdQuestion": "C'est quoi une Instant Ad ?",
        "FAQInstantAdAnswer": "Une Instant Ad est un format publicitaire social proposant une forme simplifiée du site web pour une expérience sans friction.\nElle prolonge la publicité in-feed par une expérience plein écran sous la forme d'une page web simplifiée (photos, vidéos, carrousels).",
        "FAQInstantAdDifferenceQuestion": "Quelle différence avec TikTok Instant Page et Meta Instant Experience ?",
        "FAQInstantAdDifferenceAnswer": "Là où TikTok Instant Page et Meta Instant Experience proposent un format web simplifié, UpReality offre une vraie expérience immersive sous la forme de la Landing Page Sociale.\nLa Landing Page Sociale se branche en lien destination de votre Social Ad et propose un temps de chargement standard pour une expérience plus attractive et engageante, en cohérence avec le contenu social.",
        "FAQEasyToUseQuestion": "Est-ce facile à utiliser ?",
        "FAQEasyToUseAnswer": "UpReality est conçu pour être utilisé par des propriétaires de restaurant et des professionnels du marketing, il est simple et intuitif. Vous pouvez créer votre landing page sociale en quelques clics et le mettre à jour instantanément.\n\nSi vous le souhaitez, on peut aussi le faire pour vous. N'hésitez pas à nous contacter.",
        "FAQSocialWebsiteVideoQuestion": "Quelle vidéo utiliser pour ma Landing Page Sociale ?",
        "FAQSocialWebsiteVideoAnswer": "Vous êtes libre du contenu à utiliser, nous vous proposons deux formats :\n\n1) Réutiliser à l'identique la vidéo de la Social Ad :\n\nC'est la solution la plus simple à mettre en place. La Landing Page s'ouvre dans la continuité de votre publicité, comme superposée à la vidéo.\n\n2) Utiliser une vidéo animée de la vitrine du restaurant\n\nL'idée ici est de proposer un contenu plus lent pour laisser place à la prise d'information.\n\n💡 Idée : une simple photo de votre vitrine peut être animée avec l'IA (clients en terrasse, mouvement des stores, végétation, lumière, etc.) pour créer un rendu vivant sans avoir à réaliser un tournage.",
        "FAQProContentsQuestion": "Puis-je utiliser des photos et vidéos que j'ai prises moi-même ou dois-je faire appel à un professionnel ?",
        "FAQProContentsAnswer": "Vous pouvez laisser libre court à votre créativité et utiliser vos propres photos et vidéos. Quelques conseils : \n",
        "FAQProContentsAnswerl0": "Prenez vos photos en portrait pour une meilleure utilisation de l'espace sur mobile.\nCentrez votre sujet, en effet les bords du haut et du bas peuvent être coupés sur les petits téléphones.",
        "FAQProContentsAnswerl1": "Priviliégiez la couleur et une lumière naturelle (ex à 11h)",
        "FAQProContentsAnswerl2": "Pour vos plats, mettez vous à la place du client à la bonne distance. La prise de vue de dessus est la plus répandue, mais vous pouvez aussi varier suivant les plats.",
        "FAQProContentsAnswerl3": "Misez sur le naturel, n'abusez pas des filtres, mais n'hésitez pas à jouer sur les contrastes et la luminosité pour faire ressortir vos photos.",
        "FAQProContentsAnswerl4": "Jouez des ustensiles qui font l'identité de votre restaurant (ex : planche en bois, verre de vin, etc.)",
        "FAQProContentsAnswerl5": "Vous pouvez également faire appel à un professionnel pour obtenir un résultat optimal.",
        "FAQGoogleDataQuestion": "D'où viennent les données de mon restaurant ?",
        "FAQGoogleDataAnswer": "Les données de votre restaurant : adresse, nom, no de téléphone, horaires, classe de prix proviennent de votre compte Google Business. Elles sont publiques et disponibles sur Google Maps et Google My Business. Si vous souhaitez les modifier, vous pouvez le faire sur Google My Business.",
        "FAQSocialNetworksQuestion": "Sur quel réseaux sociaux puis-je utiliser ma landing page sociale ?",
        "FAQSocialNetworksAnswer": "UpReality est plus spécifiquement conçu pour être utilisé sur Instagram et Facebook. \n\nAttention, UpReality ne se publie pas sur les réseaux sociaux en tant que contenu du réseau, c'est un lien web que l'on peut intégrer à différents endroits, comme le lien web de profil, la cible web d'un sticker ou d'une pub sociale, ou encore un simple lien dans un message." /* "Vous pouvez utiliser votre landing page sociale sur tous les réseaux sociaux. UpReality est plus spécifiquement conçu pour être utilisé sur Instagram, TikTok, Snapchat et Facebook. \n\nAttention, UpReality ne se publie pas sur les réseaux sociaux en tant que contenu du réseau, c'est un lien web que l'on peut intégrer à différents endroits, comme le lien web de profil, la cible web d'un sticker ou d'une pub sociale, ou encore un simple lien dans un message." */ ,
        "FAQSocialProfileQuestion": "Comment utiliser ma landing page sociale sur mon profil social ?",
        "FAQSocialProfileAnswer": "Rendez-vous sur la rubrique \"site web\" de votre profil social et collez-y le lien de votre landing page sociale. Il est possible que sur certains réseaux sociaux, vous deviez préalablement créer un compte professionnel.",
        "FAQSocialAdDestQuestion": "Comment utiliser ma Landing Page en tant que destination de publicité sociale ?",
        "FAQSocialAdDestAnswer": "Les landing pages sociales UpReality peuvent être utilisées pour des campagnes avec objectif de Trafic, Interaction ou de Conversion. Elles s'utilisent en lien d'action de votre publicité sociale à la place du site web ou du profil social.\n\nAjoutez votre numéro de pixel Meta pour recevoir directement tous les événements d'interaction sur votre Ad Manager. Des statistiques d'interaction globales sont également disponibles dans l'application sur la page de statistiques." /* "Les landing pages sociales UpReality peuvent être utilisées pour des campagnes avec objectif de Trafic, Interaction ou de Conversion. Elles s'utilisent en lien d'action de votre publicité sociale à la place du site web ou du profil social.\nAjoutez vos numéros de pixel Meta et TikTok pour recevoir directement tous les événements d'interaction sur votre Ad Manager. Des statistiques d'interaction globales sont également disponibles dans l'application sur la page de statistiques." */ ,
        "FAQWebsiteQuestion": "Comment utiliser ma landing page sociale en tant que site web ?",
        "FAQWebsiteAnswer": "Votre landing page sociale est déjà publiée en tant que site web, vous pouvez directement utiliser le lien. Nous mettrons prochainement en place un service vous permettant de brancher un nom de domaine existant ou de commander votre propre nom de domaine.\nEn attendant, vous pouvez brancher un sous-domaine que vous possédez (exemple : social.votrerestaurant.com) à l'url de votre landing page sociale à l'aide d'une redirection 301.",
        "FAQSocialAdQuestion": "Comment utiliser ma landing page sociale depuis une action sur une publicité sociale ?",
        "FAQSocialAdAnswer": "Vous pouvez utiliser votre landing page sociale en lien d'action depuis une publicité sociale sur toutes les plateformes sociales, copiez le lien de la landing page sociale à la place du site web.", 
        "FAQOriginalWaysQuestion": "Quels autres moyens originaux me proposez-vous ?",
        "FAQOriginalWaysAnswer": "Vous pouvez utiliser votre landing page sociale depuis : \n",
        "FAQOriginalWaysAnswerl0": "un QR Code (exemples d'utilisation : flyer, carte de visite, etc.).",
        "FAQOriginalWaysAnswerl1": "un sticker sur les réseaux sociaux qui le permettent comme Instagram.", 
        "FAQOriginalWaysAnswerl2": "un lien additionnel dans votre linktr.ee",
        "FAQOriginalWaysAnswerl3": "un post épinglé sur votre profil facebook pour que votre landing page sociale soit toujours visible en haut du fil",
        "FAQOriginalWaysAnswerl4": "un post Google Business",
        "FAQOriginalWaysAnswerl5": "une campagne SMS",      
        "FAQStatsNoteQuestion": "Comment est calculée la note d'intérêt ?",        
        "FAQStatsNoteAnswer": "La note d'intérêt est calculée à partir d'une note d'engagement pour 3/5 de la note et d'une note de conversion pour 2/5.",
        "FAQStatsNoteAnswerl1": "Plus vos clients interagissent avec la landing page sociale : stickers, boutons d'action et menus d'information, plus la note d'engagement est importante.",
        "FAQStatsNoteAnswerl2": "Plus la proportion de vos clients qui ont cliqués sur le bouton \"Reserver\" est importante, plus la note de conversion est importante.",        
        "FAQStatsQuestion": "À quoi correspondent les statistiques proposées ?",
        "FAQStatsAnswerUniqueView": "1 vue unique correspond à la visite d'un utilisateur. Si celui-ci ferme son navigateur web et décide de revenir sur votre landing page sociale, cette nouvelle visite ne sera pas comptée.",
        "FAQStatsAnswerMoy": "La durée moyenne correspond à la moyenne de durée de visite sur votre landing page sociale.",
        "FAQStatsAnswerShares": "Le nombre de partages correspond au nombre de fois où un utilisateur a cliqué sur le bouton \"Partager\".",
        "FAQStatsAnswerBooks": "Le nombre d'intentions de réservation correspond au nombre de fois où un utilisateur a cliqué sur le bouton \"Réserver\".",
        "FAQStatsAnswerItinerary": "Le nombre d'itinéraires correspond au nombre de fois où un utilisateur a cliqué sur le bouton \"Itinéraire\".",
        "FAQStatsAnswerReturn": "Le nombre de retours correspond au nombre de fois où un utilisateur a fermé la page web puis est revenu sur votre landing page sociale.",
        "FAQMenuTranslatedQuestion": "Ma carte au format optimisée mobile sera-t-elle traduite pour les touristes étrangers ?",
        "FAQMenuTranslatedAnswer": "Si la carte que nous faite parvenir contient la traduction anglaise, celle-ci sera bien intégrée à votre landing page sociale. Pour les cartes sans traduction anglaise, les utilisateurs pourront obtenir une traduction automatisée directement depuis la landing page sociale.",
        "FAQNoFacebookPageQuestion": "Lorsque je cherche à ajouter un contenu avec \"Me connecter avec Facebook\", j'ai l'erreur \"Vous n'avez pas de page Facebook associée à votre compte\".",
        "FAQNoFacebookPageAnswer": "Pour utiliser cette fonctionnalité, vous devez : \n",
        "FAQNoFacebookPageAnswer0": "avoir une page Facebook pour votre restaurant et être connecté à un compte Facebook qui a un accès \"personnel\" à cette page,\n",
        "FAQNoFacebookPageAnswer1": "Click here to see how to do it",        
        "FAQNoFacebookPageAnswer2": "and an Instagram account associated with this page. \n",
        "FAQNoFacebookPageAnswer3": "Click here to see how to do it",
        "FAQVideoFormatQuestion": "Quels formats de vidéo puis-je utiliser ?",
        "FAQVideoFormatAnswer": "Les vidéos au format .mp4 et .mov (codec h.264 ou supérieur) sont compatibles.",
        "FAQVideoSizeQuestion": "Quelle est le poids maximal pour une vidéo ?",
        "FAQVideoSizeAnswer": "Le poids maximal pour une vidéo est de 50 Mo.",
        "FAQVideoRecommendedResolutionQuestion": "Quelle résolution de vidéo recommandez-vous ?",
        "FAQVideoRecommendedResolutionAnswer": "Nous vous recommandons 720 en largeur x 1280 en hauteur, le meilleur compromis entre taille et qualité. Les vidéos de résolution supérieure sont redimensionnées automatiquement vers cette résolution.",
        "FAQImageRecommendedResolutionQuestion": "Quelle résolution d'image recommandez-vous ?",
        "FAQImageRecommendedResolutionAnswer": "Nous vous recommandons d'utiliser des images au format portrait, 9/16 pour une meilleure utilisation de l'espace, au moins 720 en largeur x 1280 en hauteur pour une meilleure qualité d'image. Les images de résolution supérieure sont redimensionnées automatiquement vers cette résolution et compressées pour un poids optimal.",
        "FAQImageFormatQuestion": "Quels formats d'image puis-je utiliser ?",
        "FAQImageFormatAnswer": "Les images au format .jpg, .png, .gif, .webp, .svg et .bmp sont compatibles.", 
        "FAQImageSizeQuestion": "Quelle est le poids maximal pour une image ?",
        "FAQImageSizeAnswer": "Le poids maximal pour une image est de 10 Mo, seul l'avatar est limité à 512 ko.",
        "FAQMusicFormatQuestion": "Quels formats de fichier audio puis-je utiliser ?",
        "FAQMusicFormatAnswer": "Les fichiers audio au format .wav, .mp3 et .m4a sont compatibles.",
        "FAQMusicSizeQuestion": "Quel est le poids maximal pour un fichier audio ?",
        "FAQMusicSizeAnswer": "Le poids maximal pour un fichier audio est de 10 Mo. Les fichiers audio de bit rate supérieur à 128k et de durée supérieure à 30s seront redimensionnés automatiquement vers ces valeurs pour un poids optimal.",
        "FAQCatUprealityOffer": "Comprendre l'offre UpReality", 
        "FAQCatUseMyStory": "🔗 Utiliser ma landing page sociale",
        "FAQCatMyStory": "🧑‍🍳 Créer ma landing page sociale",
        "FAQCatVideos": "📹 Vidéos",
        "FAQCatImages": "📷 Images",
        "FAQCatMusic": "🎶 Musique d'ambiance",
        "FAQCatMyStats": "📊 Mes statistiques",
        "FAQCatMyAccount": "⚙️ Mon compte",
        "FAQCatMetaPixel": "📈 Mon Pixel Meta",
        "FAQMetaPixelEventsQuestion": "Quels événements sont envoyés au Pixel Meta ?",
        "FAQMetaPixelEventsAnswer": "Lorsqu'un Pixel Meta est configuré sur votre landing page sociale et que le visiteur a accepté le dépôt de traceurs, UpReality envoie des événements à Meta pour mesurer l'engagement et les conversions de vos publicités. Il s'agit notamment de :\n",
        "FAQMetaPixelEventsAnswerl0": "PageView — à l'ouverture de votre landing page sociale.",
        "FAQMetaPixelEventsAnswerl1": "ViewContent — lors des interactions avec votre contenu (menu, galerie, avis, carte, partage, chat, etc.).",
        "FAQMetaPixelEventsAnswerl2": "Événements personnalisés d'intention — lorsqu'un visiteur initie une réservation, une commande ou un contact (boutons « Réserver », appel téléphonique, etc.), par exemple InitiateBooking, InitiateOrder ou InitiateContact.",
        "FAQMetaPixelEventsAnswerl3": "Widget Zenchef — si vous utilisez la réservation Zenchef intégrée, les étapes du parcours (calendrier, nombre de couverts, créneau, etc.) ainsi que la confirmation de réservation (Schedule) sont bien envoyées au Pixel Meta.",
        "FAQMetaPixelEventsAnswerl4": "Widget TheFork — l'envoi automatique des événements du widget vers le Pixel Meta n'est pas natif. Si vous disposez déjà d'un webhook pour recevoir les événements du widget TheFork, contactez-nous à contact@upreality.store afin que nous puissions relayer ces événements vers votre webhook.",
        "Bio": "Product Manager mobile, j'étais fatigué de naviguer d'une page à l'autre à la recherche de la bonne expérience de restauration. J'ai décidé d'utiliser mes connaissances en technologie mobile pour fournir une expérience de découverte qui rende la recherche aussi plaisante que le moment à table.",        
        "american_restaurant": "Restaurant américain",
        "bakery": "Boulangerie",
        "bar": "Bar",
        "barbecue_restaurant": "Restaurant barbecue",
        "brazilian_restaurant": "Restaurant brésilien",
        "breakfast_restaurant" : "Restaurant breakfast",
        "brunch_restaurant": "Restaurant brunch",
        "cafe": "Café",
        "chinese_restaurant": "Restaurant chinois",
        "coffee_shop": "Coffee shop",
        "fast_food_restaurant": "Fast food",
        "french_restaurant": "Restaurant français",
        "greek_restaurant": "Restaurant grec",
        "hamburger_restaurant" : "Restaurant hamburger",
        "ice_cream_shop": "Marchand de glace",
        "indian_restaurant": "Restaurant indien",
        "indonesian_restaurant": "Restaurant indonésien",
        "italian_restaurant": "Restaurant italien",
        "japanese_restaurant": "Restaurant japonais",
        "korean_restaurant"	: "Restaurant koréen",
        "lebanese_restaurant": "Restaurant libanais",
        "meal_delivery": "Livraison de repas",
        "meal_takeaway": "Repas à emporter",
        "mediterranean_restaurant": "Restaurant mediterranéen",
        "mexican_restaurant": "Restaurant mexicain",
        "middle_eastern_restaurant": "Restaurant oriental",
        "pizza_restaurant": "Pizzeria",
        "ramen_restaurant": "Restaurant ramen",
        "restaurant": "Restaurant",
        "sandwich_shop": "Sandwicherie",
        "seafood_restaurant": "Restaurant de poissons",
        "spanish_restaurant": "Restaurant espagnol",
        "steak_house": "Steakhouse",
        "sushi_restaurant": "Restaurant sushi",
        "thai_restaurant": "Restaurant thai",
        "turkish_restaurant": "Restaurant turc",
        "vegan_restaurant": "Restaurant vegan",
        "vegetarian_restaurant": "Restaurant vegetarien",
        "vietnamese_restaurant": "Restaurant vietnamien",
        "Allergens": "Allergènes",
        "AllergensLabel": "Allergènes : ",
        "Soja": "Soja",
        "Pisces":"Poissons",
        "Egg":"Oeuf",
        "Mustard":"Moutarde",
        "Molluscs":"Mollusques",
        "Lupine":"Lupin",
        "Milk":"Lait",
        "Sesame seeds":"Graines de sésame",
        "Gluten":"Gluten",
        "Nuts":"Fruits à coque",
        "Crustaceans":"Crustacés",
        "Cereals":"Céréales",
        "Celery":"Céleri",
        "Peanuts":"Arachides",
        "Sulphurous anhydrous": "Anhydre sulfureux",                  
        "KFontaineTitle" : "Directeur Marketing et Communication chez Cardito Village Group",        
        "KFontaineTestimonial" : "UpReality me permet au quotidien de donner un aperçu de qualité de mes 3 établissements ! Tout est intuitif, l'accès à nos notes Google, nos offres, les liens de redirection. C'est un véritable game changer pour les campagnes de trafic que nous réalisons sur Meta.",
        "KFontaineTestimonialBadge": "Taux de conversion jusqu'à 8 %",
        "TestimonialsTitle": "Ils ont testé, ils ont adopté",
        "TestimonialsSubtitle": " Découvrez comment le format immersif des Landing Pages Sociales UpReality a transformé leurs campagnes publicitaires.",
        "TestimonialsSubtitleRestaurants": "Découvrez comment le format immersif de la Landing Page Sociale a transformé leurs campagnes publicitaires.",
        "TestimonialsSubtitleSocial": "Découvrez comment le format immersif des Landing Pages Sociales UpReality a transformé leurs campagnes publicitaires.",
        
        // Upgrade Dialog translations
        "ChooseYourPlan": "Changer mon plan",
        "UpgradeToPremium": "Passez à Premium pour optimiser vos campagnes Social Ads 🍹",
        "Feature": "Fonctionnalité",        
        "Premium": "Premium",
        "PremiumPlus": "Premium Plus",
        "Trial" : "Essai gratuit",
                "PremiumPrice": "0,04 € HT / visite",
        "PremiumPriceVAT": "Prix HT",
        "PremiumPriceTooltip": "Mécanisme anti-fraude pour éviter les abus",
        "UpgradeNow": "Passer à Premium",
        "UpgradeNowPlus": "Passer à Plus",
        "TakePremiumAgain": "Reprendre Premium",
        "StayPremium": "Rester Premium",    
        "TakePremiumPlusAgain": "Reprendre Plus",
        "StayPremiumPlus": "Rester Plus",           
        "Downgrade": "Passer à gratuit",
        "ChangePlan": "Changer de plan",
        "StripePortal": "Mes infos de paiement",
        "StayFree": "Rester gratuit",
        "ContinueMyTry": "Continuer l'essai",
        "MenuOptimized": "Menu Optimisé (avec mises à jour)",
        "GoogleReviews": "Note et avis Google",
        "GoogleSync": "Synchronisation Google Business",
        "GoogleSyncDesc": "Note, avis, horaires, etc.",
        "MaxStories": "20 landing pages pour AB tester",   
        "MaxRestaurants": "Limite de restaurants",
        "MaxRestaurantsFree": "1",
        "MaxRestaurantsPremium": "10",
        "MaxRestaurantsPremiumPlus": "50",
        "AckUpgraded": "Vous êtes désormais sur le plan Premium.",  
        "AckUpgradedPlus": "Vous êtes désormais sur le plan Premium Plus.",  
        "AckDowngraded": "Votre abonnement premium a bien été annulé, vous continuez à en bénéficier pour le mois.",
        "MyPlan": "Mon plan actuel",
        "Until": " (jusqu'au {{date}})",
        "Admin" : "Admin",

        "lundi": "Lundi",
        "mardi": "Mardi",
        "mercredi": "Mercredi",
        "jeudi": "Jeudi",
        "vendredi": "Vendredi",
        "samedi": "Samedi",
        "dimanche": "Dimanche",
        "Open": "Ouvert",
        "Closed": "Fermé",
        "AddPeriod": "Ajouter une période",
        "SaveHours": "Enregistrer",
        "hve": "Haute Valeur Environnementale",
        "bio-coherence": "Bio Cohérence",
        "organic": "Bio Européen",
        "biodyvin": "Biodyvin",
        "demeter": "Demeter",
        "nature-progres": "Nature & Progrès",
        "avn": "Association des Vins Naturels",
        "vigneron-independant": "Vigneron Indépendant",
        "terra-vitis": "Terra Vitis",
        "bio": "Agriculture Biologique",
        "methode-nature": "Vin Méthode Nature",
        "sains": "SAINS",
        "PricingChoosePlan": "Choisissez votre plan",
        "PricingFindSolution": "Trouver la solution pour votre besoin.",
        "PricingAudience": "Pour restaurants et agences food",
        "PricingDiscovery": "Découverte",
        "PricingFree": "Gratuit",
        "PricingForever": "Pour toujours",
        "PricingDiscoveryDesc": "La version sociale de votre site web.",
        "PricingFeature1": "Sans note et avis Google",
        "PricingFeature2": "Menu fichier ou gallerie d'images",
        "PricingFeature3": "1 unique landing page sociale",
        "PricingFeature4": "Saisie depuis Google sans synchronisation",
        "PricingFeature5": "",
        "PricingStartFree": "Commencer gratuitement",
        "PricingPremium": "Premium",
        "PricingPremiumPrice": "0,04 € HT",
        "PricingPremiumSub": "/ visite",
        "PricingPremiumAnnually": "Vous ne payez que quand vous l'utilisez",
        "PricingPremiumDesc": "Optimisez vos campagnes Social Ads !",
        "PricingPremiumFeature1": "Note et avis Google intégrés",
        "PricingPremiumFeature1Desc": "",
        "PricingPremiumFeature2": "Menu Optimisé (avec mises à jour)",
        "PricingPremiumFeature2Desc": "",
        "PricingPremiumFeature3": "Jusqu'à 20 landing pages pour 10 restaurants",
        "PricingPremiumFeature3Desc": "",
        "PricingPremiumFeature4": "Synchronisation Google Business",
        "PricingPremiumFeature4Desc": "Note, avis, horaires, etc.",
        "PricingPremiumFeature5": "",
        "PricingChoosePremium": "Choisir Premium",
        "PricingTrialButton": "Essayer gratuitement (30 jours)",
        "PricingChainTitle": "Chaîne de restaurant",
        "PricingChainAudience": "Pour les chaînes de restaurants",
        "PricingChainPrice": "Sur mesure",
        "PricingChainSubtitle": "Selon vos établissements",
        "PricingChainFeature3": "Jusqu'à 20 landing pages",
        "PricingChainFeature5Quote": "« Trouver mon restaurant »",
        "PricingChainFeature5Suffix": "intégré",
        "PricingChainTrialNote": "Offre d'essai gratuite 30j (des frais de mise en place peuvent s'appliquer)",
        "InSocialAdsGivesAbout": "en Social Ads donne environs",
        "ForABudgetOf": "Un budget de",
        "Visits": "visites.",
        "ForACostOf": "Pour un coût de",
        "BudgetCalculationTooltip": "Calcul basé sur un CPM moyen de 11.66€ et un CTR de 0.84%",
        "WeAimToHelpYouEarn": ", on cible ",
        "InReservations": "de coût d'acquisition en moins",
        "ConversionRateImprovementTooltip": "Calcul basé sur une amélioration du taux de réservation de 0,5%",
        "CannotDeleteAccountWithPremium": "Vous ne pouvez pas supprimer votre compte tant que vous avez un abonnement premium.",
        "RoasCalculatorTitle": "Calculateur de ROAS",
        "RoasCalculatorParameters": "Vos paramètres publicitaires",
        "RoasCalculatorBudgetLabel": "Budget Social Ads (€)",
        "RoasCalculatorCpcLabel": "CPC - Coût par clic (€)",
        "RoasCalculatorReservationRateLabel": "Taux réservation site web (%)",
        "RoasCalculatorAvgBasketLabel": "Panier par réservation (€)",
        "RoasCalculatorCpaLabel": "CPA - Coût par acquisition (€)",
        "RoasCalculatorCurrentResult": "Un budget social ads de <strong style=\"color: #2FC4B5\">{{budget}} €</strong> génère <strong style=\"color: #2FC4B5; font-size: 1.1rem\">{{initialRevenue}} €</strong> en réservation <strong style=\"color: #2FC4B5\">(ROAS : {{roas}}:1)</strong>.",
        "RoasCalculatorCurrentResultCpa": "Un budget social ads de <strong style=\"color: #2FC4B5\">{{budget}} €</strong> génère <strong style=\"color: #2FC4B5; font-size: 1.1rem\">{{initialRevenue}} €</strong> en réservation <strong style=\"color: #2FC4B5\">(ROAS : {{roas}}:1)</strong>.",
        "RoasCalculatorWithUpReality": "Avec UpReality",
        "RoasCalculatorImprovement": "UpReality cible une amélioration du <strong>taux de réservation de 20%</strong> (par rapport à votre site web).",
        "RoasCalculatorImprovementCpa": "UpReality cible une amélioration du <strong>taux de réservation de 20%</strong> (par rapport à votre site web).",
        "RoasCalculatorImprovedResult": "Le même budget social ads génère <strong style=\"color: #2FC4B5; font-size: 1.15rem\">{{improvedRevenue}} €</strong> en réservation <strong style=\"color: #2FC4B5\">(ROAS : {{improvedRoas}}:1)</strong>, soit <strong style=\"color: #2FC4B5\">{{additionalRevenue}} € de plus</strong> pour un coût UpReality de <strong style=\"color: #2FC4B5\">{{uprealityCost}} €</strong>.",
        "CalculateMyNewRoas": "Calculer mon nouveau ROAS"
    }
  }
};

export { resources };

if (typeof window !== "undefined") {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources,
    //supportedLngs: ["en", "fr"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['navigator']
    }
  });

  const updateDocumentLang = (lng) => {
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.lang = lng || "en";
    }
  };

  // Set initial lang and keep it in sync
  updateDocumentLang(i18n.language || i18n.resolvedLanguage);
  i18n.on("languageChanged", updateDocumentLang);
}

export default i18n;